/* eslint-disable */
// @ts-nocheck
// 生成物。編集しない。元: schemas/card.schema.json（node scripts/generate-validators.ts で再生成）

function ucs2length(str) {
  let length = 0;
  for (const _ of str) length++;
  return length;
}
function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    if (Array.isArray(a)) return a.length === b.length && a.every((x, i) => equal(x, b[i]));
    const ka = Object.keys(a);
    if (ka.length !== Object.keys(b).length) return false;
    return ka.every((k) => Object.prototype.hasOwnProperty.call(b, k) && equal(a[k], b[k]));
  }
  return a !== a && b !== b;
}

export const validateContent = validate52;
const schema19 = {
  $schema: 'https://json-schema.org/draft/2020-12/schema',
  $id: 'https://class.inductor.dev/schemas/card.schema.json',
  $defs: {
    kebab: { type: 'string', pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$' },
    cardId: {
      type: 'string',
      minLength: 3,
      maxLength: 64,
      pattern: '^[a-z][a-z0-9]*(?:-[a-z0-9]+){2,}$',
    },
    markdown: { type: 'string', minLength: 1 },
    swiftCode: { type: 'string', minLength: 1, maxLength: 65536 },
    stdin: { type: 'string', maxLength: 1048576 },
    choices: {
      type: 'array',
      minItems: 2,
      maxItems: 6,
      items: { $ref: '#/$defs/markdown' },
      uniqueItems: true,
    },
    answerIndex: { type: 'integer', minimum: 0, maximum: 5 },
    opsExpr: { type: 'string', minLength: 1, maxLength: 80, pattern: '^[A-Za-z0-9_+\\-*/^(). ]+$' },
    vizKind: { enum: ['value', 'array', 'stack', 'queue', 'dict', 'set'] },
    vizState: {
      type: 'object',
      required: ['kind', 'value'],
      additionalProperties: false,
      properties: {
        kind: { $ref: '#/$defs/vizKind' },
        value: true,
        head: { type: 'integer', minimum: 0 },
        marks: { type: 'object', additionalProperties: { type: 'integer' } },
      },
    },
    base: {
      type: 'object',
      required: ['id', 'type', 'unit', 'stage', 'title', 'difficulty', 'tags', 'grading'],
      properties: {
        id: { $ref: '#/$defs/cardId' },
        type: {
          enum: [
            'predict-output',
            'fill-blank',
            'parsons',
            'choice',
            'reduce',
            'complexity-quiz',
            'write-ac',
            'viz-step',
            'memo',
          ],
        },
        unit: { $ref: '#/$defs/kebab' },
        stage: { type: 'integer', minimum: 0, maximum: 6 },
        title: { type: 'string', minLength: 1, maxLength: 60 },
        useCase: { $ref: '#/$defs/useCaseText' },
        textbook: {
          type: 'string',
          pattern:
            '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/(#[^\\s]+)?$',
        },
        difficulty: { type: 'integer', minimum: 1, maximum: 3 },
        tags: { type: 'array', maxItems: 8, uniqueItems: true, items: { $ref: '#/$defs/kebab' } },
        hints: { type: 'array', maxItems: 3, items: { $ref: '#/$defs/markdown' }, default: [] },
        explanation: { $ref: '#/$defs/markdown' },
        formerIds: { type: 'array', uniqueItems: true, items: { $ref: '#/$defs/cardId' } },
        draft: { type: 'boolean', default: false },
        order: { type: 'integer', minimum: 0, maximum: 1000000, default: 1000 },
        grading: { enum: ['client', 'server', 'client-then-server'] },
      },
    },
    predictOutput: {
      type: 'object',
      required: ['code', 'grading'],
      properties: {
        grading: { const: 'client' },
        code: { $ref: '#/$defs/swiftCode' },
        stdin: { $ref: '#/$defs/stdin' },
        outcome: { enum: ['ok', 'compile-error', 'runtime-error'], default: 'ok' },
        expected: { type: 'string' },
        choices: {
          type: 'array',
          minItems: 1,
          maxItems: 5,
          uniqueItems: true,
          items: { type: 'string' },
        },
      },
      allOf: [
        {
          if: {
            properties: { outcome: { enum: ['compile-error', 'runtime-error'] } },
            required: ['outcome'],
          },
          then: { not: { required: ['expected'] } },
          else: { required: ['expected'] },
        },
      ],
    },
    fillBlank: {
      type: 'object',
      required: ['template', 'blanks', 'grading'],
      properties: {
        grading: { enum: ['client', 'client-then-server'] },
        template: { type: 'string', minLength: 1, maxLength: 65536, pattern: '⟦[1-9]⟧' },
        blanks: {
          type: 'array',
          minItems: 1,
          maxItems: 9,
          items: {
            type: 'object',
            required: ['id', 'accept'],
            additionalProperties: false,
            properties: {
              id: { type: 'integer', minimum: 1, maximum: 9 },
              accept: {
                type: 'array',
                minItems: 1,
                uniqueItems: true,
                items: { type: 'string', minLength: 1 },
              },
              match: { enum: ['trim', 'ignore-spaces'], default: 'trim' },
              width: { type: 'integer', minimum: 1, maximum: 60 },
            },
          },
        },
        stdin: { $ref: '#/$defs/stdin' },
        expected: { type: 'string' },
      },
      if: { properties: { grading: { const: 'client-then-server' } } },
      then: { required: ['expected'] },
    },
    parsons: {
      type: 'object',
      required: ['lines', 'grading'],
      properties: {
        grading: { const: 'client' },
        lines: {
          type: 'array',
          minItems: 2,
          maxItems: 15,
          items: { type: 'string', minLength: 1 },
        },
        distractors: { type: 'array', maxItems: 5, items: { type: 'string', minLength: 1 } },
        alternatives: {
          type: 'array',
          maxItems: 10,
          items: { type: 'array', minItems: 2, items: { type: 'integer', minimum: 0 } },
        },
        stdin: { $ref: '#/$defs/stdin' },
        expected: { type: 'string' },
      },
    },
    complexityQuiz: {
      type: 'object',
      required: ['question', 'choices', 'grading'],
      properties: {
        grading: { const: 'client' },
        question: { $ref: '#/$defs/markdown' },
        code: { $ref: '#/$defs/swiftCode' },
        choices: { $ref: '#/$defs/choiceOptions' },
        multiple: { type: 'boolean', default: false },
        constraints: {
          type: 'array',
          maxItems: 4,
          items: {
            type: 'object',
            required: ['name', 'max'],
            additionalProperties: false,
            properties: {
              name: { type: 'string', pattern: '^[A-Z][A-Za-z0-9]*$' },
              min: { type: 'number' },
              max: { type: 'number', exclusiveMinimum: 0 },
            },
          },
        },
        ops: { $ref: '#/$defs/opsExpr' },
      },
      dependentRequired: { ops: ['constraints'] },
      allOf: [
        {
          if: { properties: { multiple: { const: true } }, required: ['multiple'] },
          then: {
            properties: {
              choices: {
                contains: { properties: { correct: { const: true } } },
                minContains: 1,
                items: { properties: { accepted: { const: false } } },
              },
            },
          },
          else: {
            properties: {
              choices: {
                contains: { properties: { correct: { const: true } }, required: ['correct'] },
                minContains: 1,
                maxContains: 1,
              },
            },
          },
        },
      ],
    },
    meter: {
      type: 'object',
      required: ['input', 'sizes'],
      additionalProperties: false,
      properties: {
        input: {
          type: 'object',
          required: ['kind'],
          additionalProperties: false,
          properties: {
            kind: { enum: ['n-only', 'n-and-array', 'n-and-string'] },
            valueMin: { type: 'integer' },
            valueMax: { type: 'integer' },
            alphabet: { type: 'string', minLength: 1, maxLength: 26 },
            seed: { type: 'integer', minimum: 0, maximum: 4294967295 },
          },
        },
        sizes: {
          type: 'array',
          minItems: 2,
          maxItems: 10,
          uniqueItems: true,
          items: { type: 'integer', minimum: 1, maximum: 1000000 },
        },
        ops: { $ref: '#/$defs/opsExpr' },
      },
    },
    writeAc: {
      type: 'object',
      required: ['statement', 'starter', 'solution', 'cases', 'grading'],
      properties: {
        grading: { const: 'server' },
        statement: { $ref: '#/$defs/markdown' },
        starter: { type: 'string', maxLength: 65536 },
        solution: { $ref: '#/$defs/swiftCode' },
        cases: {
          type: 'array',
          minItems: 1,
          maxItems: 10,
          items: {
            type: 'object',
            required: ['in', 'out'],
            additionalProperties: false,
            properties: {
              name: { type: 'string', maxLength: 40 },
              in: { $ref: '#/$defs/stdin' },
              out: { type: 'string' },
            },
          },
        },
        source: {
          type: 'object',
          required: ['kind', 'path'],
          additionalProperties: false,
          properties: {
            kind: { const: 'swift-classroom' },
            path: {
              type: 'string',
              pattern: '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
            },
          },
        },
        preflight: {
          type: 'object',
          required: ['question', 'choices', 'answer'],
          additionalProperties: false,
          properties: {
            question: { $ref: '#/$defs/markdown' },
            choices: { $ref: '#/$defs/choices' },
            answer: { $ref: '#/$defs/answerIndex' },
          },
        },
        meter: { $ref: '#/$defs/meter' },
      },
    },
    vizStep: {
      type: 'object',
      required: ['frames', 'checkpoints', 'grading'],
      properties: {
        grading: { const: 'client' },
        code: { $ref: '#/$defs/swiftCode' },
        stdin: { $ref: '#/$defs/stdin' },
        frames: {
          type: 'array',
          minItems: 2,
          maxItems: 200,
          items: {
            type: 'object',
            required: ['state'],
            additionalProperties: false,
            properties: {
              note: { $ref: '#/$defs/markdown' },
              ticks: { type: 'integer', minimum: 0 },
              state: {
                type: 'object',
                minProperties: 1,
                additionalProperties: { $ref: '#/$defs/vizState' },
              },
            },
          },
        },
        checkpoints: {
          type: 'array',
          minItems: 1,
          items: {
            type: 'object',
            required: ['frame', 'prompt', 'choices', 'answer'],
            additionalProperties: false,
            properties: {
              frame: { type: 'integer', minimum: 0 },
              prompt: { $ref: '#/$defs/markdown' },
              choices: { $ref: '#/$defs/choices' },
              answer: { $ref: '#/$defs/answerIndex' },
            },
          },
        },
      },
    },
    memo: {
      type: 'object',
      required: ['statement', 'recall', 'grading'],
      not: { anyOf: [{ required: ['explanation'] }, { required: ['hints'] }] },
      properties: {
        grading: { const: 'client' },
        statement: { $ref: '#/$defs/markdown', maxLength: 200 },
        snippet: { $ref: '#/$defs/swiftCode', maxLength: 2000 },
        stdin: { $ref: '#/$defs/stdin' },
        expected: { type: 'string' },
        why: { $ref: '#/$defs/markdown', maxLength: 200 },
        recall: {
          type: 'object',
          required: ['question', 'answer'],
          additionalProperties: false,
          properties: {
            question: { $ref: '#/$defs/markdown', maxLength: 200 },
            answer: { $ref: '#/$defs/markdown', maxLength: 200 },
            accept: {
              type: 'array',
              minItems: 1,
              maxItems: 10,
              uniqueItems: true,
              items: { type: 'string', minLength: 1, maxLength: 200 },
            },
            match: { enum: ['trim', 'ignore-spaces'], default: 'trim' },
          },
          dependentRequired: { match: ['accept'] },
        },
      },
      dependentRequired: { stdin: ['snippet', 'expected'], expected: ['snippet'] },
    },
    card: {
      type: 'object',
      allOf: [
        { $ref: '#/$defs/base' },
        {
          if: { properties: { type: { const: 'predict-output' } }, required: ['type'] },
          then: { $ref: '#/$defs/predictOutput' },
        },
        {
          if: { properties: { type: { const: 'fill-blank' } }, required: ['type'] },
          then: { $ref: '#/$defs/fillBlank' },
        },
        {
          if: { properties: { type: { const: 'parsons' } }, required: ['type'] },
          then: { $ref: '#/$defs/parsons' },
        },
        {
          if: { properties: { type: { const: 'choice' } }, required: ['type'] },
          then: { $ref: '#/$defs/choice' },
        },
        {
          if: { properties: { type: { const: 'reduce' } }, required: ['type'] },
          then: { $ref: '#/$defs/reduce' },
        },
        {
          if: { properties: { type: { const: 'complexity-quiz' } }, required: ['type'] },
          then: { $ref: '#/$defs/complexityQuiz' },
        },
        {
          if: { properties: { type: { const: 'write-ac' } }, required: ['type'] },
          then: { $ref: '#/$defs/writeAc' },
        },
        {
          if: { properties: { type: { const: 'viz-step' } }, required: ['type'] },
          then: { $ref: '#/$defs/vizStep' },
        },
        {
          if: { properties: { type: { const: 'memo' } }, required: ['type'] },
          then: { $ref: '#/$defs/memo' },
          else: { required: ['textbook', 'explanation'] },
        },
      ],
      unevaluatedProperties: false,
    },
    choiceOption: {
      type: 'object',
      required: ['text', 'correct'],
      additionalProperties: false,
      properties: {
        text: { $ref: '#/$defs/markdown' },
        correct: { type: 'boolean' },
        explanation: { $ref: '#/$defs/markdown' },
        accepted: { type: 'boolean', default: false },
      },
      allOf: [
        {
          if: { properties: { accepted: { const: true } }, required: ['accepted'] },
          then: { properties: { correct: { const: false } } },
        },
      ],
    },
    choiceOptions: {
      type: 'array',
      minItems: 2,
      maxItems: 6,
      items: { $ref: '#/$defs/choiceOption' },
    },
    choice: {
      type: 'object',
      required: ['question', 'choices', 'grading'],
      properties: {
        grading: { const: 'client' },
        question: { $ref: '#/$defs/markdown' },
        code: { $ref: '#/$defs/swiftCode' },
        choices: { $ref: '#/$defs/choiceOptions' },
        multiple: { type: 'boolean', default: false },
      },
      allOf: [
        {
          if: { properties: { multiple: { const: true } }, required: ['multiple'] },
          then: {
            properties: {
              choices: {
                contains: { properties: { correct: { const: true } } },
                minContains: 1,
                items: { properties: { accepted: { const: false } } },
              },
            },
          },
          else: {
            properties: {
              choices: {
                contains: { properties: { correct: { const: true } }, required: ['correct'] },
                minContains: 1,
                maxContains: 1,
              },
            },
          },
        },
      ],
    },
    technique: {
      enum: [
        'single-loop',
        'double-loop-search',
        'triple-loop-search',
        'digit-while',
        'array-count',
        'dict',
        'set',
        'stack',
        'queue',
        'cumulative-sum',
        'sort-and-binary-search',
        'sort-and-greedy',
        'two-pointers',
        'bit-full-search',
        'bfs',
        'dfs',
        'dp',
      ],
    },
    reduceOption: {
      type: 'object',
      required: ['technique', 'correct'],
      additionalProperties: false,
      properties: {
        technique: { $ref: '#/$defs/technique' },
        correct: { type: 'boolean' },
        explanation: { $ref: '#/$defs/markdown' },
        accepted: { type: 'boolean', default: false },
        note: { type: 'string', minLength: 1, maxLength: 30 },
      },
      allOf: [
        {
          if: { properties: { accepted: { const: true } }, required: ['accepted'] },
          then: { properties: { correct: { const: false } } },
        },
      ],
    },
    reduce: {
      type: 'object',
      required: ['problem', 'choices', 'reason', 'grading'],
      properties: {
        grading: { const: 'client' },
        problem: { $ref: '#/$defs/markdown' },
        constraints: {
          type: 'array',
          maxItems: 4,
          items: {
            type: 'object',
            required: ['name', 'max'],
            additionalProperties: false,
            properties: {
              name: { type: 'string', pattern: '^[A-Z][A-Za-z0-9]*$' },
              min: { type: 'number' },
              max: { type: 'number', exclusiveMinimum: 0 },
            },
          },
        },
        choices: {
          type: 'array',
          minItems: 3,
          maxItems: 6,
          items: { $ref: '#/$defs/reduceOption' },
          contains: { properties: { correct: { const: true } }, required: ['correct'] },
          minContains: 1,
          maxContains: 1,
        },
        reason: { type: 'string', minLength: 1, maxLength: 120 },
        ops: { $ref: '#/$defs/opsExpr' },
      },
      dependentRequired: { ops: ['constraints'] },
    },
    cardFile: {
      type: 'object',
      required: ['schemaVersion', 'cards'],
      additionalProperties: false,
      properties: {
        schemaVersion: { const: 1 },
        cards: { type: 'array', minItems: 1, items: { $ref: '#/$defs/card' } },
      },
    },
    useCaseText: { type: 'string', minLength: 1, maxLength: 120 },
    useCasesFile: {
      type: 'object',
      required: ['schemaVersion', 'kind', 'textbooks', 'units'],
      additionalProperties: false,
      properties: {
        schemaVersion: { const: 1 },
        kind: { const: 'use-cases' },
        textbooks: {
          type: 'object',
          propertyNames: {
            pattern: '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
          },
          additionalProperties: { $ref: '#/$defs/useCaseText' },
        },
        units: {
          type: 'object',
          propertyNames: { $ref: '#/$defs/kebab' },
          additionalProperties: { $ref: '#/$defs/useCaseText' },
        },
      },
    },
  },
  oneOf: [{ $ref: '#/$defs/cardFile' }, { $ref: '#/$defs/useCasesFile' }],
};
const schema20 = {
  type: 'object',
  required: ['schemaVersion', 'cards'],
  additionalProperties: false,
  properties: {
    schemaVersion: { const: 1 },
    cards: { type: 'array', minItems: 1, items: { $ref: '#/$defs/card' } },
  },
};
const schema21 = {
  type: 'object',
  allOf: [
    { $ref: '#/$defs/base' },
    {
      if: { properties: { type: { const: 'predict-output' } }, required: ['type'] },
      then: { $ref: '#/$defs/predictOutput' },
    },
    {
      if: { properties: { type: { const: 'fill-blank' } }, required: ['type'] },
      then: { $ref: '#/$defs/fillBlank' },
    },
    {
      if: { properties: { type: { const: 'parsons' } }, required: ['type'] },
      then: { $ref: '#/$defs/parsons' },
    },
    {
      if: { properties: { type: { const: 'choice' } }, required: ['type'] },
      then: { $ref: '#/$defs/choice' },
    },
    {
      if: { properties: { type: { const: 'reduce' } }, required: ['type'] },
      then: { $ref: '#/$defs/reduce' },
    },
    {
      if: { properties: { type: { const: 'complexity-quiz' } }, required: ['type'] },
      then: { $ref: '#/$defs/complexityQuiz' },
    },
    {
      if: { properties: { type: { const: 'write-ac' } }, required: ['type'] },
      then: { $ref: '#/$defs/writeAc' },
    },
    {
      if: { properties: { type: { const: 'viz-step' } }, required: ['type'] },
      then: { $ref: '#/$defs/vizStep' },
    },
    {
      if: { properties: { type: { const: 'memo' } }, required: ['type'] },
      then: { $ref: '#/$defs/memo' },
      else: { required: ['textbook', 'explanation'] },
    },
  ],
  unevaluatedProperties: false,
};
const schema22 = {
  type: 'object',
  required: ['id', 'type', 'unit', 'stage', 'title', 'difficulty', 'tags', 'grading'],
  properties: {
    id: { $ref: '#/$defs/cardId' },
    type: {
      enum: [
        'predict-output',
        'fill-blank',
        'parsons',
        'choice',
        'reduce',
        'complexity-quiz',
        'write-ac',
        'viz-step',
        'memo',
      ],
    },
    unit: { $ref: '#/$defs/kebab' },
    stage: { type: 'integer', minimum: 0, maximum: 6 },
    title: { type: 'string', minLength: 1, maxLength: 60 },
    useCase: { $ref: '#/$defs/useCaseText' },
    textbook: {
      type: 'string',
      pattern:
        '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/(#[^\\s]+)?$',
    },
    difficulty: { type: 'integer', minimum: 1, maximum: 3 },
    tags: { type: 'array', maxItems: 8, uniqueItems: true, items: { $ref: '#/$defs/kebab' } },
    hints: { type: 'array', maxItems: 3, items: { $ref: '#/$defs/markdown' }, default: [] },
    explanation: { $ref: '#/$defs/markdown' },
    formerIds: { type: 'array', uniqueItems: true, items: { $ref: '#/$defs/cardId' } },
    draft: { type: 'boolean', default: false },
    order: { type: 'integer', minimum: 0, maximum: 1000000, default: 1000 },
    grading: { enum: ['client', 'server', 'client-then-server'] },
  },
};
const schema23 = {
  type: 'string',
  minLength: 3,
  maxLength: 64,
  pattern: '^[a-z][a-z0-9]*(?:-[a-z0-9]+){2,}$',
};
const func1 = ucs2length;
const pattern3 = new RegExp('^[a-z][a-z0-9]*(?:-[a-z0-9]+){2,}$', 'u');
function validate56(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate56.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 64) {
        validate56.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 64 },
            message: 'must NOT have more than 64 characters',
          },
        ];
        return false;
      } else {
        if (func1(data) < 3) {
          validate56.errors = [
            {
              instancePath,
              schemaPath: '#/minLength',
              keyword: 'minLength',
              params: { limit: 3 },
              message: 'must NOT have fewer than 3 characters',
            },
          ];
          return false;
        } else {
          if (!pattern3.test(data)) {
            validate56.errors = [
              {
                instancePath,
                schemaPath: '#/pattern',
                keyword: 'pattern',
                params: { pattern: '^[a-z][a-z0-9]*(?:-[a-z0-9]+){2,}$' },
                message: 'must match pattern "' + '^[a-z][a-z0-9]*(?:-[a-z0-9]+){2,}$' + '"',
              },
            ];
            return false;
          }
        }
      }
    } else {
      validate56.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate56.errors = vErrors;
  return errors === 0;
}
validate56.evaluated = { dynamicProps: false, dynamicItems: false };
const schema24 = { type: 'string', pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$' };
const pattern4 = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$', 'u');
function validate58(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate58.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (!pattern4.test(data)) {
        validate58.errors = [
          {
            instancePath,
            schemaPath: '#/pattern',
            keyword: 'pattern',
            params: { pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$' },
            message: 'must match pattern "' + '^[a-z0-9]+(?:-[a-z0-9]+)*$' + '"',
          },
        ];
        return false;
      }
    } else {
      validate58.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate58.errors = vErrors;
  return errors === 0;
}
validate58.evaluated = { dynamicProps: false, dynamicItems: false };
const schema25 = { type: 'string', minLength: 1, maxLength: 120 };
function validate60(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate60.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 120) {
        validate60.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 120 },
            message: 'must NOT have more than 120 characters',
          },
        ];
        return false;
      } else {
        if (func1(data) < 1) {
          validate60.errors = [
            {
              instancePath,
              schemaPath: '#/minLength',
              keyword: 'minLength',
              params: { limit: 1 },
              message: 'must NOT have fewer than 1 characters',
            },
          ];
          return false;
        }
      }
    } else {
      validate60.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate60.errors = vErrors;
  return errors === 0;
}
validate60.evaluated = { dynamicProps: false, dynamicItems: false };
const schema26 = { type: 'string', minLength: 1 };
function validate63(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate63.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) < 1) {
        validate63.errors = [
          {
            instancePath,
            schemaPath: '#/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          },
        ];
        return false;
      }
    } else {
      validate63.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate63.errors = vErrors;
  return errors === 0;
}
validate63.evaluated = { dynamicProps: false, dynamicItems: false };
const func0 = equal;
const pattern5 = new RegExp(
  '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/(#[^\\s]+)?$',
  'u',
);
function validate55(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate55.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.type === undefined && (missing0 = 'type')) ||
        (data.unit === undefined && (missing0 = 'unit')) ||
        (data.stage === undefined && (missing0 = 'stage')) ||
        (data.title === undefined && (missing0 = 'title')) ||
        (data.difficulty === undefined && (missing0 = 'difficulty')) ||
        (data.tags === undefined && (missing0 = 'tags')) ||
        (data.grading === undefined && (missing0 = 'grading'))
      ) {
        validate55.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.id !== undefined) {
          const _errs1 = errors;
          if (
            !validate56(data.id, {
              instancePath: instancePath + '/id',
              parentData: data,
              parentDataProperty: 'id',
              rootData,
              dynamicAnchors,
            })
          ) {
            vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
            errors = vErrors.length;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.type !== undefined) {
            let data1 = data.type;
            const _errs2 = errors;
            if (!(
              data1 === 'predict-output' ||
              data1 === 'fill-blank' ||
              data1 === 'parsons' ||
              data1 === 'choice' ||
              data1 === 'reduce' ||
              data1 === 'complexity-quiz' ||
              data1 === 'write-ac' ||
              data1 === 'viz-step' ||
              data1 === 'memo'
            )) {
              validate55.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema22.properties.type.enum },
                  message: 'must be equal to one of the allowed values',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.unit !== undefined) {
              const _errs3 = errors;
              if (
                !validate58(data.unit, {
                  instancePath: instancePath + '/unit',
                  parentData: data,
                  parentDataProperty: 'unit',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.stage !== undefined) {
                let data3 = data.stage;
                const _errs4 = errors;
                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                  validate55.errors = [
                    {
                      instancePath: instancePath + '/stage',
                      schemaPath: '#/properties/stage/type',
                      keyword: 'type',
                      params: { type: 'integer' },
                      message: 'must be integer',
                    },
                  ];
                  return false;
                }
                if (errors === _errs4) {
                  if (typeof data3 == 'number') {
                    if (data3 > 6 || isNaN(data3)) {
                      validate55.errors = [
                        {
                          instancePath: instancePath + '/stage',
                          schemaPath: '#/properties/stage/maximum',
                          keyword: 'maximum',
                          params: { comparison: '<=', limit: 6 },
                          message: 'must be <= 6',
                        },
                      ];
                      return false;
                    } else {
                      if (data3 < 0 || isNaN(data3)) {
                        validate55.errors = [
                          {
                            instancePath: instancePath + '/stage',
                            schemaPath: '#/properties/stage/minimum',
                            keyword: 'minimum',
                            params: { comparison: '>=', limit: 0 },
                            message: 'must be >= 0',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                }
                var valid0 = _errs4 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.title !== undefined) {
                  let data4 = data.title;
                  const _errs6 = errors;
                  if (errors === _errs6) {
                    if (typeof data4 === 'string') {
                      if (func1(data4) > 60) {
                        validate55.errors = [
                          {
                            instancePath: instancePath + '/title',
                            schemaPath: '#/properties/title/maxLength',
                            keyword: 'maxLength',
                            params: { limit: 60 },
                            message: 'must NOT have more than 60 characters',
                          },
                        ];
                        return false;
                      } else {
                        if (func1(data4) < 1) {
                          validate55.errors = [
                            {
                              instancePath: instancePath + '/title',
                              schemaPath: '#/properties/title/minLength',
                              keyword: 'minLength',
                              params: { limit: 1 },
                              message: 'must NOT have fewer than 1 characters',
                            },
                          ];
                          return false;
                        }
                      }
                    } else {
                      validate55.errors = [
                        {
                          instancePath: instancePath + '/title',
                          schemaPath: '#/properties/title/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs6 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.useCase !== undefined) {
                    const _errs8 = errors;
                    if (
                      !validate60(data.useCase, {
                        instancePath: instancePath + '/useCase',
                        parentData: data,
                        parentDataProperty: 'useCase',
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs8 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.textbook !== undefined) {
                      let data6 = data.textbook;
                      const _errs9 = errors;
                      if (errors === _errs9) {
                        if (typeof data6 === 'string') {
                          if (!pattern5.test(data6)) {
                            validate55.errors = [
                              {
                                instancePath: instancePath + '/textbook',
                                schemaPath: '#/properties/textbook/pattern',
                                keyword: 'pattern',
                                params: {
                                  pattern:
                                    '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/(#[^\\s]+)?$',
                                },
                                message:
                                  'must match pattern "' +
                                  '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/(#[^\\s]+)?$' +
                                  '"',
                              },
                            ];
                            return false;
                          }
                        } else {
                          validate55.errors = [
                            {
                              instancePath: instancePath + '/textbook',
                              schemaPath: '#/properties/textbook/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs9 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.difficulty !== undefined) {
                        let data7 = data.difficulty;
                        const _errs11 = errors;
                        if (!(typeof data7 == 'number' && !(data7 % 1) && !isNaN(data7))) {
                          validate55.errors = [
                            {
                              instancePath: instancePath + '/difficulty',
                              schemaPath: '#/properties/difficulty/type',
                              keyword: 'type',
                              params: { type: 'integer' },
                              message: 'must be integer',
                            },
                          ];
                          return false;
                        }
                        if (errors === _errs11) {
                          if (typeof data7 == 'number') {
                            if (data7 > 3 || isNaN(data7)) {
                              validate55.errors = [
                                {
                                  instancePath: instancePath + '/difficulty',
                                  schemaPath: '#/properties/difficulty/maximum',
                                  keyword: 'maximum',
                                  params: { comparison: '<=', limit: 3 },
                                  message: 'must be <= 3',
                                },
                              ];
                              return false;
                            } else {
                              if (data7 < 1 || isNaN(data7)) {
                                validate55.errors = [
                                  {
                                    instancePath: instancePath + '/difficulty',
                                    schemaPath: '#/properties/difficulty/minimum',
                                    keyword: 'minimum',
                                    params: { comparison: '>=', limit: 1 },
                                    message: 'must be >= 1',
                                  },
                                ];
                                return false;
                              }
                            }
                          }
                        }
                        var valid0 = _errs11 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.tags !== undefined) {
                          let data8 = data.tags;
                          const _errs13 = errors;
                          if (errors === _errs13) {
                            if (Array.isArray(data8)) {
                              if (data8.length > 8) {
                                validate55.errors = [
                                  {
                                    instancePath: instancePath + '/tags',
                                    schemaPath: '#/properties/tags/maxItems',
                                    keyword: 'maxItems',
                                    params: { limit: 8 },
                                    message: 'must NOT have more than 8 items',
                                  },
                                ];
                                return false;
                              } else {
                                var valid1 = true;
                                const len0 = data8.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                  const _errs15 = errors;
                                  if (
                                    !validate58(data8[i0], {
                                      instancePath: instancePath + '/tags/' + i0,
                                      parentData: data8,
                                      parentDataProperty: i0,
                                      rootData,
                                      dynamicAnchors,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate58.errors
                                        : vErrors.concat(validate58.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid1 = _errs15 === errors;
                                  if (!valid1) {
                                    break;
                                  }
                                }
                                if (valid1) {
                                  let i1 = data8.length;
                                  let j0;
                                  if (i1 > 1) {
                                    outer0: for (; i1--;) {
                                      for (j0 = i1; j0--;) {
                                        if (func0(data8[i1], data8[j0])) {
                                          validate55.errors = [
                                            {
                                              instancePath: instancePath + '/tags',
                                              schemaPath: '#/properties/tags/uniqueItems',
                                              keyword: 'uniqueItems',
                                              params: { i: i1, j: j0 },
                                              message:
                                                'must NOT have duplicate items (items ## ' +
                                                j0 +
                                                ' and ' +
                                                i1 +
                                                ' are identical)',
                                            },
                                          ];
                                          return false;
                                          break outer0;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate55.errors = [
                                {
                                  instancePath: instancePath + '/tags',
                                  schemaPath: '#/properties/tags/type',
                                  keyword: 'type',
                                  params: { type: 'array' },
                                  message: 'must be array',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid0 = _errs13 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.hints !== undefined) {
                            let data10 = data.hints;
                            const _errs16 = errors;
                            if (errors === _errs16) {
                              if (Array.isArray(data10)) {
                                if (data10.length > 3) {
                                  validate55.errors = [
                                    {
                                      instancePath: instancePath + '/hints',
                                      schemaPath: '#/properties/hints/maxItems',
                                      keyword: 'maxItems',
                                      params: { limit: 3 },
                                      message: 'must NOT have more than 3 items',
                                    },
                                  ];
                                  return false;
                                } else {
                                  var valid3 = true;
                                  const len1 = data10.length;
                                  for (let i2 = 0; i2 < len1; i2++) {
                                    const _errs18 = errors;
                                    if (
                                      !validate63(data10[i2], {
                                        instancePath: instancePath + '/hints/' + i2,
                                        parentData: data10,
                                        parentDataProperty: i2,
                                        rootData,
                                        dynamicAnchors,
                                      })
                                    ) {
                                      vErrors =
                                        vErrors === null
                                          ? validate63.errors
                                          : vErrors.concat(validate63.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid3 = _errs18 === errors;
                                    if (!valid3) {
                                      break;
                                    }
                                  }
                                }
                              } else {
                                validate55.errors = [
                                  {
                                    instancePath: instancePath + '/hints',
                                    schemaPath: '#/properties/hints/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid0 = _errs16 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.explanation !== undefined) {
                              const _errs19 = errors;
                              if (
                                !validate63(data.explanation, {
                                  instancePath: instancePath + '/explanation',
                                  parentData: data,
                                  parentDataProperty: 'explanation',
                                  rootData,
                                  dynamicAnchors,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate63.errors
                                    : vErrors.concat(validate63.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs19 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.formerIds !== undefined) {
                                let data13 = data.formerIds;
                                const _errs20 = errors;
                                if (errors === _errs20) {
                                  if (Array.isArray(data13)) {
                                    var valid4 = true;
                                    const len2 = data13.length;
                                    for (let i3 = 0; i3 < len2; i3++) {
                                      const _errs22 = errors;
                                      if (
                                        !validate56(data13[i3], {
                                          instancePath: instancePath + '/formerIds/' + i3,
                                          parentData: data13,
                                          parentDataProperty: i3,
                                          rootData,
                                          dynamicAnchors,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate56.errors
                                            : vErrors.concat(validate56.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid4 = _errs22 === errors;
                                      if (!valid4) {
                                        break;
                                      }
                                    }
                                    if (valid4) {
                                      let i4 = data13.length;
                                      let j1;
                                      if (i4 > 1) {
                                        outer1: for (; i4--;) {
                                          for (j1 = i4; j1--;) {
                                            if (func0(data13[i4], data13[j1])) {
                                              validate55.errors = [
                                                {
                                                  instancePath: instancePath + '/formerIds',
                                                  schemaPath: '#/properties/formerIds/uniqueItems',
                                                  keyword: 'uniqueItems',
                                                  params: { i: i4, j: j1 },
                                                  message:
                                                    'must NOT have duplicate items (items ## ' +
                                                    j1 +
                                                    ' and ' +
                                                    i4 +
                                                    ' are identical)',
                                                },
                                              ];
                                              return false;
                                              break outer1;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    validate55.errors = [
                                      {
                                        instancePath: instancePath + '/formerIds',
                                        schemaPath: '#/properties/formerIds/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs20 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.draft !== undefined) {
                                  const _errs23 = errors;
                                  if (typeof data.draft !== 'boolean') {
                                    validate55.errors = [
                                      {
                                        instancePath: instancePath + '/draft',
                                        schemaPath: '#/properties/draft/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs23 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.order !== undefined) {
                                    let data16 = data.order;
                                    const _errs25 = errors;
                                    if (!(
                                      typeof data16 == 'number' &&
                                      !(data16 % 1) &&
                                      !isNaN(data16)
                                    )) {
                                      validate55.errors = [
                                        {
                                          instancePath: instancePath + '/order',
                                          schemaPath: '#/properties/order/type',
                                          keyword: 'type',
                                          params: { type: 'integer' },
                                          message: 'must be integer',
                                        },
                                      ];
                                      return false;
                                    }
                                    if (errors === _errs25) {
                                      if (typeof data16 == 'number') {
                                        if (data16 > 1000000 || isNaN(data16)) {
                                          validate55.errors = [
                                            {
                                              instancePath: instancePath + '/order',
                                              schemaPath: '#/properties/order/maximum',
                                              keyword: 'maximum',
                                              params: { comparison: '<=', limit: 1000000 },
                                              message: 'must be <= 1000000',
                                            },
                                          ];
                                          return false;
                                        } else {
                                          if (data16 < 0 || isNaN(data16)) {
                                            validate55.errors = [
                                              {
                                                instancePath: instancePath + '/order',
                                                schemaPath: '#/properties/order/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                      }
                                    }
                                    var valid0 = _errs25 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.grading !== undefined) {
                                      let data17 = data.grading;
                                      const _errs27 = errors;
                                      if (!(
                                        data17 === 'client' ||
                                        data17 === 'server' ||
                                        data17 === 'client-then-server'
                                      )) {
                                        validate55.errors = [
                                          {
                                            instancePath: instancePath + '/grading',
                                            schemaPath: '#/properties/grading/enum',
                                            keyword: 'enum',
                                            params: {
                                              allowedValues: schema22.properties.grading.enum,
                                            },
                                            message: 'must be equal to one of the allowed values',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs27 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate55.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate55.errors = vErrors;
  return errors === 0;
}
validate55.evaluated = {
  props: {
    id: true,
    type: true,
    unit: true,
    stage: true,
    title: true,
    useCase: true,
    textbook: true,
    difficulty: true,
    tags: true,
    hints: true,
    explanation: true,
    formerIds: true,
    draft: true,
    order: true,
    grading: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
const schema27 = {
  type: 'object',
  required: ['code', 'grading'],
  properties: {
    grading: { const: 'client' },
    code: { $ref: '#/$defs/swiftCode' },
    stdin: { $ref: '#/$defs/stdin' },
    outcome: { enum: ['ok', 'compile-error', 'runtime-error'], default: 'ok' },
    expected: { type: 'string' },
    choices: {
      type: 'array',
      minItems: 1,
      maxItems: 5,
      uniqueItems: true,
      items: { type: 'string' },
    },
  },
  allOf: [
    {
      if: {
        properties: { outcome: { enum: ['compile-error', 'runtime-error'] } },
        required: ['outcome'],
      },
      then: { not: { required: ['expected'] } },
      else: { required: ['expected'] },
    },
  ],
};
const schema28 = { type: 'string', minLength: 1, maxLength: 65536 };
function validate69(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate69.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 65536) {
        validate69.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 65536 },
            message: 'must NOT have more than 65536 characters',
          },
        ];
        return false;
      } else {
        if (func1(data) < 1) {
          validate69.errors = [
            {
              instancePath,
              schemaPath: '#/minLength',
              keyword: 'minLength',
              params: { limit: 1 },
              message: 'must NOT have fewer than 1 characters',
            },
          ];
          return false;
        }
      }
    } else {
      validate69.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate69.errors = vErrors;
  return errors === 0;
}
validate69.evaluated = { dynamicProps: false, dynamicItems: false };
const schema29 = { type: 'string', maxLength: 1048576 };
function validate71(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate71.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 1048576) {
        validate71.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 1048576 },
            message: 'must NOT have more than 1048576 characters',
          },
        ];
        return false;
      }
    } else {
      validate71.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate71.errors = vErrors;
  return errors === 0;
}
validate71.evaluated = { dynamicProps: false, dynamicItems: false };
function validate68(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate68.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs2 = errors;
  let valid1 = true;
  const _errs3 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (data.outcome === undefined && (missing0 = 'outcome')) {
      const err0 = {};
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    } else {
      if (data.outcome !== undefined) {
        let data0 = data.outcome;
        if (!(data0 === 'compile-error' || data0 === 'runtime-error')) {
          const err1 = {};
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      }
    }
  }
  var _valid0 = _errs3 === errors;
  errors = _errs2;
  if (vErrors !== null) {
    if (_errs2) {
      vErrors.length = _errs2;
    } else {
      vErrors = null;
    }
  }
  let ifClause0;
  if (_valid0) {
    const _errs5 = errors;
    const _errs6 = errors;
    const _errs7 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (data.expected === undefined && (missing1 = 'expected')) {
        const err2 = {};
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    var valid3 = _errs7 === errors;
    if (valid3) {
      validate68.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/then/not',
          keyword: 'not',
          params: {},
          message: 'must NOT be valid',
        },
      ];
      return false;
    } else {
      errors = _errs6;
      if (vErrors !== null) {
        if (_errs6) {
          vErrors.length = _errs6;
        } else {
          vErrors = null;
        }
      }
    }
    var _valid0 = _errs5 === errors;
    valid1 = _valid0;
    ifClause0 = 'then';
  } else {
    const _errs8 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing2;
      if (data.expected === undefined && (missing2 = 'expected')) {
        validate68.errors = [
          {
            instancePath,
            schemaPath: '#/allOf/0/else/required',
            keyword: 'required',
            params: { missingProperty: missing2 },
            message: "must have required property '" + missing2 + "'",
          },
        ];
        return false;
      }
    }
    var _valid0 = _errs8 === errors;
    valid1 = _valid0;
    ifClause0 = 'else';
  }
  if (!valid1) {
    const err3 = {
      instancePath,
      schemaPath: '#/allOf/0/if',
      keyword: 'if',
      params: { failingKeyword: ifClause0 },
      message: 'must match "' + ifClause0 + '" schema',
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
    validate68.errors = vErrors;
    return false;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing3;
      if (
        (data.code === undefined && (missing3 = 'code')) ||
        (data.grading === undefined && (missing3 = 'grading'))
      ) {
        validate68.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing3 },
            message: "must have required property '" + missing3 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          const _errs9 = errors;
          if ('client' !== data.grading) {
            validate68.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid4 = _errs9 === errors;
        } else {
          var valid4 = true;
        }
        if (valid4) {
          if (data.code !== undefined) {
            const _errs10 = errors;
            if (
              !validate69(data.code, {
                instancePath: instancePath + '/code',
                parentData: data,
                parentDataProperty: 'code',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
              errors = vErrors.length;
            }
            var valid4 = _errs10 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.stdin !== undefined) {
              const _errs11 = errors;
              if (
                !validate71(data.stdin, {
                  instancePath: instancePath + '/stdin',
                  parentData: data,
                  parentDataProperty: 'stdin',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                errors = vErrors.length;
              }
              var valid4 = _errs11 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.outcome !== undefined) {
                let data4 = data.outcome;
                const _errs12 = errors;
                if (!(data4 === 'ok' || data4 === 'compile-error' || data4 === 'runtime-error')) {
                  validate68.errors = [
                    {
                      instancePath: instancePath + '/outcome',
                      schemaPath: '#/properties/outcome/enum',
                      keyword: 'enum',
                      params: { allowedValues: schema27.properties.outcome.enum },
                      message: 'must be equal to one of the allowed values',
                    },
                  ];
                  return false;
                }
                var valid4 = _errs12 === errors;
              } else {
                var valid4 = true;
              }
              if (valid4) {
                if (data.expected !== undefined) {
                  const _errs13 = errors;
                  if (typeof data.expected !== 'string') {
                    validate68.errors = [
                      {
                        instancePath: instancePath + '/expected',
                        schemaPath: '#/properties/expected/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid4 = _errs13 === errors;
                } else {
                  var valid4 = true;
                }
                if (valid4) {
                  if (data.choices !== undefined) {
                    let data6 = data.choices;
                    const _errs15 = errors;
                    if (errors === _errs15) {
                      if (Array.isArray(data6)) {
                        if (data6.length > 5) {
                          validate68.errors = [
                            {
                              instancePath: instancePath + '/choices',
                              schemaPath: '#/properties/choices/maxItems',
                              keyword: 'maxItems',
                              params: { limit: 5 },
                              message: 'must NOT have more than 5 items',
                            },
                          ];
                          return false;
                        } else {
                          if (data6.length < 1) {
                            validate68.errors = [
                              {
                                instancePath: instancePath + '/choices',
                                schemaPath: '#/properties/choices/minItems',
                                keyword: 'minItems',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 items',
                              },
                            ];
                            return false;
                          } else {
                            var valid5 = true;
                            const len0 = data6.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs17 = errors;
                              if (typeof data6[i0] !== 'string') {
                                validate68.errors = [
                                  {
                                    instancePath: instancePath + '/choices/' + i0,
                                    schemaPath: '#/properties/choices/items/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid5 = _errs17 === errors;
                              if (!valid5) {
                                break;
                              }
                            }
                            if (valid5) {
                              let i1 = data6.length;
                              let j0;
                              if (i1 > 1) {
                                const indices0 = {};
                                for (; i1--;) {
                                  let item0 = data6[i1];
                                  if (typeof item0 !== 'string') {
                                    continue;
                                  }
                                  if (typeof indices0[item0] == 'number') {
                                    j0 = indices0[item0];
                                    validate68.errors = [
                                      {
                                        instancePath: instancePath + '/choices',
                                        schemaPath: '#/properties/choices/uniqueItems',
                                        keyword: 'uniqueItems',
                                        params: { i: i1, j: j0 },
                                        message:
                                          'must NOT have duplicate items (items ## ' +
                                          j0 +
                                          ' and ' +
                                          i1 +
                                          ' are identical)',
                                      },
                                    ];
                                    return false;
                                    break;
                                  }
                                  indices0[item0] = i1;
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate68.errors = [
                          {
                            instancePath: instancePath + '/choices',
                            schemaPath: '#/properties/choices/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid4 = _errs15 === errors;
                  } else {
                    var valid4 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate68.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate68.errors = vErrors;
  return errors === 0;
}
validate68.evaluated = {
  props: { grading: true, code: true, stdin: true, outcome: true, expected: true, choices: true },
  dynamicProps: false,
  dynamicItems: false,
};
const schema30 = {
  type: 'object',
  required: ['template', 'blanks', 'grading'],
  properties: {
    grading: { enum: ['client', 'client-then-server'] },
    template: { type: 'string', minLength: 1, maxLength: 65536, pattern: '⟦[1-9]⟧' },
    blanks: {
      type: 'array',
      minItems: 1,
      maxItems: 9,
      items: {
        type: 'object',
        required: ['id', 'accept'],
        additionalProperties: false,
        properties: {
          id: { type: 'integer', minimum: 1, maximum: 9 },
          accept: {
            type: 'array',
            minItems: 1,
            uniqueItems: true,
            items: { type: 'string', minLength: 1 },
          },
          match: { enum: ['trim', 'ignore-spaces'], default: 'trim' },
          width: { type: 'integer', minimum: 1, maximum: 60 },
        },
      },
    },
    stdin: { $ref: '#/$defs/stdin' },
    expected: { type: 'string' },
  },
  if: { properties: { grading: { const: 'client-then-server' } } },
  then: { required: ['expected'] },
};
const pattern6 = new RegExp('⟦[1-9]⟧', 'u');
function validate74(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate74.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs1 = errors;
  let valid0 = true;
  const _errs2 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.grading !== undefined) {
      if ('client-then-server' !== data.grading) {
        const err0 = {};
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
  }
  var _valid0 = _errs2 === errors;
  errors = _errs1;
  if (vErrors !== null) {
    if (_errs1) {
      vErrors.length = _errs1;
    } else {
      vErrors = null;
    }
  }
  if (_valid0) {
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.expected === undefined && (missing0 = 'expected')) {
        validate74.errors = [
          {
            instancePath,
            schemaPath: '#/then/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      }
    }
    var _valid0 = _errs4 === errors;
    valid0 = _valid0;
  }
  if (!valid0) {
    const err1 = {
      instancePath,
      schemaPath: '#/if',
      keyword: 'if',
      params: { failingKeyword: 'then' },
      message: 'must match "then" schema',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
    validate74.errors = vErrors;
    return false;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (
        (data.template === undefined && (missing1 = 'template')) ||
        (data.blanks === undefined && (missing1 = 'blanks')) ||
        (data.grading === undefined && (missing1 = 'grading'))
      ) {
        validate74.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing1 },
            message: "must have required property '" + missing1 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          let data1 = data.grading;
          const _errs5 = errors;
          if (!(data1 === 'client' || data1 === 'client-then-server')) {
            validate74.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/enum',
                keyword: 'enum',
                params: { allowedValues: schema30.properties.grading.enum },
                message: 'must be equal to one of the allowed values',
              },
            ];
            return false;
          }
          var valid2 = _errs5 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.template !== undefined) {
            let data2 = data.template;
            const _errs6 = errors;
            if (errors === _errs6) {
              if (typeof data2 === 'string') {
                if (func1(data2) > 65536) {
                  validate74.errors = [
                    {
                      instancePath: instancePath + '/template',
                      schemaPath: '#/properties/template/maxLength',
                      keyword: 'maxLength',
                      params: { limit: 65536 },
                      message: 'must NOT have more than 65536 characters',
                    },
                  ];
                  return false;
                } else {
                  if (func1(data2) < 1) {
                    validate74.errors = [
                      {
                        instancePath: instancePath + '/template',
                        schemaPath: '#/properties/template/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                      },
                    ];
                    return false;
                  } else {
                    if (!pattern6.test(data2)) {
                      validate74.errors = [
                        {
                          instancePath: instancePath + '/template',
                          schemaPath: '#/properties/template/pattern',
                          keyword: 'pattern',
                          params: { pattern: '⟦[1-9]⟧' },
                          message: 'must match pattern "' + '⟦[1-9]⟧' + '"',
                        },
                      ];
                      return false;
                    }
                  }
                }
              } else {
                validate74.errors = [
                  {
                    instancePath: instancePath + '/template',
                    schemaPath: '#/properties/template/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.blanks !== undefined) {
              let data3 = data.blanks;
              const _errs8 = errors;
              if (errors === _errs8) {
                if (Array.isArray(data3)) {
                  if (data3.length > 9) {
                    validate74.errors = [
                      {
                        instancePath: instancePath + '/blanks',
                        schemaPath: '#/properties/blanks/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 9 },
                        message: 'must NOT have more than 9 items',
                      },
                    ];
                    return false;
                  } else {
                    if (data3.length < 1) {
                      validate74.errors = [
                        {
                          instancePath: instancePath + '/blanks',
                          schemaPath: '#/properties/blanks/minItems',
                          keyword: 'minItems',
                          params: { limit: 1 },
                          message: 'must NOT have fewer than 1 items',
                        },
                      ];
                      return false;
                    } else {
                      var valid3 = true;
                      const len0 = data3.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data4 = data3[i0];
                        const _errs10 = errors;
                        if (errors === _errs10) {
                          if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                            let missing2;
                            if (
                              (data4.id === undefined && (missing2 = 'id')) ||
                              (data4.accept === undefined && (missing2 = 'accept'))
                            ) {
                              validate74.errors = [
                                {
                                  instancePath: instancePath + '/blanks/' + i0,
                                  schemaPath: '#/properties/blanks/items/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing2 },
                                  message: "must have required property '" + missing2 + "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs12 = errors;
                              for (const key0 in data4) {
                                if (!(
                                  key0 === 'id' ||
                                  key0 === 'accept' ||
                                  key0 === 'match' ||
                                  key0 === 'width'
                                )) {
                                  validate74.errors = [
                                    {
                                      instancePath: instancePath + '/blanks/' + i0,
                                      schemaPath: '#/properties/blanks/items/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key0 },
                                      message: 'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs12 === errors) {
                                if (data4.id !== undefined) {
                                  let data5 = data4.id;
                                  const _errs13 = errors;
                                  if (!(
                                    typeof data5 == 'number' &&
                                    !(data5 % 1) &&
                                    !isNaN(data5)
                                  )) {
                                    validate74.errors = [
                                      {
                                        instancePath: instancePath + '/blanks/' + i0 + '/id',
                                        schemaPath: '#/properties/blanks/items/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer',
                                      },
                                    ];
                                    return false;
                                  }
                                  if (errors === _errs13) {
                                    if (typeof data5 == 'number') {
                                      if (data5 > 9 || isNaN(data5)) {
                                        validate74.errors = [
                                          {
                                            instancePath: instancePath + '/blanks/' + i0 + '/id',
                                            schemaPath:
                                              '#/properties/blanks/items/properties/id/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 9 },
                                            message: 'must be <= 9',
                                          },
                                        ];
                                        return false;
                                      } else {
                                        if (data5 < 1 || isNaN(data5)) {
                                          validate74.errors = [
                                            {
                                              instancePath: instancePath + '/blanks/' + i0 + '/id',
                                              schemaPath:
                                                '#/properties/blanks/items/properties/id/minimum',
                                              keyword: 'minimum',
                                              params: { comparison: '>=', limit: 1 },
                                              message: 'must be >= 1',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                    }
                                  }
                                  var valid4 = _errs13 === errors;
                                } else {
                                  var valid4 = true;
                                }
                                if (valid4) {
                                  if (data4.accept !== undefined) {
                                    let data6 = data4.accept;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                      if (Array.isArray(data6)) {
                                        if (data6.length < 1) {
                                          validate74.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/blanks/' + i0 + '/accept',
                                              schemaPath:
                                                '#/properties/blanks/items/properties/accept/minItems',
                                              keyword: 'minItems',
                                              params: { limit: 1 },
                                              message: 'must NOT have fewer than 1 items',
                                            },
                                          ];
                                          return false;
                                        } else {
                                          var valid5 = true;
                                          const len1 = data6.length;
                                          for (let i1 = 0; i1 < len1; i1++) {
                                            let data7 = data6[i1];
                                            const _errs17 = errors;
                                            if (errors === _errs17) {
                                              if (typeof data7 === 'string') {
                                                if (func1(data7) < 1) {
                                                  validate74.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/blanks/' +
                                                        i0 +
                                                        '/accept/' +
                                                        i1,
                                                      schemaPath:
                                                        '#/properties/blanks/items/properties/accept/items/minLength',
                                                      keyword: 'minLength',
                                                      params: { limit: 1 },
                                                      message:
                                                        'must NOT have fewer than 1 characters',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              } else {
                                                validate74.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/blanks/' +
                                                      i0 +
                                                      '/accept/' +
                                                      i1,
                                                    schemaPath:
                                                      '#/properties/blanks/items/properties/accept/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                            }
                                            var valid5 = _errs17 === errors;
                                            if (!valid5) {
                                              break;
                                            }
                                          }
                                          if (valid5) {
                                            let i2 = data6.length;
                                            let j0;
                                            if (i2 > 1) {
                                              const indices0 = {};
                                              for (; i2--;) {
                                                let item0 = data6[i2];
                                                if (typeof item0 !== 'string') {
                                                  continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                  j0 = indices0[item0];
                                                  validate74.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath + '/blanks/' + i0 + '/accept',
                                                      schemaPath:
                                                        '#/properties/blanks/items/properties/accept/uniqueItems',
                                                      keyword: 'uniqueItems',
                                                      params: { i: i2, j: j0 },
                                                      message:
                                                        'must NOT have duplicate items (items ## ' +
                                                        j0 +
                                                        ' and ' +
                                                        i2 +
                                                        ' are identical)',
                                                    },
                                                  ];
                                                  return false;
                                                  break;
                                                }
                                                indices0[item0] = i2;
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        validate74.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/blanks/' + i0 + '/accept',
                                            schemaPath:
                                              '#/properties/blanks/items/properties/accept/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                    var valid4 = _errs15 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                  if (valid4) {
                                    if (data4.match !== undefined) {
                                      let data8 = data4.match;
                                      const _errs19 = errors;
                                      if (!(data8 === 'trim' || data8 === 'ignore-spaces')) {
                                        validate74.errors = [
                                          {
                                            instancePath: instancePath + '/blanks/' + i0 + '/match',
                                            schemaPath:
                                              '#/properties/blanks/items/properties/match/enum',
                                            keyword: 'enum',
                                            params: {
                                              allowedValues:
                                                schema30.properties.blanks.items.properties.match
                                                  .enum,
                                            },
                                            message: 'must be equal to one of the allowed values',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid4 = _errs19 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                    if (valid4) {
                                      if (data4.width !== undefined) {
                                        let data9 = data4.width;
                                        const _errs20 = errors;
                                        if (!(
                                          typeof data9 == 'number' &&
                                          !(data9 % 1) &&
                                          !isNaN(data9)
                                        )) {
                                          validate74.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/blanks/' + i0 + '/width',
                                              schemaPath:
                                                '#/properties/blanks/items/properties/width/type',
                                              keyword: 'type',
                                              params: { type: 'integer' },
                                              message: 'must be integer',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (errors === _errs20) {
                                          if (typeof data9 == 'number') {
                                            if (data9 > 60 || isNaN(data9)) {
                                              validate74.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/blanks/' + i0 + '/width',
                                                  schemaPath:
                                                    '#/properties/blanks/items/properties/width/maximum',
                                                  keyword: 'maximum',
                                                  params: { comparison: '<=', limit: 60 },
                                                  message: 'must be <= 60',
                                                },
                                              ];
                                              return false;
                                            } else {
                                              if (data9 < 1 || isNaN(data9)) {
                                                validate74.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath + '/blanks/' + i0 + '/width',
                                                    schemaPath:
                                                      '#/properties/blanks/items/properties/width/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 1 },
                                                    message: 'must be >= 1',
                                                  },
                                                ];
                                                return false;
                                              }
                                            }
                                          }
                                        }
                                        var valid4 = _errs20 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate74.errors = [
                              {
                                instancePath: instancePath + '/blanks/' + i0,
                                schemaPath: '#/properties/blanks/items/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid3 = _errs10 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate74.errors = [
                    {
                      instancePath: instancePath + '/blanks',
                      schemaPath: '#/properties/blanks/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid2 = _errs8 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.stdin !== undefined) {
                const _errs22 = errors;
                if (
                  !validate71(data.stdin, {
                    instancePath: instancePath + '/stdin',
                    parentData: data,
                    parentDataProperty: 'stdin',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                  errors = vErrors.length;
                }
                var valid2 = _errs22 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.expected !== undefined) {
                  const _errs23 = errors;
                  if (typeof data.expected !== 'string') {
                    validate74.errors = [
                      {
                        instancePath: instancePath + '/expected',
                        schemaPath: '#/properties/expected/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs23 === errors;
                } else {
                  var valid2 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate74.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate74.errors = vErrors;
  return errors === 0;
}
validate74.evaluated = {
  props: { grading: true, template: true, blanks: true, stdin: true, expected: true },
  dynamicProps: false,
  dynamicItems: false,
};
const schema31 = {
  type: 'object',
  required: ['lines', 'grading'],
  properties: {
    grading: { const: 'client' },
    lines: { type: 'array', minItems: 2, maxItems: 15, items: { type: 'string', minLength: 1 } },
    distractors: { type: 'array', maxItems: 5, items: { type: 'string', minLength: 1 } },
    alternatives: {
      type: 'array',
      maxItems: 10,
      items: { type: 'array', minItems: 2, items: { type: 'integer', minimum: 0 } },
    },
    stdin: { $ref: '#/$defs/stdin' },
    expected: { type: 'string' },
  },
};
function validate77(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate77.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.lines === undefined && (missing0 = 'lines')) ||
        (data.grading === undefined && (missing0 = 'grading'))
      ) {
        validate77.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          const _errs1 = errors;
          if ('client' !== data.grading) {
            validate77.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.lines !== undefined) {
            let data1 = data.lines;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data1)) {
                if (data1.length > 15) {
                  validate77.errors = [
                    {
                      instancePath: instancePath + '/lines',
                      schemaPath: '#/properties/lines/maxItems',
                      keyword: 'maxItems',
                      params: { limit: 15 },
                      message: 'must NOT have more than 15 items',
                    },
                  ];
                  return false;
                } else {
                  if (data1.length < 2) {
                    validate77.errors = [
                      {
                        instancePath: instancePath + '/lines',
                        schemaPath: '#/properties/lines/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                      },
                    ];
                    return false;
                  } else {
                    var valid1 = true;
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data2 = data1[i0];
                      const _errs4 = errors;
                      if (errors === _errs4) {
                        if (typeof data2 === 'string') {
                          if (func1(data2) < 1) {
                            validate77.errors = [
                              {
                                instancePath: instancePath + '/lines/' + i0,
                                schemaPath: '#/properties/lines/items/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                              },
                            ];
                            return false;
                          }
                        } else {
                          validate77.errors = [
                            {
                              instancePath: instancePath + '/lines/' + i0,
                              schemaPath: '#/properties/lines/items/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid1 = _errs4 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  }
                }
              } else {
                validate77.errors = [
                  {
                    instancePath: instancePath + '/lines',
                    schemaPath: '#/properties/lines/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.distractors !== undefined) {
              let data3 = data.distractors;
              const _errs6 = errors;
              if (errors === _errs6) {
                if (Array.isArray(data3)) {
                  if (data3.length > 5) {
                    validate77.errors = [
                      {
                        instancePath: instancePath + '/distractors',
                        schemaPath: '#/properties/distractors/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 5 },
                        message: 'must NOT have more than 5 items',
                      },
                    ];
                    return false;
                  } else {
                    var valid2 = true;
                    const len1 = data3.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      let data4 = data3[i1];
                      const _errs8 = errors;
                      if (errors === _errs8) {
                        if (typeof data4 === 'string') {
                          if (func1(data4) < 1) {
                            validate77.errors = [
                              {
                                instancePath: instancePath + '/distractors/' + i1,
                                schemaPath: '#/properties/distractors/items/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                              },
                            ];
                            return false;
                          }
                        } else {
                          validate77.errors = [
                            {
                              instancePath: instancePath + '/distractors/' + i1,
                              schemaPath: '#/properties/distractors/items/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid2 = _errs8 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  }
                } else {
                  validate77.errors = [
                    {
                      instancePath: instancePath + '/distractors',
                      schemaPath: '#/properties/distractors/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.alternatives !== undefined) {
                let data5 = data.alternatives;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (Array.isArray(data5)) {
                    if (data5.length > 10) {
                      validate77.errors = [
                        {
                          instancePath: instancePath + '/alternatives',
                          schemaPath: '#/properties/alternatives/maxItems',
                          keyword: 'maxItems',
                          params: { limit: 10 },
                          message: 'must NOT have more than 10 items',
                        },
                      ];
                      return false;
                    } else {
                      var valid3 = true;
                      const len2 = data5.length;
                      for (let i2 = 0; i2 < len2; i2++) {
                        let data6 = data5[i2];
                        const _errs12 = errors;
                        if (errors === _errs12) {
                          if (Array.isArray(data6)) {
                            if (data6.length < 2) {
                              validate77.errors = [
                                {
                                  instancePath: instancePath + '/alternatives/' + i2,
                                  schemaPath: '#/properties/alternatives/items/minItems',
                                  keyword: 'minItems',
                                  params: { limit: 2 },
                                  message: 'must NOT have fewer than 2 items',
                                },
                              ];
                              return false;
                            } else {
                              var valid4 = true;
                              const len3 = data6.length;
                              for (let i3 = 0; i3 < len3; i3++) {
                                let data7 = data6[i3];
                                const _errs14 = errors;
                                if (!(typeof data7 == 'number' && !(data7 % 1) && !isNaN(data7))) {
                                  validate77.errors = [
                                    {
                                      instancePath: instancePath + '/alternatives/' + i2 + '/' + i3,
                                      schemaPath: '#/properties/alternatives/items/items/type',
                                      keyword: 'type',
                                      params: { type: 'integer' },
                                      message: 'must be integer',
                                    },
                                  ];
                                  return false;
                                }
                                if (errors === _errs14) {
                                  if (typeof data7 == 'number') {
                                    if (data7 < 0 || isNaN(data7)) {
                                      validate77.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/alternatives/' + i2 + '/' + i3,
                                          schemaPath:
                                            '#/properties/alternatives/items/items/minimum',
                                          keyword: 'minimum',
                                          params: { comparison: '>=', limit: 0 },
                                          message: 'must be >= 0',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                }
                                var valid4 = _errs14 === errors;
                                if (!valid4) {
                                  break;
                                }
                              }
                            }
                          } else {
                            validate77.errors = [
                              {
                                instancePath: instancePath + '/alternatives/' + i2,
                                schemaPath: '#/properties/alternatives/items/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid3 = _errs12 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate77.errors = [
                      {
                        instancePath: instancePath + '/alternatives',
                        schemaPath: '#/properties/alternatives/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.stdin !== undefined) {
                  const _errs16 = errors;
                  if (
                    !validate71(data.stdin, {
                      instancePath: instancePath + '/stdin',
                      parentData: data,
                      parentDataProperty: 'stdin',
                      rootData,
                      dynamicAnchors,
                    })
                  ) {
                    vErrors =
                      vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs16 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.expected !== undefined) {
                    const _errs17 = errors;
                    if (typeof data.expected !== 'string') {
                      validate77.errors = [
                        {
                          instancePath: instancePath + '/expected',
                          schemaPath: '#/properties/expected/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate77.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate77.errors = vErrors;
  return errors === 0;
}
validate77.evaluated = {
  props: {
    grading: true,
    lines: true,
    distractors: true,
    alternatives: true,
    stdin: true,
    expected: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
const schema32 = {
  type: 'object',
  required: ['question', 'choices', 'grading'],
  properties: {
    grading: { const: 'client' },
    question: { $ref: '#/$defs/markdown' },
    code: { $ref: '#/$defs/swiftCode' },
    choices: { $ref: '#/$defs/choiceOptions' },
    multiple: { type: 'boolean', default: false },
  },
  allOf: [
    {
      if: { properties: { multiple: { const: true } }, required: ['multiple'] },
      then: {
        properties: {
          choices: {
            contains: { properties: { correct: { const: true } } },
            minContains: 1,
            items: { properties: { accepted: { const: false } } },
          },
        },
      },
      else: {
        properties: {
          choices: {
            contains: { properties: { correct: { const: true } }, required: ['correct'] },
            minContains: 1,
            maxContains: 1,
          },
        },
      },
    },
  ],
};
const schema33 = {
  type: 'array',
  minItems: 2,
  maxItems: 6,
  items: { $ref: '#/$defs/choiceOption' },
};
const schema34 = {
  type: 'object',
  required: ['text', 'correct'],
  additionalProperties: false,
  properties: {
    text: { $ref: '#/$defs/markdown' },
    correct: { type: 'boolean' },
    explanation: { $ref: '#/$defs/markdown' },
    accepted: { type: 'boolean', default: false },
  },
  allOf: [
    {
      if: { properties: { accepted: { const: true } }, required: ['accepted'] },
      then: { properties: { correct: { const: false } } },
    },
  ],
};
function validate84(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate84.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs2 = errors;
  let valid1 = true;
  const _errs3 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (data.accepted === undefined && (missing0 = 'accepted')) {
      const err0 = {};
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    } else {
      if (data.accepted !== undefined) {
        if (true !== data.accepted) {
          const err1 = {};
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      }
    }
  }
  var _valid0 = _errs3 === errors;
  errors = _errs2;
  if (vErrors !== null) {
    if (_errs2) {
      vErrors.length = _errs2;
    } else {
      vErrors = null;
    }
  }
  if (_valid0) {
    const _errs5 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.correct !== undefined) {
        if (false !== data.correct) {
          validate84.errors = [
            {
              instancePath: instancePath + '/correct',
              schemaPath: '#/allOf/0/then/properties/correct/const',
              keyword: 'const',
              params: { allowedValue: false },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
      }
    }
    var _valid0 = _errs5 === errors;
    valid1 = _valid0;
    if (valid1) {
      var props0 = {};
      props0.correct = true;
      props0.accepted = true;
    }
  }
  if (!valid1) {
    const err2 = {
      instancePath,
      schemaPath: '#/allOf/0/if',
      keyword: 'if',
      params: { failingKeyword: 'then' },
      message: 'must match "then" schema',
    };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
    validate84.errors = vErrors;
    return false;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (
        (data.text === undefined && (missing1 = 'text')) ||
        (data.correct === undefined && (missing1 = 'correct'))
      ) {
        validate84.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing1 },
            message: "must have required property '" + missing1 + "'",
          },
        ];
        return false;
      } else {
        const _errs7 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'text' ||
            key0 === 'correct' ||
            key0 === 'explanation' ||
            key0 === 'accepted'
          )) {
            validate84.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs7 === errors) {
          if (data.text !== undefined) {
            const _errs8 = errors;
            if (
              !validate63(data.text, {
                instancePath: instancePath + '/text',
                parentData: data,
                parentDataProperty: 'text',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            var valid4 = _errs8 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.correct !== undefined) {
              const _errs9 = errors;
              if (typeof data.correct !== 'boolean') {
                validate84.errors = [
                  {
                    instancePath: instancePath + '/correct',
                    schemaPath: '#/properties/correct/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid4 = _errs9 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.explanation !== undefined) {
                const _errs11 = errors;
                if (
                  !validate63(data.explanation, {
                    instancePath: instancePath + '/explanation',
                    parentData: data,
                    parentDataProperty: 'explanation',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                  errors = vErrors.length;
                }
                var valid4 = _errs11 === errors;
              } else {
                var valid4 = true;
              }
              if (valid4) {
                if (data.accepted !== undefined) {
                  const _errs12 = errors;
                  if (typeof data.accepted !== 'boolean') {
                    validate84.errors = [
                      {
                        instancePath: instancePath + '/accepted',
                        schemaPath: '#/properties/accepted/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid4 = _errs12 === errors;
                } else {
                  var valid4 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate84.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate84.errors = vErrors;
  return errors === 0;
}
validate84.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate83(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate83.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (Array.isArray(data)) {
      if (data.length > 6) {
        validate83.errors = [
          {
            instancePath,
            schemaPath: '#/maxItems',
            keyword: 'maxItems',
            params: { limit: 6 },
            message: 'must NOT have more than 6 items',
          },
        ];
        return false;
      } else {
        if (data.length < 2) {
          validate83.errors = [
            {
              instancePath,
              schemaPath: '#/minItems',
              keyword: 'minItems',
              params: { limit: 2 },
              message: 'must NOT have fewer than 2 items',
            },
          ];
          return false;
        } else {
          var valid0 = true;
          const len0 = data.length;
          for (let i0 = 0; i0 < len0; i0++) {
            const _errs1 = errors;
            if (
              !validate84(data[i0], {
                instancePath: instancePath + '/' + i0,
                parentData: data,
                parentDataProperty: i0,
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs1 === errors;
            if (!valid0) {
              break;
            }
          }
        }
      }
    } else {
      validate83.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        },
      ];
      return false;
    }
  }
  validate83.errors = vErrors;
  return errors === 0;
}
validate83.evaluated = { items: true, dynamicProps: false, dynamicItems: false };
function validate80(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate80.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs2 = errors;
  let valid1 = true;
  const _errs3 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (data.multiple === undefined && (missing0 = 'multiple')) {
      const err0 = {};
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    } else {
      if (data.multiple !== undefined) {
        if (true !== data.multiple) {
          const err1 = {};
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      }
    }
  }
  var _valid0 = _errs3 === errors;
  errors = _errs2;
  if (vErrors !== null) {
    if (_errs2) {
      vErrors.length = _errs2;
    } else {
      vErrors = null;
    }
  }
  let ifClause0;
  if (_valid0) {
    const _errs5 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.choices !== undefined) {
        let data1 = data.choices;
        if (Array.isArray(data1)) {
          var valid4 = true;
          const len0 = data1.length;
          for (let i0 = 0; i0 < len0; i0++) {
            let data2 = data1[i0];
            const _errs7 = errors;
            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
              if (data2.accepted !== undefined) {
                if (false !== data2.accepted) {
                  validate80.errors = [
                    {
                      instancePath: instancePath + '/choices/' + i0 + '/accepted',
                      schemaPath:
                        '#/allOf/0/then/properties/choices/items/properties/accepted/const',
                      keyword: 'const',
                      params: { allowedValue: false },
                      message: 'must be equal to constant',
                    },
                  ];
                  return false;
                }
              }
            }
            var valid4 = _errs7 === errors;
            if (!valid4) {
              break;
            }
          }
          if (valid4) {
            const _errs9 = errors;
            const len1 = data1.length;
            for (let i1 = 0; i1 < len1; i1++) {
              let data4 = data1[i1];
              const _errs10 = errors;
              if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                if (data4.correct !== undefined) {
                  if (true !== data4.correct) {
                    const err2 = {
                      instancePath: instancePath + '/choices/' + i1 + '/correct',
                      schemaPath:
                        '#/allOf/0/then/properties/choices/contains/properties/correct/const',
                      keyword: 'const',
                      params: { allowedValue: true },
                      message: 'must be equal to constant',
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                }
              }
              var valid6 = _errs10 === errors;
              if (valid6) {
                break;
              }
            }
            if (!valid6) {
              validate80.errors = [
                {
                  instancePath: instancePath + '/choices',
                  schemaPath: '#/allOf/0/then/properties/choices/contains',
                  keyword: 'contains',
                  params: { minContains: 1 },
                  message: 'must contain at least 1 valid item(s)',
                },
              ];
              return false;
            } else {
              errors = _errs9;
              if (vErrors !== null) {
                if (_errs9) {
                  vErrors.length = _errs9;
                } else {
                  vErrors = null;
                }
              }
            }
          }
        }
      }
    }
    var _valid0 = _errs5 === errors;
    valid1 = _valid0;
    if (valid1) {
      var props0 = {};
      props0.choices = true;
      props0.multiple = true;
    }
    ifClause0 = 'then';
  } else {
    const _errs12 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.choices !== undefined) {
        let data6 = data.choices;
        if (Array.isArray(data6)) {
          const _errs14 = errors;
          const len2 = data6.length;
          let valid9 = false;
          let count0 = 0;
          for (let i2 = 0; i2 < len2; i2++) {
            let data7 = data6[i2];
            const _errs15 = errors;
            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
              let missing1;
              if (data7.correct === undefined && (missing1 = 'correct')) {
                const err3 = {
                  instancePath: instancePath + '/choices/' + i2,
                  schemaPath: '#/allOf/0/else/properties/choices/contains/required',
                  keyword: 'required',
                  params: { missingProperty: missing1 },
                  message: "must have required property '" + missing1 + "'",
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              } else {
                if (data7.correct !== undefined) {
                  if (true !== data7.correct) {
                    const err4 = {
                      instancePath: instancePath + '/choices/' + i2 + '/correct',
                      schemaPath:
                        '#/allOf/0/else/properties/choices/contains/properties/correct/const',
                      keyword: 'const',
                      params: { allowedValue: true },
                      message: 'must be equal to constant',
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                }
              }
            }
            var _valid1 = _errs15 === errors;
            if (_valid1) {
              count0++;
              if (count0 > 1) {
                valid9 = false;
                break;
              }
              valid9 = true;
            }
          }
          if (!valid9) {
            validate80.errors = [
              {
                instancePath: instancePath + '/choices',
                schemaPath: '#/allOf/0/else/properties/choices/contains',
                keyword: 'contains',
                params: { minContains: 1, maxContains: 1 },
                message: 'must contain at least 1 and no more than 1 valid item(s)',
              },
            ];
            return false;
          } else {
            errors = _errs14;
            if (vErrors !== null) {
              if (_errs14) {
                vErrors.length = _errs14;
              } else {
                vErrors = null;
              }
            }
          }
        }
      }
    }
    var _valid0 = _errs12 === errors;
    valid1 = _valid0;
    if (valid1) {
      if (props0 !== true) {
        props0 = props0 || {};
        props0.choices = true;
      }
    }
    ifClause0 = 'else';
  }
  if (!valid1) {
    const err5 = {
      instancePath,
      schemaPath: '#/allOf/0/if',
      keyword: 'if',
      params: { failingKeyword: ifClause0 },
      message: 'must match "' + ifClause0 + '" schema',
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
    validate80.errors = vErrors;
    return false;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing2;
      if (
        (data.question === undefined && (missing2 = 'question')) ||
        (data.choices === undefined && (missing2 = 'choices')) ||
        (data.grading === undefined && (missing2 = 'grading'))
      ) {
        validate80.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing2 },
            message: "must have required property '" + missing2 + "'",
          },
        ];
        return false;
      } else {
        if (props0 !== true) {
          props0 = props0 || {};
          props0.grading = true;
          props0.question = true;
          props0.code = true;
          props0.choices = true;
          props0.multiple = true;
        }
        if (data.grading !== undefined) {
          const _errs17 = errors;
          if ('client' !== data.grading) {
            validate80.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid11 = _errs17 === errors;
        } else {
          var valid11 = true;
        }
        if (valid11) {
          if (data.question !== undefined) {
            const _errs18 = errors;
            if (
              !validate63(data.question, {
                instancePath: instancePath + '/question',
                parentData: data,
                parentDataProperty: 'question',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            var valid11 = _errs18 === errors;
          } else {
            var valid11 = true;
          }
          if (valid11) {
            if (data.code !== undefined) {
              const _errs19 = errors;
              if (
                !validate69(data.code, {
                  instancePath: instancePath + '/code',
                  parentData: data,
                  parentDataProperty: 'code',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
                errors = vErrors.length;
              }
              var valid11 = _errs19 === errors;
            } else {
              var valid11 = true;
            }
            if (valid11) {
              if (data.choices !== undefined) {
                const _errs20 = errors;
                if (
                  !validate83(data.choices, {
                    instancePath: instancePath + '/choices',
                    parentData: data,
                    parentDataProperty: 'choices',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate83.errors : vErrors.concat(validate83.errors);
                  errors = vErrors.length;
                }
                var valid11 = _errs20 === errors;
              } else {
                var valid11 = true;
              }
              if (valid11) {
                if (data.multiple !== undefined) {
                  const _errs21 = errors;
                  if (typeof data.multiple !== 'boolean') {
                    validate80.errors = [
                      {
                        instancePath: instancePath + '/multiple',
                        schemaPath: '#/properties/multiple/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid11 = _errs21 === errors;
                } else {
                  var valid11 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate80.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate80.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate80.evaluated = { dynamicProps: true, dynamicItems: false };
const schema35 = {
  type: 'object',
  required: ['problem', 'choices', 'reason', 'grading'],
  properties: {
    grading: { const: 'client' },
    problem: { $ref: '#/$defs/markdown' },
    constraints: {
      type: 'array',
      maxItems: 4,
      items: {
        type: 'object',
        required: ['name', 'max'],
        additionalProperties: false,
        properties: {
          name: { type: 'string', pattern: '^[A-Z][A-Za-z0-9]*$' },
          min: { type: 'number' },
          max: { type: 'number', exclusiveMinimum: 0 },
        },
      },
    },
    choices: {
      type: 'array',
      minItems: 3,
      maxItems: 6,
      items: { $ref: '#/$defs/reduceOption' },
      contains: { properties: { correct: { const: true } }, required: ['correct'] },
      minContains: 1,
      maxContains: 1,
    },
    reason: { type: 'string', minLength: 1, maxLength: 120 },
    ops: { $ref: '#/$defs/opsExpr' },
  },
  dependentRequired: { ops: ['constraints'] },
};
const schema36 = {
  type: 'object',
  required: ['technique', 'correct'],
  additionalProperties: false,
  properties: {
    technique: { $ref: '#/$defs/technique' },
    correct: { type: 'boolean' },
    explanation: { $ref: '#/$defs/markdown' },
    accepted: { type: 'boolean', default: false },
    note: { type: 'string', minLength: 1, maxLength: 30 },
  },
  allOf: [
    {
      if: { properties: { accepted: { const: true } }, required: ['accepted'] },
      then: { properties: { correct: { const: false } } },
    },
  ],
};
const schema37 = {
  enum: [
    'single-loop',
    'double-loop-search',
    'triple-loop-search',
    'digit-while',
    'array-count',
    'dict',
    'set',
    'stack',
    'queue',
    'cumulative-sum',
    'sort-and-binary-search',
    'sort-and-greedy',
    'two-pointers',
    'bit-full-search',
    'bfs',
    'dfs',
    'dp',
  ],
};
function validate93(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate93.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (!(
    data === 'single-loop' ||
    data === 'double-loop-search' ||
    data === 'triple-loop-search' ||
    data === 'digit-while' ||
    data === 'array-count' ||
    data === 'dict' ||
    data === 'set' ||
    data === 'stack' ||
    data === 'queue' ||
    data === 'cumulative-sum' ||
    data === 'sort-and-binary-search' ||
    data === 'sort-and-greedy' ||
    data === 'two-pointers' ||
    data === 'bit-full-search' ||
    data === 'bfs' ||
    data === 'dfs' ||
    data === 'dp'
  )) {
    validate93.errors = [
      {
        instancePath,
        schemaPath: '#/enum',
        keyword: 'enum',
        params: { allowedValues: schema37.enum },
        message: 'must be equal to one of the allowed values',
      },
    ];
    return false;
  }
  validate93.errors = vErrors;
  return errors === 0;
}
validate93.evaluated = { dynamicProps: false, dynamicItems: false };
function validate92(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate92.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs2 = errors;
  let valid1 = true;
  const _errs3 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (data.accepted === undefined && (missing0 = 'accepted')) {
      const err0 = {};
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    } else {
      if (data.accepted !== undefined) {
        if (true !== data.accepted) {
          const err1 = {};
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      }
    }
  }
  var _valid0 = _errs3 === errors;
  errors = _errs2;
  if (vErrors !== null) {
    if (_errs2) {
      vErrors.length = _errs2;
    } else {
      vErrors = null;
    }
  }
  if (_valid0) {
    const _errs5 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.correct !== undefined) {
        if (false !== data.correct) {
          validate92.errors = [
            {
              instancePath: instancePath + '/correct',
              schemaPath: '#/allOf/0/then/properties/correct/const',
              keyword: 'const',
              params: { allowedValue: false },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
      }
    }
    var _valid0 = _errs5 === errors;
    valid1 = _valid0;
    if (valid1) {
      var props0 = {};
      props0.correct = true;
      props0.accepted = true;
    }
  }
  if (!valid1) {
    const err2 = {
      instancePath,
      schemaPath: '#/allOf/0/if',
      keyword: 'if',
      params: { failingKeyword: 'then' },
      message: 'must match "then" schema',
    };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
    validate92.errors = vErrors;
    return false;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (
        (data.technique === undefined && (missing1 = 'technique')) ||
        (data.correct === undefined && (missing1 = 'correct'))
      ) {
        validate92.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing1 },
            message: "must have required property '" + missing1 + "'",
          },
        ];
        return false;
      } else {
        const _errs7 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'technique' ||
            key0 === 'correct' ||
            key0 === 'explanation' ||
            key0 === 'accepted' ||
            key0 === 'note'
          )) {
            validate92.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs7 === errors) {
          if (data.technique !== undefined) {
            const _errs8 = errors;
            if (
              !validate93(data.technique, {
                instancePath: instancePath + '/technique',
                parentData: data,
                parentDataProperty: 'technique',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate93.errors : vErrors.concat(validate93.errors);
              errors = vErrors.length;
            }
            var valid4 = _errs8 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.correct !== undefined) {
              const _errs9 = errors;
              if (typeof data.correct !== 'boolean') {
                validate92.errors = [
                  {
                    instancePath: instancePath + '/correct',
                    schemaPath: '#/properties/correct/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid4 = _errs9 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.explanation !== undefined) {
                const _errs11 = errors;
                if (
                  !validate63(data.explanation, {
                    instancePath: instancePath + '/explanation',
                    parentData: data,
                    parentDataProperty: 'explanation',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                  errors = vErrors.length;
                }
                var valid4 = _errs11 === errors;
              } else {
                var valid4 = true;
              }
              if (valid4) {
                if (data.accepted !== undefined) {
                  const _errs12 = errors;
                  if (typeof data.accepted !== 'boolean') {
                    validate92.errors = [
                      {
                        instancePath: instancePath + '/accepted',
                        schemaPath: '#/properties/accepted/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid4 = _errs12 === errors;
                } else {
                  var valid4 = true;
                }
                if (valid4) {
                  if (data.note !== undefined) {
                    let data6 = data.note;
                    const _errs14 = errors;
                    if (errors === _errs14) {
                      if (typeof data6 === 'string') {
                        if (func1(data6) > 30) {
                          validate92.errors = [
                            {
                              instancePath: instancePath + '/note',
                              schemaPath: '#/properties/note/maxLength',
                              keyword: 'maxLength',
                              params: { limit: 30 },
                              message: 'must NOT have more than 30 characters',
                            },
                          ];
                          return false;
                        } else {
                          if (func1(data6) < 1) {
                            validate92.errors = [
                              {
                                instancePath: instancePath + '/note',
                                schemaPath: '#/properties/note/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                              },
                            ];
                            return false;
                          }
                        }
                      } else {
                        validate92.errors = [
                          {
                            instancePath: instancePath + '/note',
                            schemaPath: '#/properties/note/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid4 = _errs14 === errors;
                  } else {
                    var valid4 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate92.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate92.errors = vErrors;
  return errors === 0;
}
validate92.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const schema38 = {
  type: 'string',
  minLength: 1,
  maxLength: 80,
  pattern: '^[A-Za-z0-9_+\\-*/^(). ]+$',
};
const pattern8 = new RegExp('^[A-Za-z0-9_+\\-*/^(). ]+$', 'u');
function validate97(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate97.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 80) {
        validate97.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 80 },
            message: 'must NOT have more than 80 characters',
          },
        ];
        return false;
      } else {
        if (func1(data) < 1) {
          validate97.errors = [
            {
              instancePath,
              schemaPath: '#/minLength',
              keyword: 'minLength',
              params: { limit: 1 },
              message: 'must NOT have fewer than 1 characters',
            },
          ];
          return false;
        } else {
          if (!pattern8.test(data)) {
            validate97.errors = [
              {
                instancePath,
                schemaPath: '#/pattern',
                keyword: 'pattern',
                params: { pattern: '^[A-Za-z0-9_+\\-*/^(). ]+$' },
                message: 'must match pattern "' + '^[A-Za-z0-9_+\\-*/^(). ]+$' + '"',
              },
            ];
            return false;
          }
        }
      }
    } else {
      validate97.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate97.errors = vErrors;
  return errors === 0;
}
validate97.evaluated = { dynamicProps: false, dynamicItems: false };
const pattern7 = new RegExp('^[A-Z][A-Za-z0-9]*$', 'u');
function validate90(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate90.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.problem === undefined && (missing0 = 'problem')) ||
        (data.choices === undefined && (missing0 = 'choices')) ||
        (data.reason === undefined && (missing0 = 'reason')) ||
        (data.grading === undefined && (missing0 = 'grading'))
      ) {
        validate90.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          const _errs1 = errors;
          if ('client' !== data.grading) {
            validate90.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.problem !== undefined) {
            const _errs2 = errors;
            if (
              !validate63(data.problem, {
                instancePath: instancePath + '/problem',
                parentData: data,
                parentDataProperty: 'problem',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.constraints !== undefined) {
              let data2 = data.constraints;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (Array.isArray(data2)) {
                  if (data2.length > 4) {
                    validate90.errors = [
                      {
                        instancePath: instancePath + '/constraints',
                        schemaPath: '#/properties/constraints/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 4 },
                        message: 'must NOT have more than 4 items',
                      },
                    ];
                    return false;
                  } else {
                    var valid1 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data3 = data2[i0];
                      const _errs5 = errors;
                      if (errors === _errs5) {
                        if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                          let missing1;
                          if (
                            (data3.name === undefined && (missing1 = 'name')) ||
                            (data3.max === undefined && (missing1 = 'max'))
                          ) {
                            validate90.errors = [
                              {
                                instancePath: instancePath + '/constraints/' + i0,
                                schemaPath: '#/properties/constraints/items/required',
                                keyword: 'required',
                                params: { missingProperty: missing1 },
                                message: "must have required property '" + missing1 + "'",
                              },
                            ];
                            return false;
                          } else {
                            const _errs7 = errors;
                            for (const key0 in data3) {
                              if (!(key0 === 'name' || key0 === 'min' || key0 === 'max')) {
                                validate90.errors = [
                                  {
                                    instancePath: instancePath + '/constraints/' + i0,
                                    schemaPath:
                                      '#/properties/constraints/items/additionalProperties',
                                    keyword: 'additionalProperties',
                                    params: { additionalProperty: key0 },
                                    message: 'must NOT have additional properties',
                                  },
                                ];
                                return false;
                                break;
                              }
                            }
                            if (_errs7 === errors) {
                              if (data3.name !== undefined) {
                                let data4 = data3.name;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                  if (typeof data4 === 'string') {
                                    if (!pattern7.test(data4)) {
                                      validate90.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/constraints/' + i0 + '/name',
                                          schemaPath:
                                            '#/properties/constraints/items/properties/name/pattern',
                                          keyword: 'pattern',
                                          params: { pattern: '^[A-Z][A-Za-z0-9]*$' },
                                          message:
                                            'must match pattern "' + '^[A-Z][A-Za-z0-9]*$' + '"',
                                        },
                                      ];
                                      return false;
                                    }
                                  } else {
                                    validate90.errors = [
                                      {
                                        instancePath: instancePath + '/constraints/' + i0 + '/name',
                                        schemaPath:
                                          '#/properties/constraints/items/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid2 = _errs8 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data3.min !== undefined) {
                                  const _errs10 = errors;
                                  if (!(typeof data3.min == 'number')) {
                                    validate90.errors = [
                                      {
                                        instancePath: instancePath + '/constraints/' + i0 + '/min',
                                        schemaPath:
                                          '#/properties/constraints/items/properties/min/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid2 = _errs10 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data3.max !== undefined) {
                                    let data6 = data3.max;
                                    const _errs12 = errors;
                                    if (errors === _errs12) {
                                      if (typeof data6 == 'number') {
                                        if (data6 <= 0 || isNaN(data6)) {
                                          validate90.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/constraints/' + i0 + '/max',
                                              schemaPath:
                                                '#/properties/constraints/items/properties/max/exclusiveMinimum',
                                              keyword: 'exclusiveMinimum',
                                              params: { comparison: '>', limit: 0 },
                                              message: 'must be > 0',
                                            },
                                          ];
                                          return false;
                                        }
                                      } else {
                                        validate90.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/constraints/' + i0 + '/max',
                                            schemaPath:
                                              '#/properties/constraints/items/properties/max/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                    var valid2 = _errs12 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate90.errors = [
                            {
                              instancePath: instancePath + '/constraints/' + i0,
                              schemaPath: '#/properties/constraints/items/type',
                              keyword: 'type',
                              params: { type: 'object' },
                              message: 'must be object',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  }
                } else {
                  validate90.errors = [
                    {
                      instancePath: instancePath + '/constraints',
                      schemaPath: '#/properties/constraints/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.choices !== undefined) {
                let data7 = data.choices;
                const _errs14 = errors;
                if (errors === _errs14) {
                  if (Array.isArray(data7)) {
                    if (data7.length > 6) {
                      validate90.errors = [
                        {
                          instancePath: instancePath + '/choices',
                          schemaPath: '#/properties/choices/maxItems',
                          keyword: 'maxItems',
                          params: { limit: 6 },
                          message: 'must NOT have more than 6 items',
                        },
                      ];
                      return false;
                    } else {
                      if (data7.length < 3) {
                        validate90.errors = [
                          {
                            instancePath: instancePath + '/choices',
                            schemaPath: '#/properties/choices/minItems',
                            keyword: 'minItems',
                            params: { limit: 3 },
                            message: 'must NOT have fewer than 3 items',
                          },
                        ];
                        return false;
                      } else {
                        var valid3 = true;
                        const len1 = data7.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          const _errs16 = errors;
                          if (
                            !validate92(data7[i1], {
                              instancePath: instancePath + '/choices/' + i1,
                              parentData: data7,
                              parentDataProperty: i1,
                              rootData,
                              dynamicAnchors,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate92.errors
                                : vErrors.concat(validate92.errors);
                            errors = vErrors.length;
                          }
                          var valid3 = _errs16 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                        if (valid3) {
                          const _errs17 = errors;
                          const len2 = data7.length;
                          let valid4 = false;
                          let count0 = 0;
                          for (let i2 = 0; i2 < len2; i2++) {
                            let data9 = data7[i2];
                            const _errs18 = errors;
                            if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                              let missing2;
                              if (data9.correct === undefined && (missing2 = 'correct')) {
                                const err0 = {
                                  instancePath: instancePath + '/choices/' + i2,
                                  schemaPath: '#/properties/choices/contains/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing2 },
                                  message: "must have required property '" + missing2 + "'",
                                };
                                if (vErrors === null) {
                                  vErrors = [err0];
                                } else {
                                  vErrors.push(err0);
                                }
                                errors++;
                              } else {
                                if (data9.correct !== undefined) {
                                  if (true !== data9.correct) {
                                    const err1 = {
                                      instancePath: instancePath + '/choices/' + i2 + '/correct',
                                      schemaPath:
                                        '#/properties/choices/contains/properties/correct/const',
                                      keyword: 'const',
                                      params: { allowedValue: true },
                                      message: 'must be equal to constant',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err1];
                                    } else {
                                      vErrors.push(err1);
                                    }
                                    errors++;
                                  }
                                }
                              }
                            }
                            var _valid0 = _errs18 === errors;
                            if (_valid0) {
                              count0++;
                              if (count0 > 1) {
                                valid4 = false;
                                break;
                              }
                              valid4 = true;
                            }
                          }
                          if (!valid4) {
                            validate90.errors = [
                              {
                                instancePath: instancePath + '/choices',
                                schemaPath: '#/properties/choices/contains',
                                keyword: 'contains',
                                params: { minContains: 1, maxContains: 1 },
                                message: 'must contain at least 1 and no more than 1 valid item(s)',
                              },
                            ];
                            return false;
                          } else {
                            errors = _errs17;
                            if (vErrors !== null) {
                              if (_errs17) {
                                vErrors.length = _errs17;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    validate90.errors = [
                      {
                        instancePath: instancePath + '/choices',
                        schemaPath: '#/properties/choices/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs14 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.reason !== undefined) {
                  let data11 = data.reason;
                  const _errs20 = errors;
                  if (errors === _errs20) {
                    if (typeof data11 === 'string') {
                      if (func1(data11) > 120) {
                        validate90.errors = [
                          {
                            instancePath: instancePath + '/reason',
                            schemaPath: '#/properties/reason/maxLength',
                            keyword: 'maxLength',
                            params: { limit: 120 },
                            message: 'must NOT have more than 120 characters',
                          },
                        ];
                        return false;
                      } else {
                        if (func1(data11) < 1) {
                          validate90.errors = [
                            {
                              instancePath: instancePath + '/reason',
                              schemaPath: '#/properties/reason/minLength',
                              keyword: 'minLength',
                              params: { limit: 1 },
                              message: 'must NOT have fewer than 1 characters',
                            },
                          ];
                          return false;
                        }
                      }
                    } else {
                      validate90.errors = [
                        {
                          instancePath: instancePath + '/reason',
                          schemaPath: '#/properties/reason/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs20 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.ops !== undefined) {
                    const _errs22 = errors;
                    if (
                      !validate97(data.ops, {
                        instancePath: instancePath + '/ops',
                        parentData: data,
                        parentDataProperty: 'ops',
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate97.errors : vErrors.concat(validate97.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs22 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    let missing3;
                    if (
                      data.ops !== undefined &&
                      data.constraints === undefined &&
                      (missing3 = 'constraints')
                    ) {
                      validate90.errors = [
                        {
                          instancePath,
                          schemaPath: '#/dependentRequired',
                          keyword: 'dependentRequired',
                          params: {
                            property: 'ops',
                            missingProperty: missing3,
                            depsCount: 1,
                            deps: 'constraints',
                          },
                          message: 'must have property constraints when property ops is present',
                        },
                      ];
                      return false;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate90.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate90.errors = vErrors;
  return errors === 0;
}
validate90.evaluated = {
  props: {
    grading: true,
    problem: true,
    constraints: true,
    choices: true,
    reason: true,
    ops: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
const schema39 = {
  type: 'object',
  required: ['question', 'choices', 'grading'],
  properties: {
    grading: { const: 'client' },
    question: { $ref: '#/$defs/markdown' },
    code: { $ref: '#/$defs/swiftCode' },
    choices: { $ref: '#/$defs/choiceOptions' },
    multiple: { type: 'boolean', default: false },
    constraints: {
      type: 'array',
      maxItems: 4,
      items: {
        type: 'object',
        required: ['name', 'max'],
        additionalProperties: false,
        properties: {
          name: { type: 'string', pattern: '^[A-Z][A-Za-z0-9]*$' },
          min: { type: 'number' },
          max: { type: 'number', exclusiveMinimum: 0 },
        },
      },
    },
    ops: { $ref: '#/$defs/opsExpr' },
  },
  dependentRequired: { ops: ['constraints'] },
  allOf: [
    {
      if: { properties: { multiple: { const: true } }, required: ['multiple'] },
      then: {
        properties: {
          choices: {
            contains: { properties: { correct: { const: true } } },
            minContains: 1,
            items: { properties: { accepted: { const: false } } },
          },
        },
      },
      else: {
        properties: {
          choices: {
            contains: { properties: { correct: { const: true } }, required: ['correct'] },
            minContains: 1,
            maxContains: 1,
          },
        },
      },
    },
  ],
};
function validate100(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate100.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs2 = errors;
  let valid1 = true;
  const _errs3 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (data.multiple === undefined && (missing0 = 'multiple')) {
      const err0 = {};
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    } else {
      if (data.multiple !== undefined) {
        if (true !== data.multiple) {
          const err1 = {};
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      }
    }
  }
  var _valid0 = _errs3 === errors;
  errors = _errs2;
  if (vErrors !== null) {
    if (_errs2) {
      vErrors.length = _errs2;
    } else {
      vErrors = null;
    }
  }
  let ifClause0;
  if (_valid0) {
    const _errs5 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.choices !== undefined) {
        let data1 = data.choices;
        if (Array.isArray(data1)) {
          var valid4 = true;
          const len0 = data1.length;
          for (let i0 = 0; i0 < len0; i0++) {
            let data2 = data1[i0];
            const _errs7 = errors;
            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
              if (data2.accepted !== undefined) {
                if (false !== data2.accepted) {
                  validate100.errors = [
                    {
                      instancePath: instancePath + '/choices/' + i0 + '/accepted',
                      schemaPath:
                        '#/allOf/0/then/properties/choices/items/properties/accepted/const',
                      keyword: 'const',
                      params: { allowedValue: false },
                      message: 'must be equal to constant',
                    },
                  ];
                  return false;
                }
              }
            }
            var valid4 = _errs7 === errors;
            if (!valid4) {
              break;
            }
          }
          if (valid4) {
            const _errs9 = errors;
            const len1 = data1.length;
            for (let i1 = 0; i1 < len1; i1++) {
              let data4 = data1[i1];
              const _errs10 = errors;
              if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                if (data4.correct !== undefined) {
                  if (true !== data4.correct) {
                    const err2 = {
                      instancePath: instancePath + '/choices/' + i1 + '/correct',
                      schemaPath:
                        '#/allOf/0/then/properties/choices/contains/properties/correct/const',
                      keyword: 'const',
                      params: { allowedValue: true },
                      message: 'must be equal to constant',
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                }
              }
              var valid6 = _errs10 === errors;
              if (valid6) {
                break;
              }
            }
            if (!valid6) {
              validate100.errors = [
                {
                  instancePath: instancePath + '/choices',
                  schemaPath: '#/allOf/0/then/properties/choices/contains',
                  keyword: 'contains',
                  params: { minContains: 1 },
                  message: 'must contain at least 1 valid item(s)',
                },
              ];
              return false;
            } else {
              errors = _errs9;
              if (vErrors !== null) {
                if (_errs9) {
                  vErrors.length = _errs9;
                } else {
                  vErrors = null;
                }
              }
            }
          }
        }
      }
    }
    var _valid0 = _errs5 === errors;
    valid1 = _valid0;
    if (valid1) {
      var props0 = {};
      props0.choices = true;
      props0.multiple = true;
    }
    ifClause0 = 'then';
  } else {
    const _errs12 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.choices !== undefined) {
        let data6 = data.choices;
        if (Array.isArray(data6)) {
          const _errs14 = errors;
          const len2 = data6.length;
          let valid9 = false;
          let count0 = 0;
          for (let i2 = 0; i2 < len2; i2++) {
            let data7 = data6[i2];
            const _errs15 = errors;
            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
              let missing1;
              if (data7.correct === undefined && (missing1 = 'correct')) {
                const err3 = {
                  instancePath: instancePath + '/choices/' + i2,
                  schemaPath: '#/allOf/0/else/properties/choices/contains/required',
                  keyword: 'required',
                  params: { missingProperty: missing1 },
                  message: "must have required property '" + missing1 + "'",
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              } else {
                if (data7.correct !== undefined) {
                  if (true !== data7.correct) {
                    const err4 = {
                      instancePath: instancePath + '/choices/' + i2 + '/correct',
                      schemaPath:
                        '#/allOf/0/else/properties/choices/contains/properties/correct/const',
                      keyword: 'const',
                      params: { allowedValue: true },
                      message: 'must be equal to constant',
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                }
              }
            }
            var _valid1 = _errs15 === errors;
            if (_valid1) {
              count0++;
              if (count0 > 1) {
                valid9 = false;
                break;
              }
              valid9 = true;
            }
          }
          if (!valid9) {
            validate100.errors = [
              {
                instancePath: instancePath + '/choices',
                schemaPath: '#/allOf/0/else/properties/choices/contains',
                keyword: 'contains',
                params: { minContains: 1, maxContains: 1 },
                message: 'must contain at least 1 and no more than 1 valid item(s)',
              },
            ];
            return false;
          } else {
            errors = _errs14;
            if (vErrors !== null) {
              if (_errs14) {
                vErrors.length = _errs14;
              } else {
                vErrors = null;
              }
            }
          }
        }
      }
    }
    var _valid0 = _errs12 === errors;
    valid1 = _valid0;
    if (valid1) {
      if (props0 !== true) {
        props0 = props0 || {};
        props0.choices = true;
      }
    }
    ifClause0 = 'else';
  }
  if (!valid1) {
    const err5 = {
      instancePath,
      schemaPath: '#/allOf/0/if',
      keyword: 'if',
      params: { failingKeyword: ifClause0 },
      message: 'must match "' + ifClause0 + '" schema',
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
    validate100.errors = vErrors;
    return false;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing2;
      if (
        (data.question === undefined && (missing2 = 'question')) ||
        (data.choices === undefined && (missing2 = 'choices')) ||
        (data.grading === undefined && (missing2 = 'grading'))
      ) {
        validate100.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing2 },
            message: "must have required property '" + missing2 + "'",
          },
        ];
        return false;
      } else {
        if (props0 !== true) {
          props0 = props0 || {};
          props0.grading = true;
          props0.question = true;
          props0.code = true;
          props0.choices = true;
          props0.multiple = true;
          props0.constraints = true;
          props0.ops = true;
        }
        if (data.grading !== undefined) {
          const _errs17 = errors;
          if ('client' !== data.grading) {
            validate100.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid11 = _errs17 === errors;
        } else {
          var valid11 = true;
        }
        if (valid11) {
          if (data.question !== undefined) {
            const _errs18 = errors;
            if (
              !validate63(data.question, {
                instancePath: instancePath + '/question',
                parentData: data,
                parentDataProperty: 'question',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            var valid11 = _errs18 === errors;
          } else {
            var valid11 = true;
          }
          if (valid11) {
            if (data.code !== undefined) {
              const _errs19 = errors;
              if (
                !validate69(data.code, {
                  instancePath: instancePath + '/code',
                  parentData: data,
                  parentDataProperty: 'code',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
                errors = vErrors.length;
              }
              var valid11 = _errs19 === errors;
            } else {
              var valid11 = true;
            }
            if (valid11) {
              if (data.choices !== undefined) {
                const _errs20 = errors;
                if (
                  !validate83(data.choices, {
                    instancePath: instancePath + '/choices',
                    parentData: data,
                    parentDataProperty: 'choices',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate83.errors : vErrors.concat(validate83.errors);
                  errors = vErrors.length;
                }
                var valid11 = _errs20 === errors;
              } else {
                var valid11 = true;
              }
              if (valid11) {
                if (data.multiple !== undefined) {
                  const _errs21 = errors;
                  if (typeof data.multiple !== 'boolean') {
                    validate100.errors = [
                      {
                        instancePath: instancePath + '/multiple',
                        schemaPath: '#/properties/multiple/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid11 = _errs21 === errors;
                } else {
                  var valid11 = true;
                }
                if (valid11) {
                  if (data.constraints !== undefined) {
                    let data14 = data.constraints;
                    const _errs23 = errors;
                    if (errors === _errs23) {
                      if (Array.isArray(data14)) {
                        if (data14.length > 4) {
                          validate100.errors = [
                            {
                              instancePath: instancePath + '/constraints',
                              schemaPath: '#/properties/constraints/maxItems',
                              keyword: 'maxItems',
                              params: { limit: 4 },
                              message: 'must NOT have more than 4 items',
                            },
                          ];
                          return false;
                        } else {
                          var valid12 = true;
                          const len3 = data14.length;
                          for (let i3 = 0; i3 < len3; i3++) {
                            let data15 = data14[i3];
                            const _errs25 = errors;
                            if (errors === _errs25) {
                              if (data15 && typeof data15 == 'object' && !Array.isArray(data15)) {
                                let missing3;
                                if (
                                  (data15.name === undefined && (missing3 = 'name')) ||
                                  (data15.max === undefined && (missing3 = 'max'))
                                ) {
                                  validate100.errors = [
                                    {
                                      instancePath: instancePath + '/constraints/' + i3,
                                      schemaPath: '#/properties/constraints/items/required',
                                      keyword: 'required',
                                      params: { missingProperty: missing3 },
                                      message: "must have required property '" + missing3 + "'",
                                    },
                                  ];
                                  return false;
                                } else {
                                  const _errs27 = errors;
                                  for (const key0 in data15) {
                                    if (!(key0 === 'name' || key0 === 'min' || key0 === 'max')) {
                                      validate100.errors = [
                                        {
                                          instancePath: instancePath + '/constraints/' + i3,
                                          schemaPath:
                                            '#/properties/constraints/items/additionalProperties',
                                          keyword: 'additionalProperties',
                                          params: { additionalProperty: key0 },
                                          message: 'must NOT have additional properties',
                                        },
                                      ];
                                      return false;
                                      break;
                                    }
                                  }
                                  if (_errs27 === errors) {
                                    if (data15.name !== undefined) {
                                      let data16 = data15.name;
                                      const _errs28 = errors;
                                      if (errors === _errs28) {
                                        if (typeof data16 === 'string') {
                                          if (!pattern7.test(data16)) {
                                            validate100.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/constraints/' + i3 + '/name',
                                                schemaPath:
                                                  '#/properties/constraints/items/properties/name/pattern',
                                                keyword: 'pattern',
                                                params: { pattern: '^[A-Z][A-Za-z0-9]*$' },
                                                message:
                                                  'must match pattern "' +
                                                  '^[A-Z][A-Za-z0-9]*$' +
                                                  '"',
                                              },
                                            ];
                                            return false;
                                          }
                                        } else {
                                          validate100.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/constraints/' + i3 + '/name',
                                              schemaPath:
                                                '#/properties/constraints/items/properties/name/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                      var valid13 = _errs28 === errors;
                                    } else {
                                      var valid13 = true;
                                    }
                                    if (valid13) {
                                      if (data15.min !== undefined) {
                                        const _errs30 = errors;
                                        if (!(typeof data15.min == 'number')) {
                                          validate100.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/constraints/' + i3 + '/min',
                                              schemaPath:
                                                '#/properties/constraints/items/properties/min/type',
                                              keyword: 'type',
                                              params: { type: 'number' },
                                              message: 'must be number',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid13 = _errs30 === errors;
                                      } else {
                                        var valid13 = true;
                                      }
                                      if (valid13) {
                                        if (data15.max !== undefined) {
                                          let data18 = data15.max;
                                          const _errs32 = errors;
                                          if (errors === _errs32) {
                                            if (typeof data18 == 'number') {
                                              if (data18 <= 0 || isNaN(data18)) {
                                                validate100.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath + '/constraints/' + i3 + '/max',
                                                    schemaPath:
                                                      '#/properties/constraints/items/properties/max/exclusiveMinimum',
                                                    keyword: 'exclusiveMinimum',
                                                    params: { comparison: '>', limit: 0 },
                                                    message: 'must be > 0',
                                                  },
                                                ];
                                                return false;
                                              }
                                            } else {
                                              validate100.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/constraints/' + i3 + '/max',
                                                  schemaPath:
                                                    '#/properties/constraints/items/properties/max/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                          var valid13 = _errs32 === errors;
                                        } else {
                                          var valid13 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate100.errors = [
                                  {
                                    instancePath: instancePath + '/constraints/' + i3,
                                    schemaPath: '#/properties/constraints/items/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid12 = _errs25 === errors;
                            if (!valid12) {
                              break;
                            }
                          }
                        }
                      } else {
                        validate100.errors = [
                          {
                            instancePath: instancePath + '/constraints',
                            schemaPath: '#/properties/constraints/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid11 = _errs23 === errors;
                  } else {
                    var valid11 = true;
                  }
                  if (valid11) {
                    if (data.ops !== undefined) {
                      const _errs34 = errors;
                      if (
                        !validate97(data.ops, {
                          instancePath: instancePath + '/ops',
                          parentData: data,
                          parentDataProperty: 'ops',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate97.errors : vErrors.concat(validate97.errors);
                        errors = vErrors.length;
                      }
                      var valid11 = _errs34 === errors;
                    } else {
                      var valid11 = true;
                    }
                    if (valid11) {
                      let missing4;
                      if (
                        data.ops !== undefined &&
                        data.constraints === undefined &&
                        (missing4 = 'constraints')
                      ) {
                        validate100.errors = [
                          {
                            instancePath,
                            schemaPath: '#/dependentRequired',
                            keyword: 'dependentRequired',
                            params: {
                              property: 'ops',
                              missingProperty: missing4,
                              depsCount: 1,
                              deps: 'constraints',
                            },
                            message: 'must have property constraints when property ops is present',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate100.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate100.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate100.evaluated = { dynamicProps: true, dynamicItems: false };
const schema40 = {
  type: 'object',
  required: ['statement', 'starter', 'solution', 'cases', 'grading'],
  properties: {
    grading: { const: 'server' },
    statement: { $ref: '#/$defs/markdown' },
    starter: { type: 'string', maxLength: 65536 },
    solution: { $ref: '#/$defs/swiftCode' },
    cases: {
      type: 'array',
      minItems: 1,
      maxItems: 10,
      items: {
        type: 'object',
        required: ['in', 'out'],
        additionalProperties: false,
        properties: {
          name: { type: 'string', maxLength: 40 },
          in: { $ref: '#/$defs/stdin' },
          out: { type: 'string' },
        },
      },
    },
    source: {
      type: 'object',
      required: ['kind', 'path'],
      additionalProperties: false,
      properties: {
        kind: { const: 'swift-classroom' },
        path: {
          type: 'string',
          pattern: '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
        },
      },
    },
    preflight: {
      type: 'object',
      required: ['question', 'choices', 'answer'],
      additionalProperties: false,
      properties: {
        question: { $ref: '#/$defs/markdown' },
        choices: { $ref: '#/$defs/choices' },
        answer: { $ref: '#/$defs/answerIndex' },
      },
    },
    meter: { $ref: '#/$defs/meter' },
  },
};
const schema41 = {
  type: 'array',
  minItems: 2,
  maxItems: 6,
  items: { $ref: '#/$defs/markdown' },
  uniqueItems: true,
};
function validate111(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate111.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (Array.isArray(data)) {
      if (data.length > 6) {
        validate111.errors = [
          {
            instancePath,
            schemaPath: '#/maxItems',
            keyword: 'maxItems',
            params: { limit: 6 },
            message: 'must NOT have more than 6 items',
          },
        ];
        return false;
      } else {
        if (data.length < 2) {
          validate111.errors = [
            {
              instancePath,
              schemaPath: '#/minItems',
              keyword: 'minItems',
              params: { limit: 2 },
              message: 'must NOT have fewer than 2 items',
            },
          ];
          return false;
        } else {
          var valid0 = true;
          const len0 = data.length;
          for (let i0 = 0; i0 < len0; i0++) {
            const _errs1 = errors;
            if (
              !validate63(data[i0], {
                instancePath: instancePath + '/' + i0,
                parentData: data,
                parentDataProperty: i0,
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs1 === errors;
            if (!valid0) {
              break;
            }
          }
          if (valid0) {
            let i1 = data.length;
            let j0;
            if (i1 > 1) {
              outer0: for (; i1--;) {
                for (j0 = i1; j0--;) {
                  if (func0(data[i1], data[j0])) {
                    validate111.errors = [
                      {
                        instancePath,
                        schemaPath: '#/uniqueItems',
                        keyword: 'uniqueItems',
                        params: { i: i1, j: j0 },
                        message:
                          'must NOT have duplicate items (items ## ' +
                          j0 +
                          ' and ' +
                          i1 +
                          ' are identical)',
                      },
                    ];
                    return false;
                    break outer0;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate111.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        },
      ];
      return false;
    }
  }
  validate111.errors = vErrors;
  return errors === 0;
}
validate111.evaluated = { items: true, dynamicProps: false, dynamicItems: false };
const schema42 = { type: 'integer', minimum: 0, maximum: 5 };
function validate114(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate114.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (!(typeof data == 'number' && !(data % 1) && !isNaN(data))) {
    validate114.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'integer' },
        message: 'must be integer',
      },
    ];
    return false;
  }
  if (errors === 0) {
    if (typeof data == 'number') {
      if (data > 5 || isNaN(data)) {
        validate114.errors = [
          {
            instancePath,
            schemaPath: '#/maximum',
            keyword: 'maximum',
            params: { comparison: '<=', limit: 5 },
            message: 'must be <= 5',
          },
        ];
        return false;
      } else {
        if (data < 0 || isNaN(data)) {
          validate114.errors = [
            {
              instancePath,
              schemaPath: '#/minimum',
              keyword: 'minimum',
              params: { comparison: '>=', limit: 0 },
              message: 'must be >= 0',
            },
          ];
          return false;
        }
      }
    }
  }
  validate114.errors = vErrors;
  return errors === 0;
}
validate114.evaluated = { dynamicProps: false, dynamicItems: false };
const schema43 = {
  type: 'object',
  required: ['input', 'sizes'],
  additionalProperties: false,
  properties: {
    input: {
      type: 'object',
      required: ['kind'],
      additionalProperties: false,
      properties: {
        kind: { enum: ['n-only', 'n-and-array', 'n-and-string'] },
        valueMin: { type: 'integer' },
        valueMax: { type: 'integer' },
        alphabet: { type: 'string', minLength: 1, maxLength: 26 },
        seed: { type: 'integer', minimum: 0, maximum: 4294967295 },
      },
    },
    sizes: {
      type: 'array',
      minItems: 2,
      maxItems: 10,
      uniqueItems: true,
      items: { type: 'integer', minimum: 1, maximum: 1000000 },
    },
    ops: { $ref: '#/$defs/opsExpr' },
  },
};
function validate116(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate116.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.input === undefined && (missing0 = 'input')) ||
        (data.sizes === undefined && (missing0 = 'sizes'))
      ) {
        validate116.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'input' || key0 === 'sizes' || key0 === 'ops')) {
            validate116.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.input !== undefined) {
            let data0 = data.input;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                let missing1;
                if (data0.kind === undefined && (missing1 = 'kind')) {
                  validate116.errors = [
                    {
                      instancePath: instancePath + '/input',
                      schemaPath: '#/properties/input/required',
                      keyword: 'required',
                      params: { missingProperty: missing1 },
                      message: "must have required property '" + missing1 + "'",
                    },
                  ];
                  return false;
                } else {
                  const _errs4 = errors;
                  for (const key1 in data0) {
                    if (!(
                      key1 === 'kind' ||
                      key1 === 'valueMin' ||
                      key1 === 'valueMax' ||
                      key1 === 'alphabet' ||
                      key1 === 'seed'
                    )) {
                      validate116.errors = [
                        {
                          instancePath: instancePath + '/input',
                          schemaPath: '#/properties/input/additionalProperties',
                          keyword: 'additionalProperties',
                          params: { additionalProperty: key1 },
                          message: 'must NOT have additional properties',
                        },
                      ];
                      return false;
                      break;
                    }
                  }
                  if (_errs4 === errors) {
                    if (data0.kind !== undefined) {
                      let data1 = data0.kind;
                      const _errs5 = errors;
                      if (!(
                        data1 === 'n-only' ||
                        data1 === 'n-and-array' ||
                        data1 === 'n-and-string'
                      )) {
                        validate116.errors = [
                          {
                            instancePath: instancePath + '/input/kind',
                            schemaPath: '#/properties/input/properties/kind/enum',
                            keyword: 'enum',
                            params: {
                              allowedValues: schema43.properties.input.properties.kind.enum,
                            },
                            message: 'must be equal to one of the allowed values',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs5 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data0.valueMin !== undefined) {
                        let data2 = data0.valueMin;
                        const _errs6 = errors;
                        if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                          validate116.errors = [
                            {
                              instancePath: instancePath + '/input/valueMin',
                              schemaPath: '#/properties/input/properties/valueMin/type',
                              keyword: 'type',
                              params: { type: 'integer' },
                              message: 'must be integer',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs6 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data0.valueMax !== undefined) {
                          let data3 = data0.valueMax;
                          const _errs8 = errors;
                          if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                            validate116.errors = [
                              {
                                instancePath: instancePath + '/input/valueMax',
                                schemaPath: '#/properties/input/properties/valueMax/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs8 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data0.alphabet !== undefined) {
                            let data4 = data0.alphabet;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                              if (typeof data4 === 'string') {
                                if (func1(data4) > 26) {
                                  validate116.errors = [
                                    {
                                      instancePath: instancePath + '/input/alphabet',
                                      schemaPath:
                                        '#/properties/input/properties/alphabet/maxLength',
                                      keyword: 'maxLength',
                                      params: { limit: 26 },
                                      message: 'must NOT have more than 26 characters',
                                    },
                                  ];
                                  return false;
                                } else {
                                  if (func1(data4) < 1) {
                                    validate116.errors = [
                                      {
                                        instancePath: instancePath + '/input/alphabet',
                                        schemaPath:
                                          '#/properties/input/properties/alphabet/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                              } else {
                                validate116.errors = [
                                  {
                                    instancePath: instancePath + '/input/alphabet',
                                    schemaPath: '#/properties/input/properties/alphabet/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid1 = _errs10 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data0.seed !== undefined) {
                              let data5 = data0.seed;
                              const _errs12 = errors;
                              if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                                validate116.errors = [
                                  {
                                    instancePath: instancePath + '/input/seed',
                                    schemaPath: '#/properties/input/properties/seed/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer',
                                  },
                                ];
                                return false;
                              }
                              if (errors === _errs12) {
                                if (typeof data5 == 'number') {
                                  if (data5 > 4294967295 || isNaN(data5)) {
                                    validate116.errors = [
                                      {
                                        instancePath: instancePath + '/input/seed',
                                        schemaPath: '#/properties/input/properties/seed/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 4294967295 },
                                        message: 'must be <= 4294967295',
                                      },
                                    ];
                                    return false;
                                  } else {
                                    if (data5 < 0 || isNaN(data5)) {
                                      validate116.errors = [
                                        {
                                          instancePath: instancePath + '/input/seed',
                                          schemaPath: '#/properties/input/properties/seed/minimum',
                                          keyword: 'minimum',
                                          params: { comparison: '>=', limit: 0 },
                                          message: 'must be >= 0',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                }
                              }
                              var valid1 = _errs12 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate116.errors = [
                  {
                    instancePath: instancePath + '/input',
                    schemaPath: '#/properties/input/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.sizes !== undefined) {
              let data6 = data.sizes;
              const _errs14 = errors;
              if (errors === _errs14) {
                if (Array.isArray(data6)) {
                  if (data6.length > 10) {
                    validate116.errors = [
                      {
                        instancePath: instancePath + '/sizes',
                        schemaPath: '#/properties/sizes/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 10 },
                        message: 'must NOT have more than 10 items',
                      },
                    ];
                    return false;
                  } else {
                    if (data6.length < 2) {
                      validate116.errors = [
                        {
                          instancePath: instancePath + '/sizes',
                          schemaPath: '#/properties/sizes/minItems',
                          keyword: 'minItems',
                          params: { limit: 2 },
                          message: 'must NOT have fewer than 2 items',
                        },
                      ];
                      return false;
                    } else {
                      var valid2 = true;
                      const len0 = data6.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data7 = data6[i0];
                        const _errs16 = errors;
                        if (!(typeof data7 == 'number' && !(data7 % 1) && !isNaN(data7))) {
                          validate116.errors = [
                            {
                              instancePath: instancePath + '/sizes/' + i0,
                              schemaPath: '#/properties/sizes/items/type',
                              keyword: 'type',
                              params: { type: 'integer' },
                              message: 'must be integer',
                            },
                          ];
                          return false;
                        }
                        if (errors === _errs16) {
                          if (typeof data7 == 'number') {
                            if (data7 > 1000000 || isNaN(data7)) {
                              validate116.errors = [
                                {
                                  instancePath: instancePath + '/sizes/' + i0,
                                  schemaPath: '#/properties/sizes/items/maximum',
                                  keyword: 'maximum',
                                  params: { comparison: '<=', limit: 1000000 },
                                  message: 'must be <= 1000000',
                                },
                              ];
                              return false;
                            } else {
                              if (data7 < 1 || isNaN(data7)) {
                                validate116.errors = [
                                  {
                                    instancePath: instancePath + '/sizes/' + i0,
                                    schemaPath: '#/properties/sizes/items/minimum',
                                    keyword: 'minimum',
                                    params: { comparison: '>=', limit: 1 },
                                    message: 'must be >= 1',
                                  },
                                ];
                                return false;
                              }
                            }
                          }
                        }
                        var valid2 = _errs16 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                      if (valid2) {
                        let i1 = data6.length;
                        let j0;
                        if (i1 > 1) {
                          const indices0 = {};
                          for (; i1--;) {
                            let item0 = data6[i1];
                            if (!(typeof item0 == 'number' && !(item0 % 1) && !isNaN(item0))) {
                              continue;
                            }
                            if (typeof indices0[item0] == 'number') {
                              j0 = indices0[item0];
                              validate116.errors = [
                                {
                                  instancePath: instancePath + '/sizes',
                                  schemaPath: '#/properties/sizes/uniqueItems',
                                  keyword: 'uniqueItems',
                                  params: { i: i1, j: j0 },
                                  message:
                                    'must NOT have duplicate items (items ## ' +
                                    j0 +
                                    ' and ' +
                                    i1 +
                                    ' are identical)',
                                },
                              ];
                              return false;
                              break;
                            }
                            indices0[item0] = i1;
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate116.errors = [
                    {
                      instancePath: instancePath + '/sizes',
                      schemaPath: '#/properties/sizes/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs14 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.ops !== undefined) {
                const _errs18 = errors;
                if (
                  !validate97(data.ops, {
                    instancePath: instancePath + '/ops',
                    parentData: data,
                    parentDataProperty: 'ops',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate97.errors : vErrors.concat(validate97.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs18 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate116.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate116.errors = vErrors;
  return errors === 0;
}
validate116.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const pattern10 = new RegExp(
  '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
  'u',
);
function validate106(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate106.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.statement === undefined && (missing0 = 'statement')) ||
        (data.starter === undefined && (missing0 = 'starter')) ||
        (data.solution === undefined && (missing0 = 'solution')) ||
        (data.cases === undefined && (missing0 = 'cases')) ||
        (data.grading === undefined && (missing0 = 'grading'))
      ) {
        validate106.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          const _errs1 = errors;
          if ('server' !== data.grading) {
            validate106.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'server' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.statement !== undefined) {
            const _errs2 = errors;
            if (
              !validate63(data.statement, {
                instancePath: instancePath + '/statement',
                parentData: data,
                parentDataProperty: 'statement',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.starter !== undefined) {
              let data2 = data.starter;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (typeof data2 === 'string') {
                  if (func1(data2) > 65536) {
                    validate106.errors = [
                      {
                        instancePath: instancePath + '/starter',
                        schemaPath: '#/properties/starter/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 65536 },
                        message: 'must NOT have more than 65536 characters',
                      },
                    ];
                    return false;
                  }
                } else {
                  validate106.errors = [
                    {
                      instancePath: instancePath + '/starter',
                      schemaPath: '#/properties/starter/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.solution !== undefined) {
                const _errs5 = errors;
                if (
                  !validate69(data.solution, {
                    instancePath: instancePath + '/solution',
                    parentData: data,
                    parentDataProperty: 'solution',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.cases !== undefined) {
                  let data4 = data.cases;
                  const _errs6 = errors;
                  if (errors === _errs6) {
                    if (Array.isArray(data4)) {
                      if (data4.length > 10) {
                        validate106.errors = [
                          {
                            instancePath: instancePath + '/cases',
                            schemaPath: '#/properties/cases/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 10 },
                            message: 'must NOT have more than 10 items',
                          },
                        ];
                        return false;
                      } else {
                        if (data4.length < 1) {
                          validate106.errors = [
                            {
                              instancePath: instancePath + '/cases',
                              schemaPath: '#/properties/cases/minItems',
                              keyword: 'minItems',
                              params: { limit: 1 },
                              message: 'must NOT have fewer than 1 items',
                            },
                          ];
                          return false;
                        } else {
                          var valid1 = true;
                          const len0 = data4.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            let data5 = data4[i0];
                            const _errs8 = errors;
                            if (errors === _errs8) {
                              if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                let missing1;
                                if (
                                  (data5.in === undefined && (missing1 = 'in')) ||
                                  (data5.out === undefined && (missing1 = 'out'))
                                ) {
                                  validate106.errors = [
                                    {
                                      instancePath: instancePath + '/cases/' + i0,
                                      schemaPath: '#/properties/cases/items/required',
                                      keyword: 'required',
                                      params: { missingProperty: missing1 },
                                      message: "must have required property '" + missing1 + "'",
                                    },
                                  ];
                                  return false;
                                } else {
                                  const _errs10 = errors;
                                  for (const key0 in data5) {
                                    if (!(key0 === 'name' || key0 === 'in' || key0 === 'out')) {
                                      validate106.errors = [
                                        {
                                          instancePath: instancePath + '/cases/' + i0,
                                          schemaPath:
                                            '#/properties/cases/items/additionalProperties',
                                          keyword: 'additionalProperties',
                                          params: { additionalProperty: key0 },
                                          message: 'must NOT have additional properties',
                                        },
                                      ];
                                      return false;
                                      break;
                                    }
                                  }
                                  if (_errs10 === errors) {
                                    if (data5.name !== undefined) {
                                      let data6 = data5.name;
                                      const _errs11 = errors;
                                      if (errors === _errs11) {
                                        if (typeof data6 === 'string') {
                                          if (func1(data6) > 40) {
                                            validate106.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/cases/' + i0 + '/name',
                                                schemaPath:
                                                  '#/properties/cases/items/properties/name/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 40 },
                                                message: 'must NOT have more than 40 characters',
                                              },
                                            ];
                                            return false;
                                          }
                                        } else {
                                          validate106.errors = [
                                            {
                                              instancePath: instancePath + '/cases/' + i0 + '/name',
                                              schemaPath:
                                                '#/properties/cases/items/properties/name/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                      var valid2 = _errs11 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data5.in !== undefined) {
                                        const _errs13 = errors;
                                        if (
                                          !validate71(data5.in, {
                                            instancePath: instancePath + '/cases/' + i0 + '/in',
                                            parentData: data5,
                                            parentDataProperty: 'in',
                                            rootData,
                                            dynamicAnchors,
                                          })
                                        ) {
                                          vErrors =
                                            vErrors === null
                                              ? validate71.errors
                                              : vErrors.concat(validate71.errors);
                                          errors = vErrors.length;
                                        }
                                        var valid2 = _errs13 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data5.out !== undefined) {
                                          const _errs14 = errors;
                                          if (typeof data5.out !== 'string') {
                                            validate106.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/cases/' + i0 + '/out',
                                                schemaPath:
                                                  '#/properties/cases/items/properties/out/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid2 = _errs14 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate106.errors = [
                                  {
                                    instancePath: instancePath + '/cases/' + i0,
                                    schemaPath: '#/properties/cases/items/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid1 = _errs8 === errors;
                            if (!valid1) {
                              break;
                            }
                          }
                        }
                      }
                    } else {
                      validate106.errors = [
                        {
                          instancePath: instancePath + '/cases',
                          schemaPath: '#/properties/cases/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs6 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.source !== undefined) {
                    let data9 = data.source;
                    const _errs16 = errors;
                    if (errors === _errs16) {
                      if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                        let missing2;
                        if (
                          (data9.kind === undefined && (missing2 = 'kind')) ||
                          (data9.path === undefined && (missing2 = 'path'))
                        ) {
                          validate106.errors = [
                            {
                              instancePath: instancePath + '/source',
                              schemaPath: '#/properties/source/required',
                              keyword: 'required',
                              params: { missingProperty: missing2 },
                              message: "must have required property '" + missing2 + "'",
                            },
                          ];
                          return false;
                        } else {
                          const _errs18 = errors;
                          for (const key1 in data9) {
                            if (!(key1 === 'kind' || key1 === 'path')) {
                              validate106.errors = [
                                {
                                  instancePath: instancePath + '/source',
                                  schemaPath: '#/properties/source/additionalProperties',
                                  keyword: 'additionalProperties',
                                  params: { additionalProperty: key1 },
                                  message: 'must NOT have additional properties',
                                },
                              ];
                              return false;
                              break;
                            }
                          }
                          if (_errs18 === errors) {
                            if (data9.kind !== undefined) {
                              const _errs19 = errors;
                              if ('swift-classroom' !== data9.kind) {
                                validate106.errors = [
                                  {
                                    instancePath: instancePath + '/source/kind',
                                    schemaPath: '#/properties/source/properties/kind/const',
                                    keyword: 'const',
                                    params: { allowedValue: 'swift-classroom' },
                                    message: 'must be equal to constant',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs19 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data9.path !== undefined) {
                                let data11 = data9.path;
                                const _errs20 = errors;
                                if (errors === _errs20) {
                                  if (typeof data11 === 'string') {
                                    if (!pattern10.test(data11)) {
                                      validate106.errors = [
                                        {
                                          instancePath: instancePath + '/source/path',
                                          schemaPath: '#/properties/source/properties/path/pattern',
                                          keyword: 'pattern',
                                          params: {
                                            pattern:
                                              '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
                                          },
                                          message:
                                            'must match pattern "' +
                                            '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$' +
                                            '"',
                                        },
                                      ];
                                      return false;
                                    }
                                  } else {
                                    validate106.errors = [
                                      {
                                        instancePath: instancePath + '/source/path',
                                        schemaPath: '#/properties/source/properties/path/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid3 = _errs20 === errors;
                              } else {
                                var valid3 = true;
                              }
                            }
                          }
                        }
                      } else {
                        validate106.errors = [
                          {
                            instancePath: instancePath + '/source',
                            schemaPath: '#/properties/source/type',
                            keyword: 'type',
                            params: { type: 'object' },
                            message: 'must be object',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid0 = _errs16 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.preflight !== undefined) {
                      let data12 = data.preflight;
                      const _errs22 = errors;
                      if (errors === _errs22) {
                        if (data12 && typeof data12 == 'object' && !Array.isArray(data12)) {
                          let missing3;
                          if (
                            (data12.question === undefined && (missing3 = 'question')) ||
                            (data12.choices === undefined && (missing3 = 'choices')) ||
                            (data12.answer === undefined && (missing3 = 'answer'))
                          ) {
                            validate106.errors = [
                              {
                                instancePath: instancePath + '/preflight',
                                schemaPath: '#/properties/preflight/required',
                                keyword: 'required',
                                params: { missingProperty: missing3 },
                                message: "must have required property '" + missing3 + "'",
                              },
                            ];
                            return false;
                          } else {
                            const _errs24 = errors;
                            for (const key2 in data12) {
                              if (!(
                                key2 === 'question' ||
                                key2 === 'choices' ||
                                key2 === 'answer'
                              )) {
                                validate106.errors = [
                                  {
                                    instancePath: instancePath + '/preflight',
                                    schemaPath: '#/properties/preflight/additionalProperties',
                                    keyword: 'additionalProperties',
                                    params: { additionalProperty: key2 },
                                    message: 'must NOT have additional properties',
                                  },
                                ];
                                return false;
                                break;
                              }
                            }
                            if (_errs24 === errors) {
                              if (data12.question !== undefined) {
                                const _errs25 = errors;
                                if (
                                  !validate63(data12.question, {
                                    instancePath: instancePath + '/preflight/question',
                                    parentData: data12,
                                    parentDataProperty: 'question',
                                    rootData,
                                    dynamicAnchors,
                                  })
                                ) {
                                  vErrors =
                                    vErrors === null
                                      ? validate63.errors
                                      : vErrors.concat(validate63.errors);
                                  errors = vErrors.length;
                                }
                                var valid4 = _errs25 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data12.choices !== undefined) {
                                  const _errs26 = errors;
                                  if (
                                    !validate111(data12.choices, {
                                      instancePath: instancePath + '/preflight/choices',
                                      parentData: data12,
                                      parentDataProperty: 'choices',
                                      rootData,
                                      dynamicAnchors,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate111.errors
                                        : vErrors.concat(validate111.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid4 = _errs26 === errors;
                                } else {
                                  var valid4 = true;
                                }
                                if (valid4) {
                                  if (data12.answer !== undefined) {
                                    const _errs27 = errors;
                                    if (
                                      !validate114(data12.answer, {
                                        instancePath: instancePath + '/preflight/answer',
                                        parentData: data12,
                                        parentDataProperty: 'answer',
                                        rootData,
                                        dynamicAnchors,
                                      })
                                    ) {
                                      vErrors =
                                        vErrors === null
                                          ? validate114.errors
                                          : vErrors.concat(validate114.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid4 = _errs27 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate106.errors = [
                            {
                              instancePath: instancePath + '/preflight',
                              schemaPath: '#/properties/preflight/type',
                              keyword: 'type',
                              params: { type: 'object' },
                              message: 'must be object',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs22 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.meter !== undefined) {
                        const _errs28 = errors;
                        if (
                          !validate116(data.meter, {
                            instancePath: instancePath + '/meter',
                            parentData: data,
                            parentDataProperty: 'meter',
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate116.errors
                              : vErrors.concat(validate116.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs28 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate106.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate106.errors = vErrors;
  return errors === 0;
}
validate106.evaluated = {
  props: {
    grading: true,
    statement: true,
    starter: true,
    solution: true,
    cases: true,
    source: true,
    preflight: true,
    meter: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
const schema44 = {
  type: 'object',
  required: ['frames', 'checkpoints', 'grading'],
  properties: {
    grading: { const: 'client' },
    code: { $ref: '#/$defs/swiftCode' },
    stdin: { $ref: '#/$defs/stdin' },
    frames: {
      type: 'array',
      minItems: 2,
      maxItems: 200,
      items: {
        type: 'object',
        required: ['state'],
        additionalProperties: false,
        properties: {
          note: { $ref: '#/$defs/markdown' },
          ticks: { type: 'integer', minimum: 0 },
          state: {
            type: 'object',
            minProperties: 1,
            additionalProperties: { $ref: '#/$defs/vizState' },
          },
        },
      },
    },
    checkpoints: {
      type: 'array',
      minItems: 1,
      items: {
        type: 'object',
        required: ['frame', 'prompt', 'choices', 'answer'],
        additionalProperties: false,
        properties: {
          frame: { type: 'integer', minimum: 0 },
          prompt: { $ref: '#/$defs/markdown' },
          choices: { $ref: '#/$defs/choices' },
          answer: { $ref: '#/$defs/answerIndex' },
        },
      },
    },
  },
};
const schema45 = {
  type: 'object',
  required: ['kind', 'value'],
  additionalProperties: false,
  properties: {
    kind: { $ref: '#/$defs/vizKind' },
    value: true,
    head: { type: 'integer', minimum: 0 },
    marks: { type: 'object', additionalProperties: { type: 'integer' } },
  },
};
const schema46 = { enum: ['value', 'array', 'stack', 'queue', 'dict', 'set'] };
function validate125(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate125.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (!(
    data === 'value' ||
    data === 'array' ||
    data === 'stack' ||
    data === 'queue' ||
    data === 'dict' ||
    data === 'set'
  )) {
    validate125.errors = [
      {
        instancePath,
        schemaPath: '#/enum',
        keyword: 'enum',
        params: { allowedValues: schema46.enum },
        message: 'must be equal to one of the allowed values',
      },
    ];
    return false;
  }
  validate125.errors = vErrors;
  return errors === 0;
}
validate125.evaluated = { dynamicProps: false, dynamicItems: false };
function validate124(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate124.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.kind === undefined && (missing0 = 'kind')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate124.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'kind' || key0 === 'value' || key0 === 'head' || key0 === 'marks')) {
            validate124.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.kind !== undefined) {
            const _errs2 = errors;
            if (
              !validate125(data.kind, {
                instancePath: instancePath + '/kind',
                parentData: data,
                parentDataProperty: 'kind',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate125.errors : vErrors.concat(validate125.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.head !== undefined) {
              let data1 = data.head;
              const _errs3 = errors;
              if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                validate124.errors = [
                  {
                    instancePath: instancePath + '/head',
                    schemaPath: '#/properties/head/type',
                    keyword: 'type',
                    params: { type: 'integer' },
                    message: 'must be integer',
                  },
                ];
                return false;
              }
              if (errors === _errs3) {
                if (typeof data1 == 'number') {
                  if (data1 < 0 || isNaN(data1)) {
                    validate124.errors = [
                      {
                        instancePath: instancePath + '/head',
                        schemaPath: '#/properties/head/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0 },
                        message: 'must be >= 0',
                      },
                    ];
                    return false;
                  }
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.marks !== undefined) {
                let data2 = data.marks;
                const _errs5 = errors;
                if (errors === _errs5) {
                  if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                    for (const key1 in data2) {
                      let data3 = data2[key1];
                      const _errs8 = errors;
                      if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                        validate124.errors = [
                          {
                            instancePath:
                              instancePath +
                              '/marks/' +
                              key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                            schemaPath: '#/properties/marks/additionalProperties/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs8 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate124.errors = [
                      {
                        instancePath: instancePath + '/marks',
                        schemaPath: '#/properties/marks/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate124.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate124.errors = vErrors;
  return errors === 0;
}
validate124.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate120(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate120.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.frames === undefined && (missing0 = 'frames')) ||
        (data.checkpoints === undefined && (missing0 = 'checkpoints')) ||
        (data.grading === undefined && (missing0 = 'grading'))
      ) {
        validate120.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          const _errs1 = errors;
          if ('client' !== data.grading) {
            validate120.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.code !== undefined) {
            const _errs2 = errors;
            if (
              !validate69(data.code, {
                instancePath: instancePath + '/code',
                parentData: data,
                parentDataProperty: 'code',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.stdin !== undefined) {
              const _errs3 = errors;
              if (
                !validate71(data.stdin, {
                  instancePath: instancePath + '/stdin',
                  parentData: data,
                  parentDataProperty: 'stdin',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.frames !== undefined) {
                let data3 = data.frames;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (Array.isArray(data3)) {
                    if (data3.length > 200) {
                      validate120.errors = [
                        {
                          instancePath: instancePath + '/frames',
                          schemaPath: '#/properties/frames/maxItems',
                          keyword: 'maxItems',
                          params: { limit: 200 },
                          message: 'must NOT have more than 200 items',
                        },
                      ];
                      return false;
                    } else {
                      if (data3.length < 2) {
                        validate120.errors = [
                          {
                            instancePath: instancePath + '/frames',
                            schemaPath: '#/properties/frames/minItems',
                            keyword: 'minItems',
                            params: { limit: 2 },
                            message: 'must NOT have fewer than 2 items',
                          },
                        ];
                        return false;
                      } else {
                        var valid1 = true;
                        const len0 = data3.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          let data4 = data3[i0];
                          const _errs6 = errors;
                          if (errors === _errs6) {
                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                              let missing1;
                              if (data4.state === undefined && (missing1 = 'state')) {
                                validate120.errors = [
                                  {
                                    instancePath: instancePath + '/frames/' + i0,
                                    schemaPath: '#/properties/frames/items/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing1 },
                                    message: "must have required property '" + missing1 + "'",
                                  },
                                ];
                                return false;
                              } else {
                                const _errs8 = errors;
                                for (const key0 in data4) {
                                  if (!(key0 === 'note' || key0 === 'ticks' || key0 === 'state')) {
                                    validate120.errors = [
                                      {
                                        instancePath: instancePath + '/frames/' + i0,
                                        schemaPath:
                                          '#/properties/frames/items/additionalProperties',
                                        keyword: 'additionalProperties',
                                        params: { additionalProperty: key0 },
                                        message: 'must NOT have additional properties',
                                      },
                                    ];
                                    return false;
                                    break;
                                  }
                                }
                                if (_errs8 === errors) {
                                  if (data4.note !== undefined) {
                                    const _errs9 = errors;
                                    if (
                                      !validate63(data4.note, {
                                        instancePath: instancePath + '/frames/' + i0 + '/note',
                                        parentData: data4,
                                        parentDataProperty: 'note',
                                        rootData,
                                        dynamicAnchors,
                                      })
                                    ) {
                                      vErrors =
                                        vErrors === null
                                          ? validate63.errors
                                          : vErrors.concat(validate63.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid2 = _errs9 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data4.ticks !== undefined) {
                                      let data6 = data4.ticks;
                                      const _errs10 = errors;
                                      if (!(
                                        typeof data6 == 'number' &&
                                        !(data6 % 1) &&
                                        !isNaN(data6)
                                      )) {
                                        validate120.errors = [
                                          {
                                            instancePath: instancePath + '/frames/' + i0 + '/ticks',
                                            schemaPath:
                                              '#/properties/frames/items/properties/ticks/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer',
                                          },
                                        ];
                                        return false;
                                      }
                                      if (errors === _errs10) {
                                        if (typeof data6 == 'number') {
                                          if (data6 < 0 || isNaN(data6)) {
                                            validate120.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/frames/' + i0 + '/ticks',
                                                schemaPath:
                                                  '#/properties/frames/items/properties/ticks/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                      }
                                      var valid2 = _errs10 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data4.state !== undefined) {
                                        let data7 = data4.state;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                          if (
                                            data7 &&
                                            typeof data7 == 'object' &&
                                            !Array.isArray(data7)
                                          ) {
                                            if (Object.keys(data7).length < 1) {
                                              validate120.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/frames/' + i0 + '/state',
                                                  schemaPath:
                                                    '#/properties/frames/items/properties/state/minProperties',
                                                  keyword: 'minProperties',
                                                  params: { limit: 1 },
                                                  message: 'must NOT have fewer than 1 properties',
                                                },
                                              ];
                                              return false;
                                            } else {
                                              for (const key1 in data7) {
                                                const _errs15 = errors;
                                                if (
                                                  !validate124(data7[key1], {
                                                    instancePath:
                                                      instancePath +
                                                      '/frames/' +
                                                      i0 +
                                                      '/state/' +
                                                      key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    parentData: data7,
                                                    parentDataProperty: key1,
                                                    rootData,
                                                    dynamicAnchors,
                                                  })
                                                ) {
                                                  vErrors =
                                                    vErrors === null
                                                      ? validate124.errors
                                                      : vErrors.concat(validate124.errors);
                                                  errors = vErrors.length;
                                                }
                                                var valid3 = _errs15 === errors;
                                                if (!valid3) {
                                                  break;
                                                }
                                              }
                                            }
                                          } else {
                                            validate120.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/frames/' + i0 + '/state',
                                                schemaPath:
                                                  '#/properties/frames/items/properties/state/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                        var valid2 = _errs12 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate120.errors = [
                                {
                                  instancePath: instancePath + '/frames/' + i0,
                                  schemaPath: '#/properties/frames/items/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid1 = _errs6 === errors;
                          if (!valid1) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate120.errors = [
                      {
                        instancePath: instancePath + '/frames',
                        schemaPath: '#/properties/frames/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs4 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.checkpoints !== undefined) {
                  let data9 = data.checkpoints;
                  const _errs16 = errors;
                  if (errors === _errs16) {
                    if (Array.isArray(data9)) {
                      if (data9.length < 1) {
                        validate120.errors = [
                          {
                            instancePath: instancePath + '/checkpoints',
                            schemaPath: '#/properties/checkpoints/minItems',
                            keyword: 'minItems',
                            params: { limit: 1 },
                            message: 'must NOT have fewer than 1 items',
                          },
                        ];
                        return false;
                      } else {
                        var valid4 = true;
                        const len1 = data9.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          let data10 = data9[i1];
                          const _errs18 = errors;
                          if (errors === _errs18) {
                            if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                              let missing2;
                              if (
                                (data10.frame === undefined && (missing2 = 'frame')) ||
                                (data10.prompt === undefined && (missing2 = 'prompt')) ||
                                (data10.choices === undefined && (missing2 = 'choices')) ||
                                (data10.answer === undefined && (missing2 = 'answer'))
                              ) {
                                validate120.errors = [
                                  {
                                    instancePath: instancePath + '/checkpoints/' + i1,
                                    schemaPath: '#/properties/checkpoints/items/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing2 },
                                    message: "must have required property '" + missing2 + "'",
                                  },
                                ];
                                return false;
                              } else {
                                const _errs20 = errors;
                                for (const key2 in data10) {
                                  if (!(
                                    key2 === 'frame' ||
                                    key2 === 'prompt' ||
                                    key2 === 'choices' ||
                                    key2 === 'answer'
                                  )) {
                                    validate120.errors = [
                                      {
                                        instancePath: instancePath + '/checkpoints/' + i1,
                                        schemaPath:
                                          '#/properties/checkpoints/items/additionalProperties',
                                        keyword: 'additionalProperties',
                                        params: { additionalProperty: key2 },
                                        message: 'must NOT have additional properties',
                                      },
                                    ];
                                    return false;
                                    break;
                                  }
                                }
                                if (_errs20 === errors) {
                                  if (data10.frame !== undefined) {
                                    let data11 = data10.frame;
                                    const _errs21 = errors;
                                    if (!(
                                      typeof data11 == 'number' &&
                                      !(data11 % 1) &&
                                      !isNaN(data11)
                                    )) {
                                      validate120.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/checkpoints/' + i1 + '/frame',
                                          schemaPath:
                                            '#/properties/checkpoints/items/properties/frame/type',
                                          keyword: 'type',
                                          params: { type: 'integer' },
                                          message: 'must be integer',
                                        },
                                      ];
                                      return false;
                                    }
                                    if (errors === _errs21) {
                                      if (typeof data11 == 'number') {
                                        if (data11 < 0 || isNaN(data11)) {
                                          validate120.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/checkpoints/' + i1 + '/frame',
                                              schemaPath:
                                                '#/properties/checkpoints/items/properties/frame/minimum',
                                              keyword: 'minimum',
                                              params: { comparison: '>=', limit: 0 },
                                              message: 'must be >= 0',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                    }
                                    var valid5 = _errs21 === errors;
                                  } else {
                                    var valid5 = true;
                                  }
                                  if (valid5) {
                                    if (data10.prompt !== undefined) {
                                      const _errs23 = errors;
                                      if (
                                        !validate63(data10.prompt, {
                                          instancePath:
                                            instancePath + '/checkpoints/' + i1 + '/prompt',
                                          parentData: data10,
                                          parentDataProperty: 'prompt',
                                          rootData,
                                          dynamicAnchors,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate63.errors
                                            : vErrors.concat(validate63.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid5 = _errs23 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                    if (valid5) {
                                      if (data10.choices !== undefined) {
                                        const _errs24 = errors;
                                        if (
                                          !validate111(data10.choices, {
                                            instancePath:
                                              instancePath + '/checkpoints/' + i1 + '/choices',
                                            parentData: data10,
                                            parentDataProperty: 'choices',
                                            rootData,
                                            dynamicAnchors,
                                          })
                                        ) {
                                          vErrors =
                                            vErrors === null
                                              ? validate111.errors
                                              : vErrors.concat(validate111.errors);
                                          errors = vErrors.length;
                                        }
                                        var valid5 = _errs24 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                      if (valid5) {
                                        if (data10.answer !== undefined) {
                                          const _errs25 = errors;
                                          if (
                                            !validate114(data10.answer, {
                                              instancePath:
                                                instancePath + '/checkpoints/' + i1 + '/answer',
                                              parentData: data10,
                                              parentDataProperty: 'answer',
                                              rootData,
                                              dynamicAnchors,
                                            })
                                          ) {
                                            vErrors =
                                              vErrors === null
                                                ? validate114.errors
                                                : vErrors.concat(validate114.errors);
                                            errors = vErrors.length;
                                          }
                                          var valid5 = _errs25 === errors;
                                        } else {
                                          var valid5 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate120.errors = [
                                {
                                  instancePath: instancePath + '/checkpoints/' + i1,
                                  schemaPath: '#/properties/checkpoints/items/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid4 = _errs18 === errors;
                          if (!valid4) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate120.errors = [
                        {
                          instancePath: instancePath + '/checkpoints',
                          schemaPath: '#/properties/checkpoints/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs16 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate120.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate120.errors = vErrors;
  return errors === 0;
}
validate120.evaluated = {
  props: { grading: true, code: true, stdin: true, frames: true, checkpoints: true },
  dynamicProps: false,
  dynamicItems: false,
};
const schema47 = {
  type: 'object',
  required: ['statement', 'recall', 'grading'],
  not: { anyOf: [{ required: ['explanation'] }, { required: ['hints'] }] },
  properties: {
    grading: { const: 'client' },
    statement: { $ref: '#/$defs/markdown', maxLength: 200 },
    snippet: { $ref: '#/$defs/swiftCode', maxLength: 2000 },
    stdin: { $ref: '#/$defs/stdin' },
    expected: { type: 'string' },
    why: { $ref: '#/$defs/markdown', maxLength: 200 },
    recall: {
      type: 'object',
      required: ['question', 'answer'],
      additionalProperties: false,
      properties: {
        question: { $ref: '#/$defs/markdown', maxLength: 200 },
        answer: { $ref: '#/$defs/markdown', maxLength: 200 },
        accept: {
          type: 'array',
          minItems: 1,
          maxItems: 10,
          uniqueItems: true,
          items: { type: 'string', minLength: 1, maxLength: 200 },
        },
        match: { enum: ['trim', 'ignore-spaces'], default: 'trim' },
      },
      dependentRequired: { match: ['accept'] },
    },
  },
  dependentRequired: { stdin: ['snippet', 'expected'], expected: ['snippet'] },
};
function validate132(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate132.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs1 = errors;
  const _errs2 = errors;
  const _errs3 = errors;
  let valid1 = false;
  const _errs4 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (data.explanation === undefined && (missing0 = 'explanation')) {
      const err0 = {};
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  }
  var _valid0 = _errs4 === errors;
  valid1 = valid1 || _valid0;
  const _errs5 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing1;
    if (data.hints === undefined && (missing1 = 'hints')) {
      const err1 = {};
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
  }
  var _valid0 = _errs5 === errors;
  valid1 = valid1 || _valid0;
  if (!valid1) {
    const err2 = {};
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  } else {
    errors = _errs3;
    if (vErrors !== null) {
      if (_errs3) {
        vErrors.length = _errs3;
      } else {
        vErrors = null;
      }
    }
  }
  var valid0 = _errs2 === errors;
  if (valid0) {
    validate132.errors = [
      {
        instancePath,
        schemaPath: '#/not',
        keyword: 'not',
        params: {},
        message: 'must NOT be valid',
      },
    ];
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing2;
      if (
        (data.statement === undefined && (missing2 = 'statement')) ||
        (data.recall === undefined && (missing2 = 'recall')) ||
        (data.grading === undefined && (missing2 = 'grading'))
      ) {
        validate132.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing2 },
            message: "must have required property '" + missing2 + "'",
          },
        ];
        return false;
      } else {
        if (data.grading !== undefined) {
          const _errs6 = errors;
          if ('client' !== data.grading) {
            validate132.errors = [
              {
                instancePath: instancePath + '/grading',
                schemaPath: '#/properties/grading/const',
                keyword: 'const',
                params: { allowedValue: 'client' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid2 = _errs6 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.statement !== undefined) {
            let data1 = data.statement;
            const _errs7 = errors;
            if (
              !validate63(data1, {
                instancePath: instancePath + '/statement',
                parentData: data,
                parentDataProperty: 'statement',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
              errors = vErrors.length;
            }
            if (errors === _errs7) {
              if (typeof data1 === 'string') {
                if (func1(data1) > 200) {
                  validate132.errors = [
                    {
                      instancePath: instancePath + '/statement',
                      schemaPath: '#/properties/statement/maxLength',
                      keyword: 'maxLength',
                      params: { limit: 200 },
                      message: 'must NOT have more than 200 characters',
                    },
                  ];
                  return false;
                }
              }
            }
            var valid2 = _errs7 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.snippet !== undefined) {
              let data2 = data.snippet;
              const _errs8 = errors;
              if (
                !validate69(data2, {
                  instancePath: instancePath + '/snippet',
                  parentData: data,
                  parentDataProperty: 'snippet',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
                errors = vErrors.length;
              }
              if (errors === _errs8) {
                if (typeof data2 === 'string') {
                  if (func1(data2) > 2000) {
                    validate132.errors = [
                      {
                        instancePath: instancePath + '/snippet',
                        schemaPath: '#/properties/snippet/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 2000 },
                        message: 'must NOT have more than 2000 characters',
                      },
                    ];
                    return false;
                  }
                }
              }
              var valid2 = _errs8 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.stdin !== undefined) {
                const _errs9 = errors;
                if (
                  !validate71(data.stdin, {
                    instancePath: instancePath + '/stdin',
                    parentData: data,
                    parentDataProperty: 'stdin',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                  errors = vErrors.length;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.expected !== undefined) {
                  const _errs10 = errors;
                  if (typeof data.expected !== 'string') {
                    validate132.errors = [
                      {
                        instancePath: instancePath + '/expected',
                        schemaPath: '#/properties/expected/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs10 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.why !== undefined) {
                    let data5 = data.why;
                    const _errs12 = errors;
                    if (
                      !validate63(data5, {
                        instancePath: instancePath + '/why',
                        parentData: data,
                        parentDataProperty: 'why',
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                      errors = vErrors.length;
                    }
                    if (errors === _errs12) {
                      if (typeof data5 === 'string') {
                        if (func1(data5) > 200) {
                          validate132.errors = [
                            {
                              instancePath: instancePath + '/why',
                              schemaPath: '#/properties/why/maxLength',
                              keyword: 'maxLength',
                              params: { limit: 200 },
                              message: 'must NOT have more than 200 characters',
                            },
                          ];
                          return false;
                        }
                      }
                    }
                    var valid2 = _errs12 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data.recall !== undefined) {
                      let data6 = data.recall;
                      const _errs13 = errors;
                      if (errors === _errs13) {
                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                          let missing3;
                          if (
                            (data6.question === undefined && (missing3 = 'question')) ||
                            (data6.answer === undefined && (missing3 = 'answer'))
                          ) {
                            validate132.errors = [
                              {
                                instancePath: instancePath + '/recall',
                                schemaPath: '#/properties/recall/required',
                                keyword: 'required',
                                params: { missingProperty: missing3 },
                                message: "must have required property '" + missing3 + "'",
                              },
                            ];
                            return false;
                          } else {
                            const _errs15 = errors;
                            for (const key0 in data6) {
                              if (!(
                                key0 === 'question' ||
                                key0 === 'answer' ||
                                key0 === 'accept' ||
                                key0 === 'match'
                              )) {
                                validate132.errors = [
                                  {
                                    instancePath: instancePath + '/recall',
                                    schemaPath: '#/properties/recall/additionalProperties',
                                    keyword: 'additionalProperties',
                                    params: { additionalProperty: key0 },
                                    message: 'must NOT have additional properties',
                                  },
                                ];
                                return false;
                                break;
                              }
                            }
                            if (_errs15 === errors) {
                              if (data6.question !== undefined) {
                                let data7 = data6.question;
                                const _errs16 = errors;
                                if (
                                  !validate63(data7, {
                                    instancePath: instancePath + '/recall/question',
                                    parentData: data6,
                                    parentDataProperty: 'question',
                                    rootData,
                                    dynamicAnchors,
                                  })
                                ) {
                                  vErrors =
                                    vErrors === null
                                      ? validate63.errors
                                      : vErrors.concat(validate63.errors);
                                  errors = vErrors.length;
                                }
                                if (errors === _errs16) {
                                  if (typeof data7 === 'string') {
                                    if (func1(data7) > 200) {
                                      validate132.errors = [
                                        {
                                          instancePath: instancePath + '/recall/question',
                                          schemaPath:
                                            '#/properties/recall/properties/question/maxLength',
                                          keyword: 'maxLength',
                                          params: { limit: 200 },
                                          message: 'must NOT have more than 200 characters',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                }
                                var valid3 = _errs16 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data6.answer !== undefined) {
                                  let data8 = data6.answer;
                                  const _errs17 = errors;
                                  if (
                                    !validate63(data8, {
                                      instancePath: instancePath + '/recall/answer',
                                      parentData: data6,
                                      parentDataProperty: 'answer',
                                      rootData,
                                      dynamicAnchors,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate63.errors
                                        : vErrors.concat(validate63.errors);
                                    errors = vErrors.length;
                                  }
                                  if (errors === _errs17) {
                                    if (typeof data8 === 'string') {
                                      if (func1(data8) > 200) {
                                        validate132.errors = [
                                          {
                                            instancePath: instancePath + '/recall/answer',
                                            schemaPath:
                                              '#/properties/recall/properties/answer/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 200 },
                                            message: 'must NOT have more than 200 characters',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                  }
                                  var valid3 = _errs17 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data6.accept !== undefined) {
                                    let data9 = data6.accept;
                                    const _errs18 = errors;
                                    if (errors === _errs18) {
                                      if (Array.isArray(data9)) {
                                        if (data9.length > 10) {
                                          validate132.errors = [
                                            {
                                              instancePath: instancePath + '/recall/accept',
                                              schemaPath:
                                                '#/properties/recall/properties/accept/maxItems',
                                              keyword: 'maxItems',
                                              params: { limit: 10 },
                                              message: 'must NOT have more than 10 items',
                                            },
                                          ];
                                          return false;
                                        } else {
                                          if (data9.length < 1) {
                                            validate132.errors = [
                                              {
                                                instancePath: instancePath + '/recall/accept',
                                                schemaPath:
                                                  '#/properties/recall/properties/accept/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items',
                                              },
                                            ];
                                            return false;
                                          } else {
                                            var valid4 = true;
                                            const len0 = data9.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                              let data10 = data9[i0];
                                              const _errs20 = errors;
                                              if (errors === _errs20) {
                                                if (typeof data10 === 'string') {
                                                  if (func1(data10) > 200) {
                                                    validate132.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath + '/recall/accept/' + i0,
                                                        schemaPath:
                                                          '#/properties/recall/properties/accept/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 200 },
                                                        message:
                                                          'must NOT have more than 200 characters',
                                                      },
                                                    ];
                                                    return false;
                                                  } else {
                                                    if (func1(data10) < 1) {
                                                      validate132.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath + '/recall/accept/' + i0,
                                                          schemaPath:
                                                            '#/properties/recall/properties/accept/items/minLength',
                                                          keyword: 'minLength',
                                                          params: { limit: 1 },
                                                          message:
                                                            'must NOT have fewer than 1 characters',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                  }
                                                } else {
                                                  validate132.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath + '/recall/accept/' + i0,
                                                      schemaPath:
                                                        '#/properties/recall/properties/accept/items/type',
                                                      keyword: 'type',
                                                      params: { type: 'string' },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              }
                                              var valid4 = _errs20 === errors;
                                              if (!valid4) {
                                                break;
                                              }
                                            }
                                            if (valid4) {
                                              let i1 = data9.length;
                                              let j0;
                                              if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                  let item0 = data9[i1];
                                                  if (typeof item0 !== 'string') {
                                                    continue;
                                                  }
                                                  if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate132.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath + '/recall/accept',
                                                        schemaPath:
                                                          '#/properties/recall/properties/accept/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message:
                                                          'must NOT have duplicate items (items ## ' +
                                                          j0 +
                                                          ' and ' +
                                                          i1 +
                                                          ' are identical)',
                                                      },
                                                    ];
                                                    return false;
                                                    break;
                                                  }
                                                  indices0[item0] = i1;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        validate132.errors = [
                                          {
                                            instancePath: instancePath + '/recall/accept',
                                            schemaPath:
                                              '#/properties/recall/properties/accept/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                    var valid3 = _errs18 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data6.match !== undefined) {
                                      let data11 = data6.match;
                                      const _errs22 = errors;
                                      if (!(data11 === 'trim' || data11 === 'ignore-spaces')) {
                                        validate132.errors = [
                                          {
                                            instancePath: instancePath + '/recall/match',
                                            schemaPath: '#/properties/recall/properties/match/enum',
                                            keyword: 'enum',
                                            params: {
                                              allowedValues:
                                                schema47.properties.recall.properties.match.enum,
                                            },
                                            message: 'must be equal to one of the allowed values',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs22 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      let missing4;
                                      if (
                                        data6.match !== undefined &&
                                        data6.accept === undefined &&
                                        (missing4 = 'accept')
                                      ) {
                                        validate132.errors = [
                                          {
                                            instancePath: instancePath + '/recall',
                                            schemaPath: '#/properties/recall/dependentRequired',
                                            keyword: 'dependentRequired',
                                            params: {
                                              property: 'match',
                                              missingProperty: missing4,
                                              depsCount: 1,
                                              deps: 'accept',
                                            },
                                            message:
                                              'must have property accept when property match is present',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate132.errors = [
                            {
                              instancePath: instancePath + '/recall',
                              schemaPath: '#/properties/recall/type',
                              keyword: 'type',
                              params: { type: 'object' },
                              message: 'must be object',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid2 = _errs13 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      let missing5;
                      if (
                        data.stdin !== undefined &&
                        ((data.snippet === undefined && (missing5 = 'snippet')) ||
                          (data.expected === undefined && (missing5 = 'expected')))
                      ) {
                        validate132.errors = [
                          {
                            instancePath,
                            schemaPath: '#/dependentRequired',
                            keyword: 'dependentRequired',
                            params: {
                              property: 'stdin',
                              missingProperty: missing5,
                              depsCount: 2,
                              deps: 'snippet, expected',
                            },
                            message:
                              'must have properties snippet, expected when property stdin is present',
                          },
                        ];
                        return false;
                      } else {
                        if (
                          data.expected !== undefined &&
                          data.snippet === undefined &&
                          (missing5 = 'snippet')
                        ) {
                          validate132.errors = [
                            {
                              instancePath,
                              schemaPath: '#/dependentRequired',
                              keyword: 'dependentRequired',
                              params: {
                                property: 'expected',
                                missingProperty: missing5,
                                depsCount: 1,
                                deps: 'snippet',
                              },
                              message:
                                'must have property snippet when property expected is present',
                            },
                          ];
                          return false;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate132.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate132.errors = vErrors;
  return errors === 0;
}
validate132.evaluated = {
  props: {
    grading: true,
    statement: true,
    snippet: true,
    stdin: true,
    expected: true,
    why: true,
    recall: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
function validate54(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate54.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs1 = errors;
  if (
    !validate55(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })
  ) {
    vErrors = vErrors === null ? validate55.errors : vErrors.concat(validate55.errors);
    errors = vErrors.length;
  }
  var valid0 = _errs1 === errors;
  if (valid0) {
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = true;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.type === undefined && (missing0 = 'type')) {
        const err0 = {};
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.type !== undefined) {
          if ('predict-output' !== data.type) {
            const err1 = {};
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      }
    }
    var _valid0 = _errs4 === errors;
    errors = _errs3;
    if (vErrors !== null) {
      if (_errs3) {
        vErrors.length = _errs3;
      } else {
        vErrors = null;
      }
    }
    if (_valid0) {
      const _errs6 = errors;
      if (
        !validate68(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
          dynamicAnchors,
        })
      ) {
        vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs6 === errors;
      valid1 = _valid0;
      if (valid1) {
        var props0 = {};
        props0.grading = true;
        props0.code = true;
        props0.stdin = true;
        props0.outcome = true;
        props0.expected = true;
        props0.choices = true;
        props0.type = true;
      }
    }
    if (!valid1) {
      const err2 = {
        instancePath,
        schemaPath: '#/allOf/1/if',
        keyword: 'if',
        params: { failingKeyword: 'then' },
        message: 'must match "then" schema',
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
      validate54.errors = vErrors;
      return false;
    }
    var valid0 = _errs2 === errors;
    if (valid0) {
      if (props0 !== true) {
        props0 = props0 || {};
        props0.id = true;
        props0.type = true;
        props0.unit = true;
        props0.stage = true;
        props0.title = true;
        props0.useCase = true;
        props0.textbook = true;
        props0.difficulty = true;
        props0.tags = true;
        props0.hints = true;
        props0.explanation = true;
        props0.formerIds = true;
        props0.draft = true;
        props0.order = true;
        props0.grading = true;
      }
      const _errs7 = errors;
      const _errs8 = errors;
      let valid3 = true;
      const _errs9 = errors;
      if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing1;
        if (data.type === undefined && (missing1 = 'type')) {
          const err3 = {};
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        } else {
          if (data.type !== undefined) {
            if ('fill-blank' !== data.type) {
              const err4 = {};
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
          }
        }
      }
      var _valid1 = _errs9 === errors;
      errors = _errs8;
      if (vErrors !== null) {
        if (_errs8) {
          vErrors.length = _errs8;
        } else {
          vErrors = null;
        }
      }
      if (_valid1) {
        const _errs11 = errors;
        if (
          !validate74(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
            dynamicAnchors,
          })
        ) {
          vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
          errors = vErrors.length;
        }
        var _valid1 = _errs11 === errors;
        valid3 = _valid1;
        if (valid3) {
          var props1 = {};
          props1.grading = true;
          props1.template = true;
          props1.blanks = true;
          props1.stdin = true;
          props1.expected = true;
          props1.type = true;
        }
      }
      if (!valid3) {
        const err5 = {
          instancePath,
          schemaPath: '#/allOf/2/if',
          keyword: 'if',
          params: { failingKeyword: 'then' },
          message: 'must match "then" schema',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
        validate54.errors = vErrors;
        return false;
      }
      var valid0 = _errs7 === errors;
      if (valid0) {
        if (props0 !== true && props1 !== undefined) {
          if (props1 === true) {
            props0 = true;
          } else {
            props0 = props0 || {};
            Object.assign(props0, props1);
          }
        }
        const _errs12 = errors;
        const _errs13 = errors;
        let valid5 = true;
        const _errs14 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
          let missing2;
          if (data.type === undefined && (missing2 = 'type')) {
            const err6 = {};
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          } else {
            if (data.type !== undefined) {
              if ('parsons' !== data.type) {
                const err7 = {};
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
          }
        }
        var _valid2 = _errs14 === errors;
        errors = _errs13;
        if (vErrors !== null) {
          if (_errs13) {
            vErrors.length = _errs13;
          } else {
            vErrors = null;
          }
        }
        if (_valid2) {
          const _errs16 = errors;
          if (
            !validate77(data, {
              instancePath,
              parentData,
              parentDataProperty,
              rootData,
              dynamicAnchors,
            })
          ) {
            vErrors = vErrors === null ? validate77.errors : vErrors.concat(validate77.errors);
            errors = vErrors.length;
          }
          var _valid2 = _errs16 === errors;
          valid5 = _valid2;
          if (valid5) {
            var props2 = {};
            props2.grading = true;
            props2.lines = true;
            props2.distractors = true;
            props2.alternatives = true;
            props2.stdin = true;
            props2.expected = true;
            props2.type = true;
          }
        }
        if (!valid5) {
          const err8 = {
            instancePath,
            schemaPath: '#/allOf/3/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema',
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
          validate54.errors = vErrors;
          return false;
        }
        var valid0 = _errs12 === errors;
        if (valid0) {
          if (props0 !== true && props2 !== undefined) {
            if (props2 === true) {
              props0 = true;
            } else {
              props0 = props0 || {};
              Object.assign(props0, props2);
            }
          }
          const _errs17 = errors;
          const _errs18 = errors;
          let valid7 = true;
          const _errs19 = errors;
          if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if (data.type === undefined && (missing3 = 'type')) {
              const err9 = {};
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            } else {
              if (data.type !== undefined) {
                if ('choice' !== data.type) {
                  const err10 = {};
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
              }
            }
          }
          var _valid3 = _errs19 === errors;
          errors = _errs18;
          if (vErrors !== null) {
            if (_errs18) {
              vErrors.length = _errs18;
            } else {
              vErrors = null;
            }
          }
          if (_valid3) {
            const _errs21 = errors;
            if (
              !validate80(data, {
                instancePath,
                parentData,
                parentDataProperty,
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate80.errors : vErrors.concat(validate80.errors);
              errors = vErrors.length;
            } else {
              var props3 = validate80.evaluated.props;
            }
            var _valid3 = _errs21 === errors;
            valid7 = _valid3;
            if (valid7) {
              if (props3 !== true) {
                props3 = props3 || {};
                props3.type = true;
              }
            }
          }
          if (!valid7) {
            const err11 = {
              instancePath,
              schemaPath: '#/allOf/4/if',
              keyword: 'if',
              params: { failingKeyword: 'then' },
              message: 'must match "then" schema',
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
            validate54.errors = vErrors;
            return false;
          }
          var valid0 = _errs17 === errors;
          if (valid0) {
            if (props0 !== true && props3 !== undefined) {
              if (props3 === true) {
                props0 = true;
              } else {
                props0 = props0 || {};
                Object.assign(props0, props3);
              }
            }
            const _errs22 = errors;
            const _errs23 = errors;
            let valid9 = true;
            const _errs24 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
              let missing4;
              if (data.type === undefined && (missing4 = 'type')) {
                const err12 = {};
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              } else {
                if (data.type !== undefined) {
                  if ('reduce' !== data.type) {
                    const err13 = {};
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                }
              }
            }
            var _valid4 = _errs24 === errors;
            errors = _errs23;
            if (vErrors !== null) {
              if (_errs23) {
                vErrors.length = _errs23;
              } else {
                vErrors = null;
              }
            }
            if (_valid4) {
              const _errs26 = errors;
              if (
                !validate90(data, {
                  instancePath,
                  parentData,
                  parentDataProperty,
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate90.errors : vErrors.concat(validate90.errors);
                errors = vErrors.length;
              }
              var _valid4 = _errs26 === errors;
              valid9 = _valid4;
              if (valid9) {
                var props4 = {};
                props4.grading = true;
                props4.problem = true;
                props4.constraints = true;
                props4.choices = true;
                props4.reason = true;
                props4.ops = true;
                props4.type = true;
              }
            }
            if (!valid9) {
              const err14 = {
                instancePath,
                schemaPath: '#/allOf/5/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema',
              };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
              validate54.errors = vErrors;
              return false;
            }
            var valid0 = _errs22 === errors;
            if (valid0) {
              if (props0 !== true && props4 !== undefined) {
                if (props4 === true) {
                  props0 = true;
                } else {
                  props0 = props0 || {};
                  Object.assign(props0, props4);
                }
              }
              const _errs27 = errors;
              const _errs28 = errors;
              let valid11 = true;
              const _errs29 = errors;
              if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing5;
                if (data.type === undefined && (missing5 = 'type')) {
                  const err15 = {};
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                } else {
                  if (data.type !== undefined) {
                    if ('complexity-quiz' !== data.type) {
                      const err16 = {};
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                    }
                  }
                }
              }
              var _valid5 = _errs29 === errors;
              errors = _errs28;
              if (vErrors !== null) {
                if (_errs28) {
                  vErrors.length = _errs28;
                } else {
                  vErrors = null;
                }
              }
              if (_valid5) {
                const _errs31 = errors;
                if (
                  !validate100(data, {
                    instancePath,
                    parentData,
                    parentDataProperty,
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
                  errors = vErrors.length;
                } else {
                  var props5 = validate100.evaluated.props;
                }
                var _valid5 = _errs31 === errors;
                valid11 = _valid5;
                if (valid11) {
                  if (props5 !== true) {
                    props5 = props5 || {};
                    props5.type = true;
                  }
                }
              }
              if (!valid11) {
                const err17 = {
                  instancePath,
                  schemaPath: '#/allOf/6/if',
                  keyword: 'if',
                  params: { failingKeyword: 'then' },
                  message: 'must match "then" schema',
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
                validate54.errors = vErrors;
                return false;
              }
              var valid0 = _errs27 === errors;
              if (valid0) {
                if (props0 !== true && props5 !== undefined) {
                  if (props5 === true) {
                    props0 = true;
                  } else {
                    props0 = props0 || {};
                    Object.assign(props0, props5);
                  }
                }
                const _errs32 = errors;
                const _errs33 = errors;
                let valid13 = true;
                const _errs34 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                  let missing6;
                  if (data.type === undefined && (missing6 = 'type')) {
                    const err18 = {};
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  } else {
                    if (data.type !== undefined) {
                      if ('write-ac' !== data.type) {
                        const err19 = {};
                        if (vErrors === null) {
                          vErrors = [err19];
                        } else {
                          vErrors.push(err19);
                        }
                        errors++;
                      }
                    }
                  }
                }
                var _valid6 = _errs34 === errors;
                errors = _errs33;
                if (vErrors !== null) {
                  if (_errs33) {
                    vErrors.length = _errs33;
                  } else {
                    vErrors = null;
                  }
                }
                if (_valid6) {
                  const _errs36 = errors;
                  if (
                    !validate106(data, {
                      instancePath,
                      parentData,
                      parentDataProperty,
                      rootData,
                      dynamicAnchors,
                    })
                  ) {
                    vErrors =
                      vErrors === null ? validate106.errors : vErrors.concat(validate106.errors);
                    errors = vErrors.length;
                  }
                  var _valid6 = _errs36 === errors;
                  valid13 = _valid6;
                  if (valid13) {
                    var props6 = {};
                    props6.grading = true;
                    props6.statement = true;
                    props6.starter = true;
                    props6.solution = true;
                    props6.cases = true;
                    props6.source = true;
                    props6.preflight = true;
                    props6.meter = true;
                    props6.type = true;
                  }
                }
                if (!valid13) {
                  const err20 = {
                    instancePath,
                    schemaPath: '#/allOf/7/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema',
                  };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                  validate54.errors = vErrors;
                  return false;
                }
                var valid0 = _errs32 === errors;
                if (valid0) {
                  if (props0 !== true && props6 !== undefined) {
                    if (props6 === true) {
                      props0 = true;
                    } else {
                      props0 = props0 || {};
                      Object.assign(props0, props6);
                    }
                  }
                  const _errs37 = errors;
                  const _errs38 = errors;
                  let valid15 = true;
                  const _errs39 = errors;
                  if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing7;
                    if (data.type === undefined && (missing7 = 'type')) {
                      const err21 = {};
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                    } else {
                      if (data.type !== undefined) {
                        if ('viz-step' !== data.type) {
                          const err22 = {};
                          if (vErrors === null) {
                            vErrors = [err22];
                          } else {
                            vErrors.push(err22);
                          }
                          errors++;
                        }
                      }
                    }
                  }
                  var _valid7 = _errs39 === errors;
                  errors = _errs38;
                  if (vErrors !== null) {
                    if (_errs38) {
                      vErrors.length = _errs38;
                    } else {
                      vErrors = null;
                    }
                  }
                  if (_valid7) {
                    const _errs41 = errors;
                    if (
                      !validate120(data, {
                        instancePath,
                        parentData,
                        parentDataProperty,
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
                      errors = vErrors.length;
                    }
                    var _valid7 = _errs41 === errors;
                    valid15 = _valid7;
                    if (valid15) {
                      var props7 = {};
                      props7.grading = true;
                      props7.code = true;
                      props7.stdin = true;
                      props7.frames = true;
                      props7.checkpoints = true;
                      props7.type = true;
                    }
                  }
                  if (!valid15) {
                    const err23 = {
                      instancePath,
                      schemaPath: '#/allOf/8/if',
                      keyword: 'if',
                      params: { failingKeyword: 'then' },
                      message: 'must match "then" schema',
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                    validate54.errors = vErrors;
                    return false;
                  }
                  var valid0 = _errs37 === errors;
                  if (valid0) {
                    if (props0 !== true && props7 !== undefined) {
                      if (props7 === true) {
                        props0 = true;
                      } else {
                        props0 = props0 || {};
                        Object.assign(props0, props7);
                      }
                    }
                    const _errs42 = errors;
                    const _errs43 = errors;
                    let valid17 = true;
                    const _errs44 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                      let missing8;
                      if (data.type === undefined && (missing8 = 'type')) {
                        const err24 = {};
                        if (vErrors === null) {
                          vErrors = [err24];
                        } else {
                          vErrors.push(err24);
                        }
                        errors++;
                      } else {
                        if (data.type !== undefined) {
                          if ('memo' !== data.type) {
                            const err25 = {};
                            if (vErrors === null) {
                              vErrors = [err25];
                            } else {
                              vErrors.push(err25);
                            }
                            errors++;
                          }
                        }
                      }
                    }
                    var _valid8 = _errs44 === errors;
                    errors = _errs43;
                    if (vErrors !== null) {
                      if (_errs43) {
                        vErrors.length = _errs43;
                      } else {
                        vErrors = null;
                      }
                    }
                    let ifClause0;
                    if (_valid8) {
                      const _errs46 = errors;
                      if (
                        !validate132(data, {
                          instancePath,
                          parentData,
                          parentDataProperty,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate132.errors
                            : vErrors.concat(validate132.errors);
                        errors = vErrors.length;
                      }
                      var _valid8 = _errs46 === errors;
                      valid17 = _valid8;
                      if (valid17) {
                        var props8 = {};
                        props8.grading = true;
                        props8.statement = true;
                        props8.snippet = true;
                        props8.stdin = true;
                        props8.expected = true;
                        props8.why = true;
                        props8.recall = true;
                        props8.type = true;
                      }
                      ifClause0 = 'then';
                    } else {
                      const _errs47 = errors;
                      if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing9;
                        if (
                          (data.textbook === undefined && (missing9 = 'textbook')) ||
                          (data.explanation === undefined && (missing9 = 'explanation'))
                        ) {
                          validate54.errors = [
                            {
                              instancePath,
                              schemaPath: '#/allOf/9/else/required',
                              keyword: 'required',
                              params: { missingProperty: missing9 },
                              message: "must have required property '" + missing9 + "'",
                            },
                          ];
                          return false;
                        }
                      }
                      var _valid8 = _errs47 === errors;
                      valid17 = _valid8;
                      ifClause0 = 'else';
                    }
                    if (!valid17) {
                      const err26 = {
                        instancePath,
                        schemaPath: '#/allOf/9/if',
                        keyword: 'if',
                        params: { failingKeyword: ifClause0 },
                        message: 'must match "' + ifClause0 + '" schema',
                      };
                      if (vErrors === null) {
                        vErrors = [err26];
                      } else {
                        vErrors.push(err26);
                      }
                      errors++;
                      validate54.errors = vErrors;
                      return false;
                    }
                    var valid0 = _errs42 === errors;
                    if (valid0) {
                      if (props0 !== true && props8 !== undefined) {
                        if (props8 === true) {
                          props0 = true;
                        } else {
                          props0 = props0 || {};
                          Object.assign(props0, props8);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (props0 !== true) {
        for (const key0 in data) {
          if (!props0 || !props0[key0]) {
            validate54.errors = [
              {
                instancePath,
                schemaPath: '#/unevaluatedProperties',
                keyword: 'unevaluatedProperties',
                params: { unevaluatedProperty: key0 },
                message: 'must NOT have unevaluated properties',
              },
            ];
            return false;
            break;
          }
        }
      }
    } else {
      validate54.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate54.errors = vErrors;
  return errors === 0;
}
validate54.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate53(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate53.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.schemaVersion === undefined && (missing0 = 'schemaVersion')) ||
        (data.cards === undefined && (missing0 = 'cards'))
      ) {
        validate53.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'schemaVersion' || key0 === 'cards')) {
            validate53.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.schemaVersion !== undefined) {
            const _errs2 = errors;
            if (1 !== data.schemaVersion) {
              validate53.errors = [
                {
                  instancePath: instancePath + '/schemaVersion',
                  schemaPath: '#/properties/schemaVersion/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cards !== undefined) {
              let data1 = data.cards;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (Array.isArray(data1)) {
                  if (data1.length < 1) {
                    validate53.errors = [
                      {
                        instancePath: instancePath + '/cards',
                        schemaPath: '#/properties/cards/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                      },
                    ];
                    return false;
                  } else {
                    var valid1 = true;
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs5 = errors;
                      if (
                        !validate54(data1[i0], {
                          instancePath: instancePath + '/cards/' + i0,
                          parentData: data1,
                          parentDataProperty: i0,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  }
                } else {
                  validate53.errors = [
                    {
                      instancePath: instancePath + '/cards',
                      schemaPath: '#/properties/cards/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate53.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate53.errors = vErrors;
  return errors === 0;
}
validate53.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const schema48 = {
  type: 'object',
  required: ['schemaVersion', 'kind', 'textbooks', 'units'],
  additionalProperties: false,
  properties: {
    schemaVersion: { const: 1 },
    kind: { const: 'use-cases' },
    textbooks: {
      type: 'object',
      propertyNames: {
        pattern: '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
      },
      additionalProperties: { $ref: '#/$defs/useCaseText' },
    },
    units: {
      type: 'object',
      propertyNames: { $ref: '#/$defs/kebab' },
      additionalProperties: { $ref: '#/$defs/useCaseText' },
    },
  },
};
function validate142(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate142.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.schemaVersion === undefined && (missing0 = 'schemaVersion')) ||
        (data.kind === undefined && (missing0 = 'kind')) ||
        (data.textbooks === undefined && (missing0 = 'textbooks')) ||
        (data.units === undefined && (missing0 = 'units'))
      ) {
        validate142.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'schemaVersion' ||
            key0 === 'kind' ||
            key0 === 'textbooks' ||
            key0 === 'units'
          )) {
            validate142.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.schemaVersion !== undefined) {
            const _errs2 = errors;
            if (1 !== data.schemaVersion) {
              validate142.errors = [
                {
                  instancePath: instancePath + '/schemaVersion',
                  schemaPath: '#/properties/schemaVersion/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.kind !== undefined) {
              const _errs3 = errors;
              if ('use-cases' !== data.kind) {
                validate142.errors = [
                  {
                    instancePath: instancePath + '/kind',
                    schemaPath: '#/properties/kind/const',
                    keyword: 'const',
                    params: { allowedValue: 'use-cases' },
                    message: 'must be equal to constant',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.textbooks !== undefined) {
                let data2 = data.textbooks;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                    for (const key1 in data2) {
                      const _errs6 = errors;
                      if (typeof key1 === 'string') {
                        if (!pattern10.test(key1)) {
                          const err0 = {
                            instancePath: instancePath + '/textbooks',
                            schemaPath: '#/properties/textbooks/propertyNames/pattern',
                            keyword: 'pattern',
                            params: {
                              pattern:
                                '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
                            },
                            message:
                              'must match pattern "' +
                              '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$' +
                              '"',
                            propertyName: key1,
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        }
                      }
                      var valid1 = _errs6 === errors;
                      if (!valid1) {
                        const err1 = {
                          instancePath: instancePath + '/textbooks',
                          schemaPath: '#/properties/textbooks/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key1 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                        validate142.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid1) {
                      for (const key2 in data2) {
                        const _errs8 = errors;
                        if (
                          !validate60(data2[key2], {
                            instancePath:
                              instancePath +
                              '/textbooks/' +
                              key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                            parentData: data2,
                            parentDataProperty: key2,
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate60.errors
                              : vErrors.concat(validate60.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs8 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate142.errors = [
                      {
                        instancePath: instancePath + '/textbooks',
                        schemaPath: '#/properties/textbooks/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs4 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.units !== undefined) {
                  let data4 = data.units;
                  const _errs9 = errors;
                  if (errors === _errs9) {
                    if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                      for (const key3 in data4) {
                        const _errs11 = errors;
                        if (
                          !validate58(key3, {
                            instancePath: instancePath + '/units',
                            parentData: data4,
                            parentDataProperty: 'units',
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate58.errors
                              : vErrors.concat(validate58.errors);
                          errors = vErrors.length;
                        }
                        var valid3 = _errs11 === errors;
                        if (!valid3) {
                          const err2 = {
                            instancePath: instancePath + '/units',
                            schemaPath: '#/properties/units/propertyNames',
                            keyword: 'propertyNames',
                            params: { propertyName: key3 },
                            message: 'property name must be valid',
                          };
                          if (vErrors === null) {
                            vErrors = [err2];
                          } else {
                            vErrors.push(err2);
                          }
                          errors++;
                          validate142.errors = vErrors;
                          return false;
                          break;
                        }
                      }
                      if (valid3) {
                        for (const key4 in data4) {
                          const _errs13 = errors;
                          if (
                            !validate60(data4[key4], {
                              instancePath:
                                instancePath +
                                '/units/' +
                                key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                              parentData: data4,
                              parentDataProperty: key4,
                              rootData,
                              dynamicAnchors,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate60.errors
                                : vErrors.concat(validate60.errors);
                            errors = vErrors.length;
                          }
                          var valid4 = _errs13 === errors;
                          if (!valid4) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate142.errors = [
                        {
                          instancePath: instancePath + '/units',
                          schemaPath: '#/properties/units/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate142.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate142.errors = vErrors;
  return errors === 0;
}
validate142.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate52(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  /*# sourceURL="https://class.inductor.dev/schemas/card.schema.json" */ let vErrors = null;
  let errors = 0;
  const evaluated0 = validate52.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  if (
    !validate53(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })
  ) {
    vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs2 = errors;
  if (
    !validate142(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })
  ) {
    vErrors = vErrors === null ? validate142.errors : vErrors.concat(validate142.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate52.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate52.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate52.evaluated = { dynamicProps: true, dynamicItems: false };
export const validateCardFile = validate147;
function validate147(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate147.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.schemaVersion === undefined && (missing0 = 'schemaVersion')) ||
        (data.cards === undefined && (missing0 = 'cards'))
      ) {
        validate147.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'schemaVersion' || key0 === 'cards')) {
            validate147.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.schemaVersion !== undefined) {
            const _errs2 = errors;
            if (1 !== data.schemaVersion) {
              validate147.errors = [
                {
                  instancePath: instancePath + '/schemaVersion',
                  schemaPath: '#/properties/schemaVersion/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cards !== undefined) {
              let data1 = data.cards;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (Array.isArray(data1)) {
                  if (data1.length < 1) {
                    validate147.errors = [
                      {
                        instancePath: instancePath + '/cards',
                        schemaPath: '#/properties/cards/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                      },
                    ];
                    return false;
                  } else {
                    var valid1 = true;
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs5 = errors;
                      if (
                        !validate54(data1[i0], {
                          instancePath: instancePath + '/cards/' + i0,
                          parentData: data1,
                          parentDataProperty: i0,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  }
                } else {
                  validate147.errors = [
                    {
                      instancePath: instancePath + '/cards',
                      schemaPath: '#/properties/cards/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate147.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate147.errors = vErrors;
  return errors === 0;
}
validate147.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
export const validateUseCasesFile = validate149;
function validate149(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate149.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.schemaVersion === undefined && (missing0 = 'schemaVersion')) ||
        (data.kind === undefined && (missing0 = 'kind')) ||
        (data.textbooks === undefined && (missing0 = 'textbooks')) ||
        (data.units === undefined && (missing0 = 'units'))
      ) {
        validate149.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'schemaVersion' ||
            key0 === 'kind' ||
            key0 === 'textbooks' ||
            key0 === 'units'
          )) {
            validate149.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.schemaVersion !== undefined) {
            const _errs2 = errors;
            if (1 !== data.schemaVersion) {
              validate149.errors = [
                {
                  instancePath: instancePath + '/schemaVersion',
                  schemaPath: '#/properties/schemaVersion/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.kind !== undefined) {
              const _errs3 = errors;
              if ('use-cases' !== data.kind) {
                validate149.errors = [
                  {
                    instancePath: instancePath + '/kind',
                    schemaPath: '#/properties/kind/const',
                    keyword: 'const',
                    params: { allowedValue: 'use-cases' },
                    message: 'must be equal to constant',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.textbooks !== undefined) {
                let data2 = data.textbooks;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                    for (const key1 in data2) {
                      const _errs6 = errors;
                      if (typeof key1 === 'string') {
                        if (!pattern10.test(key1)) {
                          const err0 = {
                            instancePath: instancePath + '/textbooks',
                            schemaPath: '#/properties/textbooks/propertyNames/pattern',
                            keyword: 'pattern',
                            params: {
                              pattern:
                                '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$',
                            },
                            message:
                              'must match pattern "' +
                              '^/(intro|basics|compute|kyopro|algo|arai60|appendix)/[0-9]{2}-[a-z0-9-]+/$' +
                              '"',
                            propertyName: key1,
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        }
                      }
                      var valid1 = _errs6 === errors;
                      if (!valid1) {
                        const err1 = {
                          instancePath: instancePath + '/textbooks',
                          schemaPath: '#/properties/textbooks/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key1 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                        validate149.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid1) {
                      for (const key2 in data2) {
                        const _errs8 = errors;
                        if (
                          !validate60(data2[key2], {
                            instancePath:
                              instancePath +
                              '/textbooks/' +
                              key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                            parentData: data2,
                            parentDataProperty: key2,
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate60.errors
                              : vErrors.concat(validate60.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs8 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate149.errors = [
                      {
                        instancePath: instancePath + '/textbooks',
                        schemaPath: '#/properties/textbooks/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs4 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.units !== undefined) {
                  let data4 = data.units;
                  const _errs9 = errors;
                  if (errors === _errs9) {
                    if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                      for (const key3 in data4) {
                        const _errs11 = errors;
                        if (
                          !validate58(key3, {
                            instancePath: instancePath + '/units',
                            parentData: data4,
                            parentDataProperty: 'units',
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate58.errors
                              : vErrors.concat(validate58.errors);
                          errors = vErrors.length;
                        }
                        var valid3 = _errs11 === errors;
                        if (!valid3) {
                          const err2 = {
                            instancePath: instancePath + '/units',
                            schemaPath: '#/properties/units/propertyNames',
                            keyword: 'propertyNames',
                            params: { propertyName: key3 },
                            message: 'property name must be valid',
                          };
                          if (vErrors === null) {
                            vErrors = [err2];
                          } else {
                            vErrors.push(err2);
                          }
                          errors++;
                          validate149.errors = vErrors;
                          return false;
                          break;
                        }
                      }
                      if (valid3) {
                        for (const key4 in data4) {
                          const _errs13 = errors;
                          if (
                            !validate60(data4[key4], {
                              instancePath:
                                instancePath +
                                '/units/' +
                                key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                              parentData: data4,
                              parentDataProperty: key4,
                              rootData,
                              dynamicAnchors,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate60.errors
                                : vErrors.concat(validate60.errors);
                            errors = vErrors.length;
                          }
                          var valid4 = _errs13 === errors;
                          if (!valid4) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate149.errors = [
                        {
                          instancePath: instancePath + '/units',
                          schemaPath: '#/properties/units/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate149.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate149.errors = vErrors;
  return errors === 0;
}
validate149.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
export const validateCard = validate153;
function validate153(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate153.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  const _errs1 = errors;
  if (
    !validate55(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })
  ) {
    vErrors = vErrors === null ? validate55.errors : vErrors.concat(validate55.errors);
    errors = vErrors.length;
  }
  var valid0 = _errs1 === errors;
  if (valid0) {
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = true;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.type === undefined && (missing0 = 'type')) {
        const err0 = {};
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.type !== undefined) {
          if ('predict-output' !== data.type) {
            const err1 = {};
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      }
    }
    var _valid0 = _errs4 === errors;
    errors = _errs3;
    if (vErrors !== null) {
      if (_errs3) {
        vErrors.length = _errs3;
      } else {
        vErrors = null;
      }
    }
    if (_valid0) {
      const _errs6 = errors;
      if (
        !validate68(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
          dynamicAnchors,
        })
      ) {
        vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs6 === errors;
      valid1 = _valid0;
      if (valid1) {
        var props0 = {};
        props0.grading = true;
        props0.code = true;
        props0.stdin = true;
        props0.outcome = true;
        props0.expected = true;
        props0.choices = true;
        props0.type = true;
      }
    }
    if (!valid1) {
      const err2 = {
        instancePath,
        schemaPath: '#/allOf/1/if',
        keyword: 'if',
        params: { failingKeyword: 'then' },
        message: 'must match "then" schema',
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
      validate153.errors = vErrors;
      return false;
    }
    var valid0 = _errs2 === errors;
    if (valid0) {
      if (props0 !== true) {
        props0 = props0 || {};
        props0.id = true;
        props0.type = true;
        props0.unit = true;
        props0.stage = true;
        props0.title = true;
        props0.useCase = true;
        props0.textbook = true;
        props0.difficulty = true;
        props0.tags = true;
        props0.hints = true;
        props0.explanation = true;
        props0.formerIds = true;
        props0.draft = true;
        props0.order = true;
        props0.grading = true;
      }
      const _errs7 = errors;
      const _errs8 = errors;
      let valid3 = true;
      const _errs9 = errors;
      if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing1;
        if (data.type === undefined && (missing1 = 'type')) {
          const err3 = {};
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        } else {
          if (data.type !== undefined) {
            if ('fill-blank' !== data.type) {
              const err4 = {};
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
          }
        }
      }
      var _valid1 = _errs9 === errors;
      errors = _errs8;
      if (vErrors !== null) {
        if (_errs8) {
          vErrors.length = _errs8;
        } else {
          vErrors = null;
        }
      }
      if (_valid1) {
        const _errs11 = errors;
        if (
          !validate74(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
            dynamicAnchors,
          })
        ) {
          vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
          errors = vErrors.length;
        }
        var _valid1 = _errs11 === errors;
        valid3 = _valid1;
        if (valid3) {
          var props1 = {};
          props1.grading = true;
          props1.template = true;
          props1.blanks = true;
          props1.stdin = true;
          props1.expected = true;
          props1.type = true;
        }
      }
      if (!valid3) {
        const err5 = {
          instancePath,
          schemaPath: '#/allOf/2/if',
          keyword: 'if',
          params: { failingKeyword: 'then' },
          message: 'must match "then" schema',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
        validate153.errors = vErrors;
        return false;
      }
      var valid0 = _errs7 === errors;
      if (valid0) {
        if (props0 !== true && props1 !== undefined) {
          if (props1 === true) {
            props0 = true;
          } else {
            props0 = props0 || {};
            Object.assign(props0, props1);
          }
        }
        const _errs12 = errors;
        const _errs13 = errors;
        let valid5 = true;
        const _errs14 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
          let missing2;
          if (data.type === undefined && (missing2 = 'type')) {
            const err6 = {};
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          } else {
            if (data.type !== undefined) {
              if ('parsons' !== data.type) {
                const err7 = {};
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
          }
        }
        var _valid2 = _errs14 === errors;
        errors = _errs13;
        if (vErrors !== null) {
          if (_errs13) {
            vErrors.length = _errs13;
          } else {
            vErrors = null;
          }
        }
        if (_valid2) {
          const _errs16 = errors;
          if (
            !validate77(data, {
              instancePath,
              parentData,
              parentDataProperty,
              rootData,
              dynamicAnchors,
            })
          ) {
            vErrors = vErrors === null ? validate77.errors : vErrors.concat(validate77.errors);
            errors = vErrors.length;
          }
          var _valid2 = _errs16 === errors;
          valid5 = _valid2;
          if (valid5) {
            var props2 = {};
            props2.grading = true;
            props2.lines = true;
            props2.distractors = true;
            props2.alternatives = true;
            props2.stdin = true;
            props2.expected = true;
            props2.type = true;
          }
        }
        if (!valid5) {
          const err8 = {
            instancePath,
            schemaPath: '#/allOf/3/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema',
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
          validate153.errors = vErrors;
          return false;
        }
        var valid0 = _errs12 === errors;
        if (valid0) {
          if (props0 !== true && props2 !== undefined) {
            if (props2 === true) {
              props0 = true;
            } else {
              props0 = props0 || {};
              Object.assign(props0, props2);
            }
          }
          const _errs17 = errors;
          const _errs18 = errors;
          let valid7 = true;
          const _errs19 = errors;
          if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if (data.type === undefined && (missing3 = 'type')) {
              const err9 = {};
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            } else {
              if (data.type !== undefined) {
                if ('choice' !== data.type) {
                  const err10 = {};
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
              }
            }
          }
          var _valid3 = _errs19 === errors;
          errors = _errs18;
          if (vErrors !== null) {
            if (_errs18) {
              vErrors.length = _errs18;
            } else {
              vErrors = null;
            }
          }
          if (_valid3) {
            const _errs21 = errors;
            if (
              !validate80(data, {
                instancePath,
                parentData,
                parentDataProperty,
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate80.errors : vErrors.concat(validate80.errors);
              errors = vErrors.length;
            } else {
              var props3 = validate80.evaluated.props;
            }
            var _valid3 = _errs21 === errors;
            valid7 = _valid3;
            if (valid7) {
              if (props3 !== true) {
                props3 = props3 || {};
                props3.type = true;
              }
            }
          }
          if (!valid7) {
            const err11 = {
              instancePath,
              schemaPath: '#/allOf/4/if',
              keyword: 'if',
              params: { failingKeyword: 'then' },
              message: 'must match "then" schema',
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
            validate153.errors = vErrors;
            return false;
          }
          var valid0 = _errs17 === errors;
          if (valid0) {
            if (props0 !== true && props3 !== undefined) {
              if (props3 === true) {
                props0 = true;
              } else {
                props0 = props0 || {};
                Object.assign(props0, props3);
              }
            }
            const _errs22 = errors;
            const _errs23 = errors;
            let valid9 = true;
            const _errs24 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
              let missing4;
              if (data.type === undefined && (missing4 = 'type')) {
                const err12 = {};
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              } else {
                if (data.type !== undefined) {
                  if ('reduce' !== data.type) {
                    const err13 = {};
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                }
              }
            }
            var _valid4 = _errs24 === errors;
            errors = _errs23;
            if (vErrors !== null) {
              if (_errs23) {
                vErrors.length = _errs23;
              } else {
                vErrors = null;
              }
            }
            if (_valid4) {
              const _errs26 = errors;
              if (
                !validate90(data, {
                  instancePath,
                  parentData,
                  parentDataProperty,
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate90.errors : vErrors.concat(validate90.errors);
                errors = vErrors.length;
              }
              var _valid4 = _errs26 === errors;
              valid9 = _valid4;
              if (valid9) {
                var props4 = {};
                props4.grading = true;
                props4.problem = true;
                props4.constraints = true;
                props4.choices = true;
                props4.reason = true;
                props4.ops = true;
                props4.type = true;
              }
            }
            if (!valid9) {
              const err14 = {
                instancePath,
                schemaPath: '#/allOf/5/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema',
              };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
              validate153.errors = vErrors;
              return false;
            }
            var valid0 = _errs22 === errors;
            if (valid0) {
              if (props0 !== true && props4 !== undefined) {
                if (props4 === true) {
                  props0 = true;
                } else {
                  props0 = props0 || {};
                  Object.assign(props0, props4);
                }
              }
              const _errs27 = errors;
              const _errs28 = errors;
              let valid11 = true;
              const _errs29 = errors;
              if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing5;
                if (data.type === undefined && (missing5 = 'type')) {
                  const err15 = {};
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                } else {
                  if (data.type !== undefined) {
                    if ('complexity-quiz' !== data.type) {
                      const err16 = {};
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                    }
                  }
                }
              }
              var _valid5 = _errs29 === errors;
              errors = _errs28;
              if (vErrors !== null) {
                if (_errs28) {
                  vErrors.length = _errs28;
                } else {
                  vErrors = null;
                }
              }
              if (_valid5) {
                const _errs31 = errors;
                if (
                  !validate100(data, {
                    instancePath,
                    parentData,
                    parentDataProperty,
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
                  errors = vErrors.length;
                } else {
                  var props5 = validate100.evaluated.props;
                }
                var _valid5 = _errs31 === errors;
                valid11 = _valid5;
                if (valid11) {
                  if (props5 !== true) {
                    props5 = props5 || {};
                    props5.type = true;
                  }
                }
              }
              if (!valid11) {
                const err17 = {
                  instancePath,
                  schemaPath: '#/allOf/6/if',
                  keyword: 'if',
                  params: { failingKeyword: 'then' },
                  message: 'must match "then" schema',
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
                validate153.errors = vErrors;
                return false;
              }
              var valid0 = _errs27 === errors;
              if (valid0) {
                if (props0 !== true && props5 !== undefined) {
                  if (props5 === true) {
                    props0 = true;
                  } else {
                    props0 = props0 || {};
                    Object.assign(props0, props5);
                  }
                }
                const _errs32 = errors;
                const _errs33 = errors;
                let valid13 = true;
                const _errs34 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                  let missing6;
                  if (data.type === undefined && (missing6 = 'type')) {
                    const err18 = {};
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  } else {
                    if (data.type !== undefined) {
                      if ('write-ac' !== data.type) {
                        const err19 = {};
                        if (vErrors === null) {
                          vErrors = [err19];
                        } else {
                          vErrors.push(err19);
                        }
                        errors++;
                      }
                    }
                  }
                }
                var _valid6 = _errs34 === errors;
                errors = _errs33;
                if (vErrors !== null) {
                  if (_errs33) {
                    vErrors.length = _errs33;
                  } else {
                    vErrors = null;
                  }
                }
                if (_valid6) {
                  const _errs36 = errors;
                  if (
                    !validate106(data, {
                      instancePath,
                      parentData,
                      parentDataProperty,
                      rootData,
                      dynamicAnchors,
                    })
                  ) {
                    vErrors =
                      vErrors === null ? validate106.errors : vErrors.concat(validate106.errors);
                    errors = vErrors.length;
                  }
                  var _valid6 = _errs36 === errors;
                  valid13 = _valid6;
                  if (valid13) {
                    var props6 = {};
                    props6.grading = true;
                    props6.statement = true;
                    props6.starter = true;
                    props6.solution = true;
                    props6.cases = true;
                    props6.source = true;
                    props6.preflight = true;
                    props6.meter = true;
                    props6.type = true;
                  }
                }
                if (!valid13) {
                  const err20 = {
                    instancePath,
                    schemaPath: '#/allOf/7/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema',
                  };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                  validate153.errors = vErrors;
                  return false;
                }
                var valid0 = _errs32 === errors;
                if (valid0) {
                  if (props0 !== true && props6 !== undefined) {
                    if (props6 === true) {
                      props0 = true;
                    } else {
                      props0 = props0 || {};
                      Object.assign(props0, props6);
                    }
                  }
                  const _errs37 = errors;
                  const _errs38 = errors;
                  let valid15 = true;
                  const _errs39 = errors;
                  if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing7;
                    if (data.type === undefined && (missing7 = 'type')) {
                      const err21 = {};
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                    } else {
                      if (data.type !== undefined) {
                        if ('viz-step' !== data.type) {
                          const err22 = {};
                          if (vErrors === null) {
                            vErrors = [err22];
                          } else {
                            vErrors.push(err22);
                          }
                          errors++;
                        }
                      }
                    }
                  }
                  var _valid7 = _errs39 === errors;
                  errors = _errs38;
                  if (vErrors !== null) {
                    if (_errs38) {
                      vErrors.length = _errs38;
                    } else {
                      vErrors = null;
                    }
                  }
                  if (_valid7) {
                    const _errs41 = errors;
                    if (
                      !validate120(data, {
                        instancePath,
                        parentData,
                        parentDataProperty,
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
                      errors = vErrors.length;
                    }
                    var _valid7 = _errs41 === errors;
                    valid15 = _valid7;
                    if (valid15) {
                      var props7 = {};
                      props7.grading = true;
                      props7.code = true;
                      props7.stdin = true;
                      props7.frames = true;
                      props7.checkpoints = true;
                      props7.type = true;
                    }
                  }
                  if (!valid15) {
                    const err23 = {
                      instancePath,
                      schemaPath: '#/allOf/8/if',
                      keyword: 'if',
                      params: { failingKeyword: 'then' },
                      message: 'must match "then" schema',
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                    validate153.errors = vErrors;
                    return false;
                  }
                  var valid0 = _errs37 === errors;
                  if (valid0) {
                    if (props0 !== true && props7 !== undefined) {
                      if (props7 === true) {
                        props0 = true;
                      } else {
                        props0 = props0 || {};
                        Object.assign(props0, props7);
                      }
                    }
                    const _errs42 = errors;
                    const _errs43 = errors;
                    let valid17 = true;
                    const _errs44 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                      let missing8;
                      if (data.type === undefined && (missing8 = 'type')) {
                        const err24 = {};
                        if (vErrors === null) {
                          vErrors = [err24];
                        } else {
                          vErrors.push(err24);
                        }
                        errors++;
                      } else {
                        if (data.type !== undefined) {
                          if ('memo' !== data.type) {
                            const err25 = {};
                            if (vErrors === null) {
                              vErrors = [err25];
                            } else {
                              vErrors.push(err25);
                            }
                            errors++;
                          }
                        }
                      }
                    }
                    var _valid8 = _errs44 === errors;
                    errors = _errs43;
                    if (vErrors !== null) {
                      if (_errs43) {
                        vErrors.length = _errs43;
                      } else {
                        vErrors = null;
                      }
                    }
                    let ifClause0;
                    if (_valid8) {
                      const _errs46 = errors;
                      if (
                        !validate132(data, {
                          instancePath,
                          parentData,
                          parentDataProperty,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate132.errors
                            : vErrors.concat(validate132.errors);
                        errors = vErrors.length;
                      }
                      var _valid8 = _errs46 === errors;
                      valid17 = _valid8;
                      if (valid17) {
                        var props8 = {};
                        props8.grading = true;
                        props8.statement = true;
                        props8.snippet = true;
                        props8.stdin = true;
                        props8.expected = true;
                        props8.why = true;
                        props8.recall = true;
                        props8.type = true;
                      }
                      ifClause0 = 'then';
                    } else {
                      const _errs47 = errors;
                      if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing9;
                        if (
                          (data.textbook === undefined && (missing9 = 'textbook')) ||
                          (data.explanation === undefined && (missing9 = 'explanation'))
                        ) {
                          validate153.errors = [
                            {
                              instancePath,
                              schemaPath: '#/allOf/9/else/required',
                              keyword: 'required',
                              params: { missingProperty: missing9 },
                              message: "must have required property '" + missing9 + "'",
                            },
                          ];
                          return false;
                        }
                      }
                      var _valid8 = _errs47 === errors;
                      valid17 = _valid8;
                      ifClause0 = 'else';
                    }
                    if (!valid17) {
                      const err26 = {
                        instancePath,
                        schemaPath: '#/allOf/9/if',
                        keyword: 'if',
                        params: { failingKeyword: ifClause0 },
                        message: 'must match "' + ifClause0 + '" schema',
                      };
                      if (vErrors === null) {
                        vErrors = [err26];
                      } else {
                        vErrors.push(err26);
                      }
                      errors++;
                      validate153.errors = vErrors;
                      return false;
                    }
                    var valid0 = _errs42 === errors;
                    if (valid0) {
                      if (props0 !== true && props8 !== undefined) {
                        if (props8 === true) {
                          props0 = true;
                        } else {
                          props0 = props0 || {};
                          Object.assign(props0, props8);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (props0 !== true) {
        for (const key0 in data) {
          if (!props0 || !props0[key0]) {
            validate153.errors = [
              {
                instancePath,
                schemaPath: '#/unevaluatedProperties',
                keyword: 'unevaluatedProperties',
                params: { unevaluatedProperty: key0 },
                message: 'must NOT have unevaluated properties',
              },
            ];
            return false;
            break;
          }
        }
      }
    } else {
      validate153.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate153.errors = vErrors;
  return errors === 0;
}
validate153.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
